import * as React from 'react';
import React__default, { useMemo as useMemo$1, useCallback, createElement, useRef, useState, useEffect, createContext, useContext, Fragment, isValidElement, cloneElement } from 'react';
import { Close, CheckOutlined, ReportProblemOutlined, ErrorOutline, InfoOutlined, AccountCircle, Menu as Menu$3, Dashboard, ChevronLeft, PowerSettingsNew, ArrowBack, Create as Create$2, Visibility, GetApp, VpnKey, Email, Drafts, RotateLeft, DoubleArrow, ArrowForwardIos, Warning, ExpandLess, ExpandMore, ArrowDropDown, Inbox, TableChart } from '@material-ui/icons';
import { withStyles, darken, lighten, makeStyles, createStyles, createTheme, useTheme } from '@material-ui/core/styles';
import { Paper, IconButton, Typography, Menu as Menu$2, useMediaQuery, AppBar as AppBar$1, Toolbar as Toolbar$2, Badge as Badge$1, Box, makeStyles as makeStyles$1, List as List$1, ListSubheader, Divider, ListItem, ListItemIcon, ListItemText, Drawer, CssBaseline, MenuItem as MenuItem$1, Link as Link$1, Button as Button$1, LinearProgress, FormHelperText, Chip, Tab, Grid, ListItemAvatar, Avatar, CircularProgress, Collapse, TextField as TextField$1, InputAdornment, Dialog, DialogTitle, DialogContent, DialogContentText, FormControlLabel, Switch, DialogActions, ThemeProvider as ThemeProvider$1, Stepper, Step, StepLabel, StepContent } from '@material-ui/core';
import PropTypes from 'prop-types';
import { capitalize, unstable_useId, useControlled, useEventCallback, setRef } from '@material-ui/core/utils';
import clsx from 'clsx';
import { useTranslate as useTranslate$1, useGetIdentity, LoadingIndicator, getResources as getResources$2, defaultTheme, Notification, Button, DeleteWithConfirmButton as DeleteWithConfirmButton$1, EditButton as EditButton$1, useRefresh, useNotify as useNotify$1, useUnselectAll, useUpdateMany, useMutation, Confirm, SaveButton, DeleteButton, ArrayField, SingleFieldList, ChipField, ImageField, DateField, Datagrid as Datagrid$1, useListPaginationContext, Pagination as Pagination$1, SimpleList as SimpleList$1, TopToolbar, useInput, ReferenceManyField, Labeled, TextField, BooleanField, EmailField, FormInput, Toolbar as Toolbar$3, InputHelperText, FieldTitle, SelectInput, useListContext, DateInput, ImageInput as ImageInput$1, useDataProvider as useDataProvider$1, FileInput, ReferenceInput, ReferenceArrayInput, CheckboxGroupInput, SelectArrayInput, useUpdate, BooleanInput, NullableBooleanInput, NumberInput, SearchInput, TextInput, TabbedForm as TabbedForm$1, FormTab as FormTab$1, Loading, SimpleForm, Create as Create$3, Edit, FilterContext, FilterButton, CreateButton, ExportButton as ExportButton$1, BulkDeleteButton, downloadCSV, List as List$2, Filter, Resource, LoginForm, Login, useRedirect as useRedirect$1, resolveBrowserLocale, useLocale as useLocale$1 } from 'react-admin';
export { BooleanField, BooleanInput, ChipField, DateField, DateInput, DeleteButton, EmailField, NullableBooleanInput, NumberInput, DeleteButton as RaDeleteButton, EditButton as RaEditButton, SaveButton, SearchInput, SelectInput, TextField, TextInput } from 'react-admin';
import { useAuthProvider as useAuthProvider$1, useRedirect, useNotify, toggleSidebar, usePermissions as usePermissions$1, useTranslate as useTranslate$2, useGetIdentity as useGetIdentity$1, useSafeSetState, useLocale, useFormContext, useFormGroup, FormGroupContextProvider, useFormGroupContext, maxLength, FieldTitle as FieldTitle$1, useMutation as useMutation$1, useRefresh as useRefresh$1, useListContext as useListContext$1, useResourceContext, useResourceDefinition, sanitizeListRestProps, useGetResourceLabel, required, email, FormDataConsumer, useInput as useInput$1, useDataProvider as useDataProvider$2, HttpError } from 'ra-core';
import classnames from 'classnames';
import { useDispatch, useSelector as useSelector$1, connect } from 'react-redux';
import { Link, withRouter, useHistory, useLocation } from 'react-router-dom';
import { get as get$1, set } from 'lodash';
import { ThemeProvider } from '@material-ui/styles';
import moment from 'moment';
import { useForm, useFormState, Form as Form$1, Field } from 'react-final-form';
import { FileField, InputHelperText as InputHelperText$1, Notification as Notification$1, TextInput as TextInput$1, DateInput as DateInput$1 } from 'ra-ui-materialui';
import { ErrorBoundary } from 'react-error-boundary';
import { stringify } from 'query-string';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Chip$1 from '@material-ui/core/Chip';
import CloseIcon from '@material-ui/icons/Close';
import IconButton$1 from '@material-ui/core/IconButton';
import ListSubheader$1 from '@material-ui/core/ListSubheader';
import Paper$1 from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import Typography$1 from '@material-ui/core/Typography';
import RefreshIcon from '@material-ui/icons/Refresh';
import jsonExport from 'jsonexport/dist';
import polyglotI18nProvider from 'ra-i18n-polyglot';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _excluded$_ = ["action", "children", "classes", "className", "closeText", "color", "icon", "iconMapping", "onClose", "role", "severity", "variant", "elevation"];
var styles$4 = function styles(theme) {
  var getColor = theme.palette.type === "light" ? darken : lighten;
  var getBackgroundColor = theme.palette.type === "light" ? lighten : darken;
  return {
    /* Styles applied to the root element. */
    root: _objectSpread2(_objectSpread2({}, theme.typography.body2), {}, {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: "transparent",
      display: "flex",
      padding: "6px 16px"
    }),

    /* Styles applied to the root element if `variant="standard"` and `color="success"`. */
    standardSuccess: {
      color: getColor(theme.palette.success.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.success.main, 0.9),
      "& $icon": {
        color: theme.palette.success.main
      }
    },

    /* Styles applied to the root element if `variant="standard"` and `color="info"`. */
    standardInfo: {
      color: getColor(theme.palette.info.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.info.main, 0.9),
      "& $icon": {
        color: theme.palette.info.main
      }
    },

    /* Styles applied to the root element if `variant="standard"` and `color="warning"`. */
    standardWarning: {
      color: getColor(theme.palette.warning.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.warning.main, 0.9),
      "& $icon": {
        color: theme.palette.warning.main
      }
    },

    /* Styles applied to the root element if `variant="standard"` and `color="error"`. */
    standardError: {
      color: getColor(theme.palette.error.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.error.main, 0.9),
      "& $icon": {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="success"`. */
    outlinedSuccess: {
      color: getColor(theme.palette.success.main, 0.6),
      border: "1px solid ".concat(theme.palette.success.main),
      "& $icon": {
        color: theme.palette.success.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="info"`. */
    outlinedInfo: {
      color: getColor(theme.palette.info.main, 0.6),
      border: "1px solid ".concat(theme.palette.info.main),
      "& $icon": {
        color: theme.palette.info.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="warning"`. */
    outlinedWarning: {
      color: getColor(theme.palette.warning.main, 0.6),
      border: "1px solid ".concat(theme.palette.warning.main),
      "& $icon": {
        color: theme.palette.warning.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="error"`. */
    outlinedError: {
      color: getColor(theme.palette.error.main, 0.6),
      border: "1px solid ".concat(theme.palette.error.main),
      "& $icon": {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `variant="filled"` and `color="success"`. */
    filledSuccess: {
      color: "#fff",
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.success.main
    },

    /* Styles applied to the root element if `variant="filled"` and `color="info"`. */
    filledInfo: {
      color: "#fff",
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.info.main
    },

    /* Styles applied to the root element if `variant="filled"` and `color="warning"`. */
    filledWarning: {
      color: "#fff",
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.warning.main
    },

    /* Styles applied to the root element if `variant="filled"` and `color="error"`. */
    filledError: {
      color: "#fff",
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.error.main
    },

    /* Styles applied to the icon wrapper element. */
    icon: {
      marginRight: 12,
      padding: "7px 0",
      display: "flex",
      fontSize: 22,
      opacity: 0.9
    },

    /* Styles applied to the message wrapper element. */
    message: {
      padding: "8px 0"
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: "flex",
      alignItems: "center",
      marginLeft: "auto",
      paddingLeft: 16,
      marginRight: -8
    }
  };
};
var defaultIconMapping = {
  success: /*#__PURE__*/React.createElement(CheckOutlined, {
    fontSize: "inherit"
  }),
  warning: /*#__PURE__*/React.createElement(ReportProblemOutlined, {
    fontSize: "inherit"
  }),
  error: /*#__PURE__*/React.createElement(ErrorOutline, {
    fontSize: "inherit"
  }),
  info: /*#__PURE__*/React.createElement(InfoOutlined, {
    fontSize: "inherit"
  })
};
var Alert = /*#__PURE__*/React.forwardRef(function Alert(props, ref) {
  var action = props.action,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$closeText = props.closeText,
      closeText = _props$closeText === void 0 ? "Close" : _props$closeText,
      color = props.color,
      icon = props.icon,
      _props$iconMapping = props.iconMapping,
      iconMapping = _props$iconMapping === void 0 ? defaultIconMapping : _props$iconMapping,
      onClose = props.onClose,
      _props$role = props.role,
      role = _props$role === void 0 ? "alert" : _props$role,
      _props$severity = props.severity,
      severity = _props$severity === void 0 ? "success" : _props$severity,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? "standard" : _props$variant,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 0 : _props$elevation,
      other = _objectWithoutProperties(props, _excluded$_);

  return /*#__PURE__*/React.createElement(Paper, _extends({
    role: role,
    square: true,
    elevation: elevation,
    className: clsx(classes.root, classes["".concat(variant).concat(capitalize(color || severity))], className),
    ref: ref
  }, other), icon !== false ? /*#__PURE__*/React.createElement("div", {
    className: classes.icon
  }, icon || iconMapping[severity] || defaultIconMapping[severity]) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.message
  }, children), action != null ? /*#__PURE__*/React.createElement("div", {
    className: classes.action
  }, action) : null, action == null && onClose ? /*#__PURE__*/React.createElement("div", {
    className: classes.action
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    "aria-label": closeText,
    title: closeText,
    color: "inherit",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Close, {
    fontSize: "small"
  }))) : null);
});
Alert.propTypes = {
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: PropTypes.node,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  closeText: PropTypes.string,

  /**
   * The main color for the alert. Unless provided, the value is taken from the `severity` prop.
   */
  color: PropTypes.oneOf(["error", "info", "success", "warning"]),

  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   */
  icon: PropTypes.node,

  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: PropTypes.shape({
    error: PropTypes.node,
    info: PropTypes.node,
    success: PropTypes.node,
    warning: PropTypes.node
  }),

  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * The ARIA role attribute of the element.
   */
  role: PropTypes.string,

  /**
   * The severity of the alert. This defines the color and icon used.
   */
  severity: PropTypes.oneOf(["error", "info", "success", "warning"]),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
};
var Alert$1 = withStyles(styles$4, {
  name: "MuiAlert"
})(Alert);

var _excluded$Z = ["classes", "className"];
var styles$3 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      fontWeight: theme.typography.fontWeightMedium,
      marginTop: -2
    }
  };
};
var AlertTitle = /*#__PURE__*/React.forwardRef(function AlertTitle(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = _objectWithoutProperties(props, _excluded$Z);

  return /*#__PURE__*/React.createElement(Typography, _extends({
    gutterBottom: true,
    component: "div",
    ref: ref,
    className: clsx(classes.root, className)
  }, other));
});
AlertTitle.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string
};
var AlertTitle$1 = withStyles(styles$3, {
  name: "MuiAlertTitle"
})(AlertTitle);

function useRoles() {
  var roles = JSON.parse(localStorage.getItem("roles") || "[]") || [];
  return roles;
}
function notifyToken(token) {
  var event = new Event("login");
  event.key = "token";
  event.value = token;
  document.dispatchEvent(event);
}
function getHeaders() {
  var token = localStorage.getItem("token");
  var headers = new Headers({
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: "Bearer ".concat(token)
  });
  return headers;
}
function getToken() {
  return localStorage.getItem("token");
}
function useToken() {
  var token = getToken();
  var headers = getHeaders();
  var headersMemo = useMemo$1(function () {
    return headers;
  }, [headers]);
  return {
    token: token,
    headers: headersMemo
  };
}

var clearAuth = function clearAuth() {
  ["token", "roles", "username", "profile", "email"].forEach(function (param) {
    localStorage.removeItem("admin_".concat(param));
    localStorage.removeItem(param);
  });
};
var validateJson = function validateJson(data) {
  var _data$data;

  if (!(data !== null && data !== void 0 && data.success) && (data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 401) {
    clearAuth();
    document.location.reload();
  }

  return data;
};
var useIsImpersonating = function useIsImpersonating() {
  var impersonate = localStorage.getItem("impersonate");
  return impersonate === "true";
};
var useDoImpersonate = function useDoImpersonate(id) {
  var authProvider = useAuthProvider$1();
  var redirect = useRedirect();
  var notify = useNotify();
  var handle = useCallback(function () {
    return authProvider.impersonate(id).then(function () {
      notify("ra.auth.sign_in_success", "info");
      redirect("/");
      setTimeout(function () {
        return window.location.reload();
      }, 1000);
    }).catch(function () {
      notify("ra.auth.sign_in_error", "warning");
    });
  }, [authProvider, notify, redirect, id]);
  return handle;
};
var useUndoImpersonate = function useUndoImpersonate() {
  var authProvider = useAuthProvider$1();
  var redirect = useRedirect();
  var notify = useNotify();
  var handleImpersonateLogout = useCallback(function () {
    return authProvider.stopImpersonate().then(function () {
      redirect("/");
      notify("ra.auth.sign_out_success", "info");
      setTimeout(function () {
        return document.location.reload();
      }, 1000);
    }).catch(function (error) {
      return notify(error, "warning");
    });
  }, [authProvider, redirect, notify]);
  return handleImpersonateLogout;
};

var createAuthProvider = function createAuthProvider(_ref) {
  var apiUrl = _ref.apiUrl;
  return {
    login: function login(params) {
      var username = params.username,
          password = params.password;
      var requestURL = "".concat(apiUrl, "/users/login");
      var request = new Request(requestURL, {
        method: "POST",
        body: JSON.stringify({
          username: username,
          password: password
        }),
        headers: new Headers({
          "Content-Type": "application/json",
          Accept: "application/json"
        })
      });
      return fetch(request).then(function (response) {
        return response.json();
      }).then(function (_ref2) {
        var data = _ref2.data,
            success = _ref2.success;

        if (!success) {
          throw new Error(data.message);
        }

        localStorage.setItem("email", data.email);
        localStorage.setItem("token", data.token);
        localStorage.setItem("roles", JSON.stringify(data.roles));
        localStorage.setItem("profile", JSON.stringify(data.profile));
        notifyToken(data.token);
      });
    },
    logout: function logout() {
      clearAuth();
      return Promise.resolve();
    },
    checkAuth: function checkAuth() {
      return localStorage.getItem("token") ? Promise.resolve() : Promise.reject();
    },
    checkError: function checkError(error) {
      if (error.status === 401 || error.status === 500) {
        return Promise.reject(error === null || error === void 0 ? void 0 : error.message);
      }

      return Promise.resolve();
    },
    getPermissions: function getPermissions() {
      var roles = JSON.parse(localStorage.getItem("roles"));
      return Promise.resolve(function (v) {
        return roles && roles.some(function (r) {
          return v.includes(r.code);
        });
      });
    },
    getIdentity: function getIdentity() {
      var profile = JSON.parse(localStorage.getItem("profile"));
      var roles = JSON.parse(localStorage.getItem("roles"));
      var email = localStorage.getItem("email");
      return Promise.resolve(_objectSpread2(_objectSpread2({}, profile), {}, {
        roles: roles,
        email: email
      }));
    },
    impersonate: function impersonate(id) {
      var requestURL = "".concat(apiUrl, "/users/impersonate/?id=").concat(id);
      var request = new Request(requestURL, {
        method: "POST",
        headers: getHeaders()
      });
      return fetch(request).then(function (response) {
        return response.json();
      }).then(function (_ref3) {
        var success = _ref3.success,
            data = _ref3.data;

        if (!success) {
          throw new Error(data.message);
        }

        ["token", "roles", "username", "profile", "email"].forEach(function (param) {
          var toSaveParam = "admin_".concat(param);
          localStorage.setItem(toSaveParam, localStorage.getItem(param));
          localStorage.setItem(param, ["profile", "roles"].indexOf(param) !== -1 ? JSON.stringify(data[param]) : data[param]);
        });
        localStorage.setItem("impersonate", true);
      });
    },
    stopImpersonate: function stopImpersonate() {
      ["token", "roles", "username", "profile", "email"].forEach(function (param) {
        var savedParam = "admin_".concat(param);
        localStorage.setItem(param, localStorage.getItem(savedParam));
        localStorage.removeItem(savedParam);
      });
      localStorage.setItem("impersonate", false);
      return Promise.resolve();
    }
  };
};

var UserMenu = function UserMenu(_ref) {
  var logout = _ref.logout,
      children = _ref.children;

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var open = Boolean(anchorEl);

  var handleMenu = function handleMenu(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: handleMenu,
    color: "inherit"
  }, /*#__PURE__*/React__default.createElement(AccountCircle, null)), /*#__PURE__*/React__default.createElement(Menu$2, {
    id: "menu-appbar",
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    keepMounted: true,
    transformOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    open: open,
    onClose: handleClose
  }, !children && logout, React__default.Children.map(children, function (child) {
    return child !== logout ? /*#__PURE__*/React__default.cloneElement(child, {
      onClick: handleClose
    }) : logout;
  })));
};

UserMenu.propTypes = {
  logout: PropTypes.element.isRequired
};

var useStyles$B = makeStyles(function (theme) {
  return {
    title: {
      flexGrow: 1
    },
    titleSidebarClose: {
      marginLeft: theme.spacing(2)
    },
    appBar: {
      flexGrow: 1,
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
    },
    appBarShift: function appBarShift(_ref) {
      var drawerWidth = _ref.drawerWidth;
      return {
        marginLeft: drawerWidth,
        width: "calc(100% - ".concat(drawerWidth - 2, "px)"),
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen
        })
      };
    },
    menuButton: _defineProperty({
      marginRight: theme.spacing(2),
      marginLeft: -20
    }, theme.breakpoints.down("sm"), {
      marginRight: theme.spacing(0)
    }),
    hide: {
      display: "none"
    },
    spacer: {
      flex: 1,
      flexGrow: 1
    },
    welcome: {
      lineHeight: "1.2em"
    },
    undoImpersonate: {
      display: "block",
      clear: "both",
      marginTop: -theme.spacing(0.5),
      fontSize: 12,
      cursor: "pointer",
      "&:hover": {
        textDecoration: "underline"
      }
    }
  };
});

var AppBar = function AppBar(_ref2) {
  var open = _ref2.open,
      logout = _ref2.logout,
      drawerWidth = _ref2.drawerWidth,
      location = _ref2.location,
      _ref2$userMenu = _ref2.userMenu,
      userMenu = _ref2$userMenu === void 0 ? UserMenu : _ref2$userMenu;
  var classes = useStyles$B({
    drawerWidth: drawerWidth
  });
  var dispatch = useDispatch();
  var translate = useTranslate$1();
  var isImpersonating = useIsImpersonating();
  var undoImpersonate = useUndoImpersonate();
  var handleUndoClick = useCallback(function (e) {
    e.stopPropagation();
    e.preventDefault();
    undoImpersonate();
  }, [undoImpersonate]);
  var isXSmall = useMediaQuery(function (theme) {
    return theme.breakpoints.down("xs");
  });

  var _useGetIdentity = useGetIdentity(),
      identity = _useGetIdentity.identity;

  var handleToggleSidebar = useCallback(function () {
    return dispatch(toggleSidebar());
  }, [dispatch]);
  return /*#__PURE__*/React__default.createElement(AppBar$1, {
    position: "fixed",
    color: "secondary",
    className: classnames(classes.appBar, _defineProperty({}, classes.appBarShift, open && !isXSmall))
  }, /*#__PURE__*/React__default.createElement(Toolbar$2, null, /*#__PURE__*/React__default.createElement(IconButton, {
    color: "inherit",
    "aria-label": "open drawer",
    onClick: handleToggleSidebar,
    edge: "start",
    className: classnames(classes.menuButton, _defineProperty({}, classes.hide, open && !isXSmall))
  }, /*#__PURE__*/React__default.createElement(Menu$3, null)), /*#__PURE__*/React__default.createElement(Typography, {
    className: classnames(classes.title, _defineProperty({}, classes.titleSidebarClose, !open)),
    variant: "h6",
    id: "react-admin-title",
    noWrap: true
  }), !isXSmall && /*#__PURE__*/React__default.createElement("div", {
    className: classes.spacer
  }), !isXSmall && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    component: "div",
    className: classes.welcome
  }, translate("app.welcome", identity), isImpersonating && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    display: "block",
    onClick: handleUndoClick,
    className: classes.undoImpersonate
  }, translate("ra.auth.impersonating.undo", identity))), /*#__PURE__*/React__default.createElement(LoadingIndicator, null), /*#__PURE__*/React__default.createElement(userMenu, {
    logout: logout,
    location: location
  })));
};

AppBar.propTypes = {
  open: PropTypes.bool.isRequired,
  logout: PropTypes.element.isRequired,
  drawerWidth: PropTypes.number.isRequired,
  userMenu: PropTypes.elementType
};

var _excluded$Y = ["titleAccess", "children"];

var Badge = function Badge(_ref) {
  _ref.titleAccess;
      var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$Y);

  return /*#__PURE__*/React__default.createElement(Badge$1, props, children);
};

var useStyles$A = makeStyles(function (theme) {
  return {
    root: {
      flexGrow: 1,
      flexDirection: "row",
      alignItems: "center"
    },
    logo: {
      marginLeft: -theme.spacing(1)
    },
    brand: {},
    title: {
      fontWeight: "bold",
      color: theme.palette.text.primary,
      marginBottom: theme.spacing(-0.5),
      "&:hover": {
        color: theme.palette.primary.main
      }
    }
  };
});
/**
 * @description The brand component renders a custom top-left brand with logo, title and subtitle.
 *
 * @param {Object} props
 * @param {String} props.title The title of the brand.
 * @param {String} props.subTitle The subtitle of the brand.
 * @param {String} props.logo The logo of the brand.
 */

var Brand = function Brand(_ref) {
  var _ref$logo = _ref.logo,
      logo = _ref$logo === void 0 ? undefined : _ref$logo,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? undefined : _ref$title,
      _ref$subTitle = _ref.subTitle,
      subTitle = _ref$subTitle === void 0 ? undefined : _ref$subTitle;
  var classes = useStyles$A();
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.root
  }, logo ? /*#__PURE__*/React__default.isValidElement(logo) ? /*#__PURE__*/React__default.createElement(Box, {
    className: classes.logo
  }, logo) : /*#__PURE__*/React__default.createElement(Box, {
    component: "img",
    sx: {
      height: 64
    },
    alt: title,
    src: logo
  }) : null, /*#__PURE__*/React__default.createElement("div", {
    className: classes.brand
  }, title ? /*#__PURE__*/React__default.isValidElement(title) ? title : /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.title,
    href: "/",
    variant: "h6",
    color: "inherit"
  }, title) : null, subTitle ? /*#__PURE__*/React__default.isValidElement(subTitle) ? subTitle : /*#__PURE__*/React__default.createElement(Typography, {
    color: "textSecondary",
    variant: "caption"
  }, subTitle) : null));
};

Brand.propTypes = {
  logo: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

var _excluded$X = ["children", "open", "label"];
var useStyles$z = makeStyles$1(function (theme) {
  return {
    subHeader: {
      backgroundColor: theme.palette.background.paper,
      zIndex: theme.zIndex.appBar,
      fontWeight: "bold",
      color: theme.palette.text.primary
    }
  };
});

var MenuGroup = function MenuGroup(_ref) {
  var children = _ref.children,
      open = _ref.open,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, _excluded$X);

  var classes = useStyles$z();
  return /*#__PURE__*/React__default.createElement(List$1, {
    subheader: open ? /*#__PURE__*/React__default.createElement(ListSubheader, {
      className: classes.subHeader
    }, label) : null
  }, React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.isValidElement(child) && /*#__PURE__*/React__default.cloneElement(child, _objectSpread2({
      open: open
    }, props));
  }), /*#__PURE__*/React__default.createElement(Divider, null));
};

MenuGroup.propTypes = {
  /** Children to render inside the MenuGroup */
  children: PropTypes.node,

  /** Indicates if sidebar is open or not. */
  open: PropTypes.bool,

  /** Label to use for this group. */
  label: PropTypes.string.isRequired,

  /** Name of the groups to merge. */
  group: PropTypes.string
};

var _excluded$W = ["location", "badge", "to", "icon", "label", "sub", "onMenuClick", "permissions", "open", "localize"];

var isSelected = function isSelected(location, to) {
  var selected = location.pathname === to || location.pathname.indexOf("".concat(to, "?")) === 0 || location.pathname.indexOf("".concat(to, "/")) === 0;
  return selected;
};

var MenuItem = function MenuItem(_ref) {
  var location = _ref.location,
      badge = _ref.badge,
      to = _ref.to,
      icon = _ref.icon,
      label = _ref.label,
      sub = _ref.sub,
      onMenuClick = _ref.onMenuClick;
      _ref.permissions;
      var open = _ref.open;
      _ref.localize;
      var props = _objectWithoutProperties(_ref, _excluded$W);

  return /*#__PURE__*/React__default.createElement(ListItem, _extends({}, props, {
    button: true,
    component: props.href ? "a" : Link,
    to: to,
    onClick: onMenuClick,
    selected: isSelected(location, to)
  }), /*#__PURE__*/React__default.createElement(ListItemIcon, null, badge && badge.show !== false ? /*#__PURE__*/React__default.createElement(Badge, {
    color: badge.color,
    variant: badge.variant,
    badgeContent: badge.value,
    overlap: "rectangular"
  }, /*#__PURE__*/createElement(icon)) : /*#__PURE__*/createElement(icon)), open && /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: label,
    secondary: sub,
    primaryTypographyProps: {
      style: {
        whiteSpace: "normal"
      }
    },
    secondaryTypographyProps: {
      style: {
        whiteSpace: "normal"
      }
    }
  }));
};

MenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  to: PropTypes.string,
  href: PropTypes.string,
  badge: PropTypes.shape({
    show: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    variant: PropTypes.oneOf(["standard", "dot", "dot-small"]),
    color: PropTypes.oneOf(["default", "primary", "secondary", "error"])
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }),
  onMenuClick: PropTypes.func
};

var compose = function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return function (Comp) {
    return funcs.reduceRight(function (prev, curr) {
      return curr(prev);
    }, Comp);
  };
};

var createMenuItem = function createMenuItem(item, badges, translate) {
  var _item$options, _item$options2;

  return {
    localize: item.options.localize,
    badge: get$1(badges, "".concat(item.name), null),
    order: get$1(item, "options.order", 0),
    label: (item === null || item === void 0 ? void 0 : (_item$options = item.options) === null || _item$options === void 0 ? void 0 : _item$options.localize) === false ? item.name : translate("menu.items.".concat(item.name)),
    icon: item.icon,
    sub: ((_item$options2 = item.options) === null || _item$options2 === void 0 ? void 0 : _item$options2.sub) || item.sub,
    to: item.path || "/".concat(item.name)
  };
};

var createGroups = function createGroups(_ref) {
  var order = _ref.order,
      resources = _ref.resources,
      permissions = _ref.permissions,
      badges = _ref.badges,
      hasDashboard = _ref.hasDashboard,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      translate = _ref.translate,
      identity = _ref.identity;
  var groups = (hasDashboard ? [{
    path: "/",
    name: "dashboard",
    icon: Dashboard,
    options: {
      group: translate("menu.groups.dashboard")
    }
  }] : []).concat(resources.filter(function (r) {
    return r.hasList && r.options && r.icon;
  })).concat(items.map(function (i) {
    return _objectSpread2(_objectSpread2({}, i), {}, {
      options: {
        roles: i.roles,
        group: i.group,
        localize: i.localize
      }
    });
  })).filter(function (item) {
    return item.options.accessible ? item.options.accessible(identity, permissions) : permissions && (item.options.roles === undefined || item.options.roles.filter(function (role) {
      return permissions(role);
    }).length > 0);
  }).reduce(function (groups, resource) {
    var groupName = resource.options ? resource.options.group : "";
    var group = groups.find(function (g) {
      return g.label === groupName;
    });

    if (group) {
      group.items.push(createMenuItem(resource, badges, translate));
      group.items.sort(function (a, b) {
        return a.order > b.order ? 1 : a.order < b.order ? -1 : 0;
      });
    } else {
      group = {
        label: groupName,
        items: [createMenuItem(resource, badges, translate)],
        order: get$1(order, groupName, 1000)
      };
      groups.push(group);
    }

    return groups;
  }, []);
  groups.sort(function (a, b) {
    return a.order > b.order ? 1 : a.order < b.order ? -1 : 0;
  });
  return groups;
};

var _require$1 = require("ra-core"),
    usePermissions = _require$1.usePermissions,
    getResources$1 = _require$1.getResources,
    useTranslate = _require$1.useTranslate;

var _require2$1 = require("react"),
    useMemo = _require2$1.useMemo;

var _require3$1 = require("react-redux"),
    shallowEqual$1 = _require3$1.shallowEqual;

var useMenu = function useMenu(_ref) {
  var order = _ref.order,
      hasDashboard = _ref.hasDashboard,
      badges = _ref.badges,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      identity = _ref.identity;
  var translate = useTranslate();

  var _usePermissions = usePermissions(),
      loaded = _usePermissions.loaded,
      permissions = _usePermissions.permissions;

  var resources = useSelector$1(getResources$1, shallowEqual$1);
  var menu = useMemo(function () {
    return loaded ? createGroups({
      order: order,
      resources: resources,
      permissions: permissions,
      badges: badges,
      hasDashboard: hasDashboard,
      items: items,
      translate: translate,
      identity: identity
    }) : [];
  }, [order, resources, permissions, badges, loaded, hasDashboard, items, translate]);
  return menu;
};

var Menu = function Menu(_ref) {
  var hasDashboard = _ref.hasDashboard,
      open = _ref.open,
      location = _ref.location,
      onMenuClick = _ref.onMenuClick,
      badges = _ref.badges,
      items = _ref.items,
      children = _ref.children,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? "build" : _ref$mode,
      order = _ref.order;

  var _useGetIdentity = useGetIdentity(),
      loading = _useGetIdentity.loading,
      loaded = _useGetIdentity.loaded,
      identity = _useGetIdentity.identity;

  var _usePermissions = usePermissions$1(),
      permissions = _usePermissions.permissions;

  var menu = useMenu({
    order: order,
    hasDashboard: hasDashboard,
    badges: badges,
    items: items,
    identity: identity
  });
  var translate = useTranslate$1();

  if (loading || !loaded || !identity || identity === null || identity.id <= 0) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(List$1, {
    component: "nav"
  }, mode === "build" && menu.map(function (group, idx) {
    return /*#__PURE__*/React__default.createElement(MenuGroup, {
      key: idx,
      open: open,
      label: translate("menu.groups.".concat(group.label))
    }, group.items.map(function (item, index) {
      return /*#__PURE__*/React__default.createElement(MenuItem, _extends({}, item, {
        key: index,
        open: open,
        location: location,
        onMenuClick: onMenuClick
      }));
    }));
  }), React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.isValidElement(child) && /*#__PURE__*/React__default.cloneElement(child, {
      open: open,
      menu: menu,
      location: location,
      permissions: permissions,
      onMenuClick: onMenuClick
    });
  }));
};

Menu.propTypes = {
  hasDashboard: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  onMenuClick: PropTypes.func,

  /** List of custom menu items that will be merged with existing menu. */
  items: PropTypes.arrayOf(PropTypes.shape({
    /** Name of the menu item. */
    name: PropTypes.string.isRequired,

    /** Icon used for this menu item. */
    icon: PropTypes.elementType.isRequired,

    /** Path connected to the routing system (ex. /posts). */
    path: PropTypes.string,

    /** List of roles allowed. */
    roles: PropTypes.arrayOf(PropTypes.string)
  })),

  /**
   * Indicates generation mode for menu. If you want to compose it use custom
   * and create your own menu using MenuGroup and MenuItems.
   **/
  mode: PropTypes.oneOf(["build", "custom"]),

  /** Allows configuration of groups */
  order: PropTypes.object,

  /** Badges config. */
  badges: PropTypes.objectOf(PropTypes.shape({
    show: PropTypes.bool,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.oneOf(["primary", "secondary", "default", "error"])
  }))
};
var Menu$1 = compose(withRouter, connect(function (state) {
  return {
    open: state.admin.ui.sidebarOpen,
    resources: getResources$2(state)
  };
}))(Menu);

var useStyles$y = makeStyles$1(function (theme) {
  return {
    brand: {
      paddingLeft: theme.spacing(1),
      display: "flex",
      flexGrow: 1,
      flex: 1,
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "center"
    },
    drawer: {
      zIndex: 10,
      flexShrink: 0,
      whiteSpace: "nowrap"
    },
    drawerOpen: function drawerOpen(_ref) {
      var drawerWidth = _ref.drawerWidth;
      return {
        width: drawerWidth - 1,
        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen
        })
      };
    },
    drawerClose: _defineProperty({
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      overflowX: "hidden",
      width: theme.spacing(7) + 1
    }, theme.breakpoints.up("sm"), {
      width: theme.spacing(7) + 1
    }),
    toolbar: _objectSpread2({
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1)
    }, theme.mixins.toolbar),
    undoImpersonate: {
      display: "block",
      clear: "both",
      marginTop: -theme.spacing(0.5),
      fontSize: 12,
      cursor: "pointer",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: theme.palette.secondary,
      "&:hover": {
        textDecoration: "underline",
        color: theme.palette.primary.main
      }
    }
  };
});
/**
 * The Sidebar renders custom sidebar using drawer component.
 * @param {Object} props
 * @param {String} props.title Title to display
 * @param {String} props.subTitle Subtitle to display
 * @param {String} props.logo Logo to display
 * @param {String} props.menu Menu to display
 * @param {String} props.appBar AppBar to display
 * @param {Element} props.brand Brand to display, if you pass brand it will override title, subTitle and logo
 * @returns
 */

var Sidebar = function Sidebar(_ref2) {
  var _classnames, _classnames2;

  var children = _ref2.children,
      open = _ref2.open,
      logo = _ref2.logo,
      drawerWidth = _ref2.drawerWidth,
      title = _ref2.title,
      subTitle = _ref2.subTitle,
      brand = _ref2.brand;
  var classes = useStyles$y({
    drawerWidth: drawerWidth
  });
  var dispatch = useDispatch();
  var handleToggleSidebar = useCallback(function () {
    return dispatch(toggleSidebar());
  }, [dispatch]);
  var isSidebarOpen = useSelector$1(function (state) {
    var _state$admin, _state$admin$ui;

    return state === null || state === void 0 ? void 0 : (_state$admin = state.admin) === null || _state$admin === void 0 ? void 0 : (_state$admin$ui = _state$admin.ui) === null || _state$admin$ui === void 0 ? void 0 : _state$admin$ui.sidebarOpen;
  });
  var isXSmall = useMediaQuery(function (theme) {
    return theme.breakpoints.down("sm");
  });
  var translate = useTranslate$2();

  var _useGetIdentity = useGetIdentity$1(),
      identity = _useGetIdentity.identity;

  var isImpersonating = useIsImpersonating();
  var undoImpersonate = useUndoImpersonate();
  var handleUndoClick = useCallback(function (e) {
    e.stopPropagation();
    e.preventDefault();
    undoImpersonate();
  }, [undoImpersonate]);
  return /*#__PURE__*/React__default.createElement(Drawer, {
    open: open,
    onClose: handleToggleSidebar,
    variant: isXSmall ? "temporary" : "permanent",
    className: classnames(classes.drawer, (_classnames = {}, _defineProperty(_classnames, classes.drawerOpen, open), _defineProperty(_classnames, classes.drawerClose, !open), _classnames)),
    classes: {
      paper: classnames((_classnames2 = {}, _defineProperty(_classnames2, classes.drawerOpen, open), _defineProperty(_classnames2, classes.drawerClose, !open), _classnames2))
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.toolbar
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.brand
  }, isSidebarOpen && (brand && /*#__PURE__*/React__default.isValidElement(brand) ? brand : /*#__PURE__*/React__default.createElement(Brand, {
    logo: logo,
    title: title,
    subTitle: subTitle
  })), isImpersonating && isXSmall && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    display: "block",
    onClick: handleUndoClick,
    className: classes.undoImpersonate
  }, translate("ra.auth.impersonating.undo.short", identity))), /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: handleToggleSidebar
  }, /*#__PURE__*/React__default.createElement(ChevronLeft, null))), React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      onMenuClick: isXSmall ? handleToggleSidebar : undefined
    });
  }));
};

Sidebar.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool.isRequired,
  drawerWidth: PropTypes.number.isRequired,
  logo: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

var _excluded$V = ["theme"];
var LayoutContext = /*#__PURE__*/React__default.createContext({
  drawerWidth: 0
});

var LayoutProvider = function LayoutProvider(_ref) {
  var children = _ref.children,
      drawerWidth = _ref.drawerWidth;
  return /*#__PURE__*/React__default.createElement(LayoutContext.Provider, {
    value: {
      drawerWidth: drawerWidth
    }
  }, children);
};

var styles$2 = function styles(theme) {
  return createStyles({
    root: {
      display: "flex"
    },
    toolbar: _objectSpread2({
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1)
    }, theme.mixins.toolbar),
    content: _defineProperty({
      flexGrow: 1,
      padding: theme.spacing(3)
    }, theme.breakpoints.down("xs"), {
      padding: theme.spacing(0)
    })
  });
};

var LayoutWithoutTheme = /*#__PURE__*/function (_React$Component) {
  _inherits(LayoutWithoutTheme, _React$Component);

  var _super = _createSuper(LayoutWithoutTheme);

  function LayoutWithoutTheme(props) {
    var _this;

    _classCallCheck(this, LayoutWithoutTheme);

    _this = _super.call(this, props);
    /**
     * Reset the error state upon navigation
     *
     * @see https://stackoverflow.com/questions/48121750/browser-navigation-broken-by-use-of-react-error-boundaries
     */

    _defineProperty(_assertThisInitialized(_this), "state", {
      hasError: false,
      errorMessage: null,
      errorInfo: null
    });

    props.history.listen(function () {
      if (_this.state.hasError) {
        _this.setState({
          hasError: false
        });
      }
    });
    return _this;
  }

  _createClass(LayoutWithoutTheme, [{
    key: "componentDidCatch",
    value: function componentDidCatch(errorMessage, errorInfo) {
      this.setState({
        hasError: true,
        errorMessage: errorMessage,
        errorInfo: errorInfo
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$appBar = _this$props.appBar,
          appBar = _this$props$appBar === void 0 ? AppBar : _this$props$appBar,
          children = _this$props.children,
          classes = _this$props.classes,
          error = _this$props.error,
          dashboard = _this$props.dashboard,
          logout = _this$props.logout,
          _this$props$menu = _this$props.menu,
          menu = _this$props$menu === void 0 ? Menu$1 : _this$props$menu,
          _this$props$notificat = _this$props.notification,
          notification = _this$props$notificat === void 0 ? Notification : _this$props$notificat,
          open = _this$props.open,
          _this$props$sidebar = _this$props.sidebar,
          sidebar = _this$props$sidebar === void 0 ? Sidebar : _this$props$sidebar,
          logo = _this$props.logo,
          title = _this$props.title,
          subTitle = _this$props.subTitle,
          drawerWidth = _this$props.drawerWidth,
          location = _this$props.location;
      var _this$state = this.state,
          hasError = _this$state.hasError,
          errorMessage = _this$state.errorMessage,
          errorInfo = _this$state.errorInfo;
      return /*#__PURE__*/React__default.createElement(LayoutProvider, {
        drawerWidth: drawerWidth
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classes.root
      }, /*#__PURE__*/React__default.createElement(CssBaseline, null), /*#__PURE__*/createElement(sidebar, {
        open: open,
        logo: logo,
        title: title,
        subTitle: subTitle,
        drawerWidth: drawerWidth,
        children: /*#__PURE__*/createElement(menu, {
          open: open,
          logout: logout,
          hasDashboard: !!dashboard,
          menuConfig: this.props.menu
        })
      }), /*#__PURE__*/React__default.createElement("main", {
        id: "main-content",
        className: classes.content
      }, /*#__PURE__*/createElement(appBar, {
        title: title,
        open: open,
        logout: logout,
        location: location,
        drawerWidth: drawerWidth
      }), /*#__PURE__*/React__default.createElement("div", {
        className: classes.toolbar
      }), hasError ? /*#__PURE__*/createElement(error, {
        error: errorMessage,
        errorInfo: errorInfo,
        title: title
      }) : children), /*#__PURE__*/createElement(notification)));
    }
  }]);

  return LayoutWithoutTheme;
}(React__default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    open: state.admin.ui.sidebarOpen
  };
};

var EnhancedLayout = compose(connect(mapStateToProps, {} // Avoid connect passing dispatch in props
), withRouter, withStyles(styles$2, {
  name: "RaLayout"
}))(LayoutWithoutTheme);
/**
 * The Layout renders custom layout with left sidebar inside a drawer menu.
 */

var Layout = function Layout(_ref2) {
  var themeOverride = _ref2.theme,
      props = _objectWithoutProperties(_ref2, _excluded$V);

  var themeProp = useRef(themeOverride);

  var _useState = useState(function () {
    return createTheme(themeOverride);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      theme = _useState2[0],
      setTheme = _useState2[1];

  useEffect(function () {
    if (themeProp.current !== themeOverride) {
      themeProp.current = themeOverride;
      setTheme(createTheme(themeOverride));
    }
  }, [themeOverride, themeProp, theme, setTheme]);
  return /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(EnhancedLayout, props));
};

Layout.propTypes = {
  theme: PropTypes.object,
  logo: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  subTitle: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  drawerWidth: PropTypes.number
};
Layout.defaultProps = {
  theme: defaultTheme,
  logo: undefined,
  title: "React-Admin",
  subTitle: "Material-UI",
  drawerWidth: 240
};

var _excluded$U = ["className", "classes", "redirectTo", "icon", "label"];
var useStyles$x = makeStyles(function (theme) {
  return {
    menuItem: {
      color: theme.palette.text.secondary
    },
    icon: {
      minWidth: theme.spacing(5)
    }
  };
}, {
  name: "RaUserMenuItem"
});
var UserMenuItem = /*#__PURE__*/React.forwardRef(function UserMenuItem(props, ref) {
  var className = props.className;
      props.classes;
      props.redirectTo;
      var icon = props.icon,
      label = props.label,
      rest = _objectWithoutProperties(props, _excluded$U);

  var classes = useStyles$x(props);
  return /*#__PURE__*/React.createElement(MenuItem$1, _extends({
    className: classnames("user-menu-item", classes.menuItem, className),
    ref: ref,
    component: props.to ? Link : "a"
  }, rest), /*#__PURE__*/React.createElement(ListItemIcon, {
    className: classes.icon
  }, icon ? icon : /*#__PURE__*/React.createElement(PowerSettingsNew, null)), label);
});
UserMenuItem.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string,
  icon: PropTypes.element,
  onClick: PropTypes.func
};

var _excluded$T = ["resource", "baseRecord", "to", "label", "mode"];
/**
 * Renders a button that navigates back to the previous page (to).
 * foo
 * @param {Object} props
 * @param {String|null} props.to The URL to navigate to.
 * @param {String|null} props.resource The label of the button.
 * @param {String|null} props.label The label of the button.
 * @param {String|null} props.mode The mode of the button: to or history.
 *
 * @example
 * // This button redirects to /customer-list
 * <BackButton to="/customer-list" resource="customers" />
 *
 * // This button redirects to /customers (becouse to was not specified).
 * <BackButton resource="customers" />
 *
 * @returns {React.ReactElement}
 */

var BackButton = function BackButton(_ref) {
  var resource = _ref.resource;
      _ref.baseRecord;
      var to = _ref.to,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "ra.action.back" : _ref$label,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? "to" : _ref$mode,
      props = _objectWithoutProperties(_ref, _excluded$T);

  var history = useHistory();
  var handleClick = useCallback(function (e) {
    if (mode !== "history") {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    history.goBack();
  }, [history, useHistory]);
  return /*#__PURE__*/React__default.createElement(Button, _extends({}, props, {
    onClick: handleClick,
    component: Link,
    to: to || {
      pathname: "/".concat(resource)
    },
    label: label
  }), /*#__PURE__*/React__default.createElement(ArrowBack, null));
};
var BackButtonProps = BackButton;
BackButtonProps.propTypes = {
  resource: PropTypes.string,
  to: PropTypes.string,
  mode: PropTypes.oneOf(["to", "history"])
};

var _excluded$S = ["redirect", "reference"];
/**
 * Renders a delete button that ask for confirmation before deleting the record.
 *
 * @example
 * <Datagrid>
 *     <DeleteWithConfirmButton redirect="/list" />
 * </Datagrid>
 *
 * @param {Object} props
 * @param {String} props.redirect
 *  The redirect path after the delete action.
 *
 * @param {String} props.reference
 *  The reference to the resource to delete.
 *
 * @param {String} props.title
 *  The title of the delete dialog.
 *
 * @param {String} props.content
 *  The message of the delete dialog.
 *
 * @returns {JSX.Element}
 */

var DeleteWithConfirmButton = function DeleteWithConfirmButton(_ref) {
  var redirect = _ref.redirect;
      _ref.reference;
      var props = _objectWithoutProperties(_ref, _excluded$S);

  var translate = useTranslate$1();

  var _useMemo = useMemo$1(function () {
    var title = props.title ? typeof props.title === "function" ? props.confirmTitle(props.record, translate) : props.title : translate("ra.title.confirm_delete");
    var content = props.confirmTitle ? typeof props.content === "function" ? props.confirmTitle(props.record, translate) : props.content : translate("ra.message.confirm_delete");
    return {
      confirmTitle: title,
      confirmContent: content
    };
  }, [props, translate]),
      confirmTitle = _useMemo.confirmTitle,
      confirmContent = _useMemo.confirmContent;

  var record = props.record;

  if (!record) {
    // React-Admin original button soffer refreh's bug.
    // While trying to recover id of an non existing records it crash the application.
    // To avoid problems with this situation we have to return an empty component in this case.
    return null;
  }

  return /*#__PURE__*/React__default.createElement(DeleteWithConfirmButton$1, _extends({}, props, {
    redirect: redirect,
    confirmTitle: confirmTitle,
    confirmContent: confirmContent
  }));
};
var DeleteWithConfirmButtonProps = DeleteWithConfirmButton;
DeleteWithConfirmButtonProps.propTypes = {
  redirect: PropTypes.string,
  reference: PropTypes.string,
  record: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};

var useWorkflow = function useWorkflow(_ref) {
  var apiUrl = _ref.apiUrl;

  var _useState = useState({
    loading: false,
    loaded: false,
    data: []
  }),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      loaded = _useState2$.loaded,
      loading = _useState2$.loading,
      data = _useState2$.data,
      setData = _useState2[1];

  var loadAll = function loadAll(_ref2) {
    var apiUrl = _ref2.apiUrl;

    if (loaded || loading) {
      return;
    }

    setData({
      loading: true
    });
    var headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    fetch("".concat(apiUrl, "/workflow/load"), {
      headers: headers
    }).then(function (response) {
      return response.json();
    }).then(validateJson).then(function (_ref3) {
      var data = _ref3.data;
      return setData({
        loaded: true,
        loading: false,
        data: data
      });
    });
  };

  useEffect(function () {
    return loadAll({
      apiUrl: apiUrl
    });
  });
  return {
    loaded: loaded,
    loading: loading,
    data: data
  };
};

var Workflow = /*#__PURE__*/function () {
  function Workflow(data) {
    _classCallCheck(this, Workflow);

    this.states = data.states;
  }

  _createClass(Workflow, [{
    key: "canCreate",
    value: function canCreate(roles) {
      return this.check("create", roles);
    }
  }, {
    key: "canEdit",
    value: function canEdit(roles, record) {
      return this.check("edit", roles, record);
    }
  }, {
    key: "canRead",
    value: function canRead(roles, record) {
      return this.check("read", roles, record);
    }
  }, {
    key: "check",
    value: function check(permission, roles, record) {
      var perm = "".concat(permission.charAt(0).toUpperCase()).concat(permission.slice(1));
      var can = "can".concat(perm);
      var state = record && record.id > 0 && record.transaction ? this.states.find(function (s) {
        return s.code === record.transaction.state;
      }) : this.states.find(function (s) {
        return s.isInitial;
      });
      var permissions = state.permissions.filter(function (p) {
        return p[can];
      });
      return permissions.some(function (permission) {
        return roles.some(function (role) {
          return permission.role === role.code;
        });
      });
    }
  }, {
    key: "canEditField",
    value: function canEditField(fieldName, roles, record) {
      return this.checkField("edit", roles, fieldName, record);
    }
  }, {
    key: "canReadField",
    value: function canReadField(fieldName, roles, record) {
      return this.checkField("read", roles, fieldName, record);
    }
  }, {
    key: "canReadFields",
    value: function canReadFields(fields, roles, record) {
      var _this = this;

      return fields.some(function (field) {
        return _this.canReadField(field, roles, record);
      });
    }
  }, {
    key: "checkField",
    value: function checkField(permission, roles, fieldName, record) {
      var perm = "".concat(permission.charAt(0).toUpperCase()).concat(permission.slice(1));
      var can = "can".concat(perm);
      var state = record && record.transaction ? this.states.find(function (s) {
        return s.code === record.transaction.state;
      }) : this.states.find(function (s) {
        return s.isInitial;
      });
      var field = state.fields.find(function (f) {
        return f.name === fieldName;
      });

      if (!field) {
        return false;
      }

      var permissions = field.permissions.filter(function (p) {
        return p[can];
      });
      var check = permissions.some(function (permission) {
        return roles.some(function (role) {
          return permission.role === role.code;
        });
      });
      return check;
    }
  }, {
    key: "getNextStates",
    value: function getNextStates(roles, record) {
      var _record$transaction,
          _this2 = this;

      if (!record) {
        return [];
      }

      var possibleStates = [];
      var stateCode = (record === null || record === void 0 ? void 0 : record.state) || (record === null || record === void 0 ? void 0 : (_record$transaction = record.transaction) === null || _record$transaction === void 0 ? void 0 : _record$transaction.state);

      if (stateCode) {
        var state = this.states.find(function (state) {
          return state.code === stateCode;
        });
        possibleStates = Object.keys(state.transitions).map(function (code) {
          return _this2.states.find(function (s) {
            return s.code === code;
          });
        });
      } else {
        var initial = this.states.find(function (state) {
          return state.isInitial;
        });
        possibleStates = [initial];
      }

      var nextStates = possibleStates.filter(function (state) {
        return state.permissions.some(function (p) {
          return roles.some(function (r) {
            return r.code === p.role && (p.canCreate || p.canMove);
          });
        });
      });
      return nextStates;
    }
  }, {
    key: "needsNotes",
    value: function needsNotes(record, state) {
      var _record$transaction2;

      if (!record || !state) {
        return false;
      }

      var stateCode = (record === null || record === void 0 ? void 0 : record.state) || (record === null || record === void 0 ? void 0 : (_record$transaction2 = record.transaction) === null || _record$transaction2 === void 0 ? void 0 : _record$transaction2.state);

      if (stateCode) {
        var currentState = this.states.find(function (state) {
          return state.code === stateCode;
        });

        if (currentState && currentState.transitions[state.code]) {
          return currentState.transitions[state.code].notesRequired;
        }
      }

      return false;
    }
  }, {
    key: "getState",
    value: function getState(record) {
      var _record$transaction3;

      var state = (record === null || record === void 0 ? void 0 : record.state) || (record === null || record === void 0 ? void 0 : (_record$transaction3 = record.transaction) === null || _record$transaction3 === void 0 ? void 0 : _record$transaction3.state);

      if (!state) {
        return null;
      }

      return this.states.find(function (s) {
        return s.code === state;
      });
    }
  }, {
    key: "getStateByCode",
    value: function getStateByCode(code) {
      return this.states.find(function (s) {
        return s.code === code;
      });
    }
  }]);

  return Workflow;
}();

var WorkflowContext = /*#__PURE__*/createContext({});
var WorkflowProvider = function WorkflowProvider(_ref) {
  var children = _ref.children,
      apiUrl = _ref.apiUrl;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      workflow = _useState2[0],
      setWorkflow = _useState2[1];

  var _useWorkflow = useWorkflow({
    apiUrl: apiUrl
  }),
      data = _useWorkflow.data;

  var getWorkflow = useCallback(function (resource) {
    return get$1(workflow, resource);
  }, [workflow]);
  useEffect(function () {
    if (!data) {
      return;
    }

    var resources = Object.keys(data).reduce(function (workflows, name) {
      return _objectSpread2(_objectSpread2({}, workflows), {}, _defineProperty({}, name, new Workflow(data[name])));
    }, {});
    setWorkflow(resources);
  }, [data]);
  return /*#__PURE__*/React__default.createElement(WorkflowContext.Provider, {
    value: {
      apiUrl: apiUrl,
      workflows: data,
      getWorkflow: getWorkflow
    }
  }, children);
};

var _excluded$R = ["record", "resource"];
/**
 * Renders Edit button connected to the workflow. The button is able to
 * check if user has required permissions and based on this can show "View"
 * or "Edit" label on the button itself.
 *
 * This button can be used inside list or show views.
 * To use this button you have to configure WorkflowContext into your app.
 *
 * @param {Object} props
 *
 * @returns {React.ReactElement}
 */

var EditButton = function EditButton(_ref) {
  var record = _ref.record,
      resource = _ref.resource,
      props = _objectWithoutProperties(_ref, _excluded$R);

  var _useContext = useContext(WorkflowContext),
      getWorkflow = _useContext.getWorkflow;

  var _useGetIdentity = useGetIdentity(),
      loaded = _useGetIdentity.loaded,
      loading = _useGetIdentity.loading,
      identity = _useGetIdentity.identity;

  var roles = useMemo$1(function () {
    return !loading && loaded ? identity === null || identity === void 0 ? void 0 : identity.roles : [];
  }, [loaded, identity, loading]);
  var workflow = useMemo$1(function () {
    return getWorkflow(resource);
  }, [getWorkflow, resource]);

  if (!workflow) {
    return /*#__PURE__*/React__default.createElement(EditButton$1, {
      disabled: true
    });
  }

  var canEdit = workflow.canEdit(roles, record);
  var label = canEdit ? "ra.action.edit" : "ra.action.view";
  var icon = canEdit ? /*#__PURE__*/React__default.createElement(Create$2, null) : /*#__PURE__*/React__default.createElement(Visibility, null);
  return /*#__PURE__*/React__default.createElement(EditButton$1, _extends({
    icon: icon,
    label: label,
    record: record
  }, props));
};

var load = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
    var apiUrl, token, headers;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiUrl = _ref.apiUrl, token = _ref.token;
            headers = new Headers();
            headers.append("Accept", "application/json");
            headers.append("Content-Type", "application/json");
            headers.append("Authorization", "Bearer ".concat(token));
            return _context.abrupt("return", fetch("".concat(apiUrl, "/crud/load"), {
              headers: headers
            }).then(function (response) {
              return response.json();
            }).then(validateJson).then(function (_ref3) {
              var data = _ref3.data;
              return data;
            }));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function load(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useCrud = function useCrud(_ref) {
  var apiUrl = _ref.apiUrl;

  var _useSafeSetState = useSafeSetState({
    loading: false,
    loaded: false,
    data: [],
    token: getToken()
  }),
      _useSafeSetState2 = _slicedToArray(_useSafeSetState, 2),
      _useSafeSetState2$ = _useSafeSetState2[0],
      loaded = _useSafeSetState2$.loaded,
      loading = _useSafeSetState2$.loading,
      data = _useSafeSetState2$.data,
      token = _useSafeSetState2$.token,
      setData = _useSafeSetState2[1];

  var handleLogin = useCallback(function (e) {
    if (token !== e.value) {
      setData(function (d) {
        return _objectSpread2(_objectSpread2({}, d), {}, {
          token: e.value,
          loaded: false
        });
      });
    }
  }, [setData, token]);
  useEffect(function () {
    return document.addEventListener("login", handleLogin);
  }, [handleLogin]);
  useEffect(function () {
    var loadAll = function loadAll(_ref2) {
      var apiUrl = _ref2.apiUrl,
          token = _ref2.token;

      if (loaded || loading || token === null) {
        return;
      }

      setData({
        loading: true
      });
      load({
        apiUrl: apiUrl,
        token: token
      }).then(function (data) {
        return setData({
          loaded: true,
          loading: false,
          data: data
        });
      });
    };

    var token = getToken();
    loadAll({
      apiUrl: apiUrl,
      token: token
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiUrl, token]);
  return {
    loaded: loaded,
    loading: loading,
    data: data
  };
};

/**
 * Export a context that will be used to provide the crud instance to the children.
 */

var CrudContext = /*#__PURE__*/createContext({});
/**
 * CrudProvider component, used to provide the crud instance to the children.
 *
 * @param {Array|Object} props.children The children to render.
 * @param {Object} props.components List of additional components to render.
 * @param {string} props.apiUrl The api url.
 *
 * @returns {React.ReactElement}
 */

var CrudProvider = function CrudProvider(_ref) {
  var children = _ref.children,
      components = _ref.components,
      apiUrl = _ref.apiUrl;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      entities = _useState2[0],
      setEntities = _useState2[1];

  var _useCrud = useCrud({
    apiUrl: apiUrl
  }),
      loading = _useCrud.loading,
      data = _useCrud.data;

  var getGrid = function getGrid(entity) {
    return get$1(entities, "".concat(entity, ".grid"), false);
  };

  var getForm = function getForm(entity) {
    return get$1(entities, "".concat(entity, ".form"), false);
  };

  useEffect(function () {
    return setEntities(data);
  }, [data]);
  return /*#__PURE__*/React__default.createElement(CrudContext.Provider, {
    value: {
      apiUrl: apiUrl,
      loading: loading,
      data: data,
      components: components,
      getGrid: getGrid,
      getForm: getForm
    }
  }, children);
};
CrudProvider.propTypes = {
  /**
   * The children to render.
   *
   * @type {Array|Object}
   */
  children: PropTypes.node.isRequired,

  /**
   * List of additional components to render.
   *
   * @type {Object}
   */
  components: PropTypes.object,

  /**
   * The api url from which to fetch the crud entities.
   *
   * @type {string}
   */
  apiUrl: PropTypes.string.isRequired
};

var ExportToXlsxButton = function ExportToXlsxButton(_ref, ref) {
  var currentSort = _ref.currentSort,
      filterValues = _ref.filterValues,
      baseUrl = _ref.baseUrl,
      onClick = _ref.onClick,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "ra.action.export" : _ref$label,
      _ref$menu = _ref.menu,
      menu = _ref$menu === void 0 ? false : _ref$menu,
      resource = _ref.resource,
      _ref$extension = _ref.extension,
      extension = _ref$extension === void 0 ? "xlsx" : _ref$extension,
      sort = _ref.sort;

  var _useContext = useContext(CrudContext),
      apiUrl = _useContext.apiUrl;

  var url = useMemo$1(function () {
    return baseUrl == null ? "".concat(apiUrl, "/crud/").concat(resource, "/export.").concat(extension) : baseUrl;
  }, [baseUrl, apiUrl, resource, extension]);
  var href = useMemo$1(function () {
    var filters = Object.keys(filterValues).filter(function (name) {
      return filterValues[name] !== undefined && filterValues[name] !== null;
    }).map(function (name) {
      return "".concat(name, "=").concat(filterValues[name]);
    }).join("&");
    var order = currentSort ? "&sort=".concat(currentSort.field, "&direction=").concat(currentSort.order) : "&sort=".concat(sort === null || sort === void 0 ? void 0 : sort.field, "&direction=").concat(sort === null || sort === void 0 ? void 0 : sort.order);
    return "".concat(url, "?token=").concat(getToken(), "&").concat(filters).concat(order);
  }, [filterValues, currentSort, url, sort]);
  return menu ? /*#__PURE__*/React__default.createElement(MenuItem$1, {
    ref: ref,
    component: Link$1,
    onClick: onClick,
    href: href
  }, extension === null || extension === void 0 ? void 0 : extension.toUpperCase()) : /*#__PURE__*/React__default.createElement(Button, {
    component: Link$1,
    href: href,
    label: label
  });
};

var ExportButton = /*#__PURE__*/React__default.forwardRef(ExportToXlsxButton);

var _excluded$Q = ["exportTo", "label"];

var ExportToButton = function ExportToButton(_ref) {
  var _ref$exportTo = _ref.exportTo,
      exportTo = _ref$exportTo === void 0 ? ["csv", "xlsx"] : _ref$exportTo,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "ra.action.export" : _ref$label,
      props = _objectWithoutProperties(_ref, _excluded$Q);

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  if (exportTo.length === 0) {
    return null;
  }

  return (exportTo === null || exportTo === void 0 ? void 0 : exportTo.length) > 1 ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Button, {
    label: label,
    onClick: handleClick,
    startIcon: /*#__PURE__*/React__default.createElement(GetApp, null)
  }), /*#__PURE__*/React__default.createElement(Menu$2, {
    id: "export-menu",
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleClose
  }, exportTo.map(function (extension) {
    return /*#__PURE__*/React__default.createElement(ExportButton, _extends({
      key: extension
    }, props, {
      extension: extension,
      menu: true
    }));
  }))) : /*#__PURE__*/React__default.createElement(ExportButton, _extends({}, props, {
    extension: exportTo[0]
  }));
};

var _excluded$P = ["label", "record"];

var ImpersonateUserButton = function ImpersonateUserButton(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? "ra.auth.sign_in" : _ref$label,
      record = _ref.record,
      rest = _objectWithoutProperties(_ref, _excluded$P);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var doImpersonate = useDoImpersonate(record === null || record === void 0 ? void 0 : record.id);
  var handleClick = useCallback(function (e) {
    e.stopPropagation();
    e.preventDefault();
    setLoading(true);
    doImpersonate().then(function () {
      return setLoading(false);
    });
  }, [doImpersonate, setLoading]);
  return /*#__PURE__*/React__default.createElement(Button, _extends({
    disabled: loading,
    color: "primary",
    variant: "text",
    label: label,
    onClick: handleClick
  }, rest), /*#__PURE__*/React__default.createElement(VpnKey, null));
};

var MarkAsReadedButton = function MarkAsReadedButton(_ref) {
  var _ref$selectedIds = _ref.selectedIds,
      selectedIds = _ref$selectedIds === void 0 ? [] : _ref$selectedIds;
  var refresh = useRefresh();
  var notify = useNotify$1();
  var unselectAll = useUnselectAll();

  var _useUpdateMany = useUpdateMany("notifications", selectedIds, {
    readed: moment().format()
  }, {
    onSuccess: function onSuccess() {
      refresh();
      notify("resources.notifications.messages.readed.done");
      unselectAll("notifications");
    },
    onFailure: function onFailure() {
      return notify("resources.notifications.messages.readed.error", "warning");
    }
  }),
      _useUpdateMany2 = _slicedToArray(_useUpdateMany, 2),
      updateMany = _useUpdateMany2[0],
      loading = _useUpdateMany2[1].loading;

  var handleUpdateMany = useCallback(function (e) {
    e.stopPropagation();
    updateMany();
  }, [updateMany]);
  return /*#__PURE__*/React__default.createElement(Button, {
    label: "resources.notifications.buttons.mark_as_readed",
    disabled: loading,
    onClick: handleUpdateMany
  }, /*#__PURE__*/React__default.createElement(Email, null));
};

var MarkAsUnreadedButton = function MarkAsUnreadedButton(_ref) {
  var _ref$selectedIds = _ref.selectedIds,
      selectedIds = _ref$selectedIds === void 0 ? [] : _ref$selectedIds;
  var refresh = useRefresh();
  var notify = useNotify$1();
  var unselectAll = useUnselectAll();

  var _useUpdateMany = useUpdateMany("notifications", selectedIds, {
    readed: null
  }, {
    onSuccess: function onSuccess() {
      refresh();
      notify("resources.notifications.messages.unreaded.done");
      unselectAll("notifications");
    },
    onFailure: function onFailure() {
      return notify("resources.notifications.messages.unreaded.error", "warning");
    }
  }),
      _useUpdateMany2 = _slicedToArray(_useUpdateMany, 2),
      updateMany = _useUpdateMany2[0],
      loading = _useUpdateMany2[1].loading;

  var handleUpdateMany = useCallback(function (e) {
    e.stopPropagation();
    updateMany();
  }, [updateMany]);
  return /*#__PURE__*/React__default.createElement(Button, {
    color: "secondary",
    label: "resources.notifications.buttons.mark_as_unreaded",
    disabled: loading,
    onClick: handleUpdateMany
  }, /*#__PURE__*/React__default.createElement(Drafts, null));
};

/**
 * Button to reset a user's password.
 * This button can be used in list or forms (everywhere a record
 * exists in the list of props).
 *
 * @param {Object} props
 * @param {Object} props.record User's record.
 * @returns  {JSX.Element}
 */

var ResetPasswordButton = function ResetPasswordButton(_ref) {
  var record = _ref.record;
  var notify = useNotify$1();
  var translate = useTranslate$1();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useMutation = useMutation({
    type: "post",
    resource: "users/reset-password",
    payload: {
      account: get$1(record, "email")
    }
  }, {
    onSuccess: function onSuccess() {
      setOpen(false);
      notify("resources.users.messages.reset_success", "info");
    },
    onFailure: function onFailure(_ref2) {
      _ref2.message;
      setOpen(false);
      notify("resources.users.messages.reset_failure", "error");
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 2),
      handleConfirm = _useMutation2[0],
      loading = _useMutation2[1].loading;

  var handleClick = function handleClick(e) {
    e.stopPropagation();
    e.preventDefault();
    setOpen(true);
  };

  var handleCancel = function handleCancel() {
    return setOpen(false);
  };

  var id = get$1(record, "id", 0);

  if (id === 0) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Confirm, {
    isOpen: open,
    loading: loading,
    title: "resources.users.messages.reset_title",
    content: "resources.users.messages.reset_content",
    onConfirm: handleConfirm,
    onClose: handleCancel
  }), /*#__PURE__*/React__default.createElement(Button, {
    onClick: handleClick,
    color: "primary",
    label: translate("resources.users.buttons.reset")
  }, /*#__PURE__*/React__default.createElement(RotateLeft, null)));
};

var _excluded$O = ["handleSubmitWithRedirect", "small", "state", "pristine"];
var useStyles$w = makeStyles(function (theme) {
  var _theme$props, _theme$props$MuiButto;

  return {
    button: {
      disableElevation: ((_theme$props = theme.props) === null || _theme$props === void 0 ? void 0 : (_theme$props$MuiButto = _theme$props.MuiButton) === null || _theme$props$MuiButto === void 0 ? void 0 : _theme$props$MuiButto.disableElevation) === true
    }
  };
});

var StateButton = function StateButton(_ref, ref) {
  var handleSubmitWithRedirect = _ref.handleSubmitWithRedirect;
      _ref.small;
      var state = _ref.state;
      _ref.pristine;
      var props = _objectWithoutProperties(_ref, _excluded$O);

  var classes = useStyles$w();
  var form = useForm();
  var handleClick = useCallback(function () {
    form.change("state", state.code);
    handleSubmitWithRedirect("list");
  }, [state, form, handleSubmitWithRedirect]);
  return /*#__PURE__*/React__default.createElement(SaveButton, _extends({}, props, {
    className: classes.button,
    redirect: "list",
    color: "primary",
    handleSubmitWithRedirect: handleClick,
    label: get$1(state, "label")
  }));
};

var StateButton$1 = /*#__PURE__*/React__default.forwardRef(StateButton);

var _excluded$N = ["states"];
var useStyles$v = makeStyles(function (theme) {
  var _theme$props, _theme$props$MuiButto;

  return {
    button: {
      disableElevation: ((_theme$props = theme.props) === null || _theme$props === void 0 ? void 0 : (_theme$props$MuiButto = _theme$props.MuiButton) === null || _theme$props$MuiButto === void 0 ? void 0 : _theme$props$MuiButto.disableElevation) === true
    }
  };
});

var StateButtonMenu = function StateButtonMenu(_ref) {
  var states = _ref.states,
      props = _objectWithoutProperties(_ref, _excluded$N);

  var classes = useStyles$v();
  var translate = useTranslate$1();

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var _React$useState3 = React__default.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      state = _React$useState4[0],
      setState = _React$useState4[1];

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var handleState = useCallback(function (state) {
    return function (e) {
      setState(state.label);
      setAnchorEl(null);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Button$1, {
    "aria-controls": "workflow-menu",
    "aria-haspopup": "true",
    variant: "contained",
    color: "primary",
    className: classes.button,
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement(DoubleArrow, null), props.saving ? "".concat(state, "...") : translate("ra.workflow.do_action")), /*#__PURE__*/React__default.createElement(Menu$2, {
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleClose
  }, states.map(function (state) {
    return /*#__PURE__*/React__default.createElement(StateButton$1, _extends({}, props, {
      key: state.code,
      component: MenuItem$1,
      state: state,
      color: "default",
      variant: "text",
      icon: /*#__PURE__*/React__default.createElement(ArrowForwardIos, null),
      onClick: handleState(state)
    }));
  })));
};

var buttons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BackButton: BackButton,
  DeleteButton: DeleteButton,
  DeleteWithConfirmButton: DeleteWithConfirmButton,
  EditButton: EditButton,
  ExportButton: ExportButton,
  ExportToButton: ExportToButton,
  ImpersonateUserButton: ImpersonateUserButton,
  MarkAsReadedButton: MarkAsReadedButton,
  MarkAsUnreadedButton: MarkAsUnreadedButton,
  RaDeleteButton: DeleteButton,
  RaEditButton: EditButton$1,
  ResetPasswordButton: ResetPasswordButton,
  SaveButton: SaveButton,
  StateButton: StateButton$1,
  StateButtonMenu: StateButtonMenu
});

var _excluded$M = ["chipSource"];

var ChipArrayField = function ChipArrayField(_ref) {
  var chipSource = _ref.chipSource,
      props = _objectWithoutProperties(_ref, _excluded$M);

  return /*#__PURE__*/React__default.createElement(ArrayField, props, /*#__PURE__*/React__default.createElement(SingleFieldList, {
    linkType: false
  }, /*#__PURE__*/React__default.createElement(ChipField, {
    source: chipSource
  })));
};

var _excluded$L = ["width", "height"];

var styles$1 = function styles(theme) {
  return {
    image: function image(_ref) {
      var width = _ref.width,
          height = _ref.height;
      return {
        margin: 0,
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
        borderRadius: 5,
        border: "1px solid ".concat(theme.palette.divider),
        width: width,
        height: height
      };
    }
  };
};

var useStyles$u = makeStyles(styles$1);

var CoverField = function CoverField(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      props = _objectWithoutProperties(_ref2, _excluded$L);

  var classes = useStyles$u({
    width: width,
    height: height
  });
  return /*#__PURE__*/React__default.createElement(ImageField, _extends({
    classes: classes
  }, props));
};

var DateAgoField = function DateAgoField(_ref) {
  var record = _ref.record;
  var locale = useLocale();
  var fromNow = useMemo$1(function () {
    require("moment/locale/".concat(locale));

    moment.locale(locale);
    return moment(record === null || record === void 0 ? void 0 : record.created).fromNow();
  }, [record === null || record === void 0 ? void 0 : record.created, locale]);
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption"
  }, fromNow), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(DateField, {
    record: record,
    source: "created",
    addLabel: false,
    showTime: true
  }));
};

var _excluded$K = ["record", "source", "width", "minWidth", "maxWidth", "maxRows", "sortable", "basePath", "sortBy", "variant"];
var useStyles$t = makeStyles$1(function (theme) {
  return {
    root: {
      overflow: "hidden",
      "text-overflow": "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      whiteSpace: "break-spaces"
    }
  };
});

var LongTextField = function LongTextField(_ref) {
  var record = _ref.record,
      source = _ref.source,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? undefined : _ref$width,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? undefined : _ref$minWidth,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? undefined : _ref$maxWidth,
      _ref$maxRows = _ref.maxRows,
      maxRows = _ref$maxRows === void 0 ? 3 : _ref$maxRows;
      _ref.sortable;
      _ref.basePath;
      _ref.sortBy;
      var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "body2" : _ref$variant,
      props = _objectWithoutProperties(_ref, _excluded$K);

  var classes = useStyles$t();
  return /*#__PURE__*/React__default.createElement(Typography, _extends({}, props, {
    variant: variant,
    title: get$1(record, source),
    className: classes.root,
    style: {
      width: width,
      minWidth: minWidth,
      maxWidth: maxWidth,
      WebkitLineClamp: maxRows
    }
  }), get$1(record, source));
};

LongTextField.propTypes = {
  minWidth: PropTypes.number,
  maxWidth: PropTypes.number,
  width: PropTypes.number,
  maxRows: PropTypes.number
};

var MediaField = function MediaField(_ref) {
  var props = _extends({}, _ref);

  var id = get$1(props, "record.id", 0);
  var source = id > 0 ? "file.path" : "filepath";
  return /*#__PURE__*/React__default.createElement(FileField, _extends({}, props, {
    source: source
  }));
};

var useStyles$s = makeStyles(function (theme) {
  return {
    content: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      whiteSpace: "break-spaces"
    }
  };
});

var NotificationField = function NotificationField(_ref) {
  var record = _ref.record;
  var translate = useTranslate$2();
  var classes = useStyles$s();
  var readed = useMemo$1(function () {
    return record !== null && record !== void 0 && record.readed ? moment(record === null || record === void 0 ? void 0 : record.readed).format(translate("app.date_format.long")) : false;
  }, [record === null || record === void 0 ? void 0 : record.readed, translate]);
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle1"
  }, /*#__PURE__*/React__default.createElement(Box, {
    fontWeight: "bold"
  }, " ", record === null || record === void 0 ? void 0 : record.title)), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    className: classes.content,
    dangerouslySetInnerHTML: {
      __html: record === null || record === void 0 ? void 0 : record.content
    }
  }), readed && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    display: "block"
  }, translate("resources.notifications.readed", {
    readed: readed
  })), record !== null && record !== void 0 && record.readed ? /*#__PURE__*/React__default.createElement(MarkAsUnreadedButton, {
    selectedIds: [record === null || record === void 0 ? void 0 : record.id]
  }) : /*#__PURE__*/React__default.createElement(MarkAsReadedButton, {
    selectedIds: [record === null || record === void 0 ? void 0 : record.id]
  }));
};

var useStyles$r = makeStyles(function (theme) {
  return {
    progress: {
      height: 20 + theme.spacing(1),
      width: 100,
      borderRadius: theme.spacing(0.5)
    },
    label: {
      position: "relative",
      color: theme.palette.primary.contrastText,
      display: "block",
      float: "left",
      marginLeft: -100,
      width: 100,
      textAlign: "center"
    }
  };
});

var ProgressField = function ProgressField(_ref) {
  var record = _ref.record,
      source = _ref.source;
  var classes = useStyles$r();
  return /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(LinearProgress, {
    classes: {
      root: classes.progress
    },
    variant: "determinate",
    color: get$1(record, source) >= 100 ? "primary" : "secondary",
    value: get$1(record, source)
  }), /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.label
  }, get$1(record, source, 0).toFixed(2), "%"));
};

var _excluded$J = ["component", "componentProps", "components", "addLabel", "sortBy"],
    _excluded2$b = ["source", "component", "componentProps"];
var useStyles$q = makeStyles(function (theme) {
  return {
    root: {
      margin: theme.spacing(2)
    }
  };
});

var Error$1 = function Error(_ref) {
  var error = _ref.error,
      label = _ref.label,
      source = _ref.source;
  var classes = useStyles$q();
  return /*#__PURE__*/React__default.createElement(Box, {
    className: classes.root
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption"
  }, label || source), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2"
  }, (error === null || error === void 0 ? void 0 : error.message) || error));
};

var ComponentWrapper = function ComponentWrapper(_ref2) {
  var component = _ref2.component,
      componentProps = _ref2.componentProps,
      components = _ref2.components;
      _ref2.addLabel;
      _ref2.sortBy;
      var props = _objectWithoutProperties(_ref2, _excluded$J);

  var Component = get$1(components, component);

  if (!Component) {
    return /*#__PURE__*/React__default.createElement(Error$1, _extends({}, props, componentProps, {
      error: "Component ".concat(component, " not found.")
    }));
  }

  return /*#__PURE__*/React__default.createElement(Component, _extends({}, props, componentProps));
};
/**
 * Render a component using a dictionary of components.
 * This component can catch and handle internal errors (e.g. when a component is not found)
 * and display a fallback message containing the error details.
 *
 * @param {Object} props
 * @param {String} props.component The name of the component to render.
 * @param {Object} props.componentProps The props to pass to the component.
 * @param {Object} props.components A dictionary of components renderable by name.
 * @param {Boolean} props.addLabel Whether to add a label to the component.
 *
 * @returns {JSX.Element}
 */


var Component = function Component(props) {
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, {
    FallbackComponent: function FallbackComponent(_ref3) {
      var error = _ref3.error;
      return /*#__PURE__*/React__default.createElement(Error$1, _extends({}, props, {
        error: error
      }));
    }
  }, /*#__PURE__*/React__default.createElement(ComponentWrapper, props));
};
/**
 * Render list fileds using component configured in the `components` prop.
 *
 * @param {Array} filters
 *  An array of filters to render.
 *
 * @param {Object} components
 *  A dictionary of components renderable by name.
 *
 * @param {Object} props
 *  Additional props to pass to the tertiary component.
 *
 * @returns {Array}
 */


Component.mapFilters = function (filters, components) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return filters === null || filters === void 0 ? void 0 : filters.map(function (_ref4) {
    var source = _ref4.source,
        component = _ref4.component,
        componentProps = _ref4.componentProps,
        restProps = _objectWithoutProperties(_ref4, _excluded2$b);

    return /*#__PURE__*/React__default.createElement(Component, _extends({}, props, restProps, {
      key: source,
      source: source,
      component: component,
      componentProps: componentProps,
      components: components,
      alwaysOn: componentProps === null || componentProps === void 0 ? void 0 : componentProps.alwaysOn
    }));
  });
};
/**
 * This method render list of columns configured with specific components inside a datagrid.
 * **Remember**: do not use this method outside `Datagrid` components, it will
 * not work as expected.
 *
 * @param {Array} columns
 *  An array of columns to render.
 *
 * @param {Object} components
 *  A dictionary of components renderable by name.
 *
 * @param {Object} props
 *  Additional props to pass to the tertiary component.
 *
 * @returns {Array}
 */


Component.mapColumns = function (columns, components) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return columns === null || columns === void 0 ? void 0 : columns.map(function (_ref5) {
    var source = _ref5.source,
        label = _ref5.label,
        sortable = _ref5.sortable,
        component = _ref5.component,
        sortBy = _ref5.sortBy,
        componentProps = _ref5.componentProps;
    return /*#__PURE__*/React__default.createElement(Component, _extends({}, props, {
      key: source
    }, component.indexOf("Button") === -1 ? {
      source: source,
      label: label,
      sortable: sortable,
      sortBy: sortBy,
      addLabel: false
    } : {}, {
      component: component,
      componentProps: componentProps,
      components: components
    }));
  });
};
var ComponentProps = Component;
ComponentProps.propTypes = {
  component: PropTypes.string.isRequired,
  componentProps: PropTypes.object,
  components: PropTypes.object.isRequired,
  addLabel: PropTypes.bool
};

var _excluded$I = ["children", "evenOdd", "inner"];

var getWidthToSubtract = function getWidthToSubtract(w) {
  return w + (window.innerWidth - document.documentElement.clientWidth);
};

var INNER_SIZE = 10;
var useStyles$p = makeStyles$1(function (theme) {
  return {
    container: function container(_ref) {
      var _ref2;

      var sidebarOpen = _ref.sidebarOpen,
          drawerWidth = _ref.drawerWidth,
          inner = _ref.inner;
      return _ref2 = {
        borderRadius: theme.shape.borderRadius,
        overflowX: "auto",
        overflowY: "hidden",
        maxWidth: "calc(100vw - ".concat(sidebarOpen ? getWidthToSubtract(drawerWidth + theme.spacing(!inner ? 6 : INNER_SIZE) - 1) : getWidthToSubtract(58 + theme.spacing(!inner ? 6 : INNER_SIZE) - 1), "px)")
      }, _defineProperty(_ref2, theme.breakpoints.down("sm"), {
        maxWidth: "calc(100vw - ".concat(theme.spacing(!inner ? 6 : INNER_SIZE), "px)")
      }), _defineProperty(_ref2, theme.breakpoints.down("xs"), {
        width: "100vw",
        maxWidth: "100vw"
      }), _ref2;
    },
    rowEven: {
      backgroundColor: theme.palette.background.default
    }
  };
});

var Datagrid = function Datagrid(_ref3) {
  var children = _ref3.children,
      _ref3$evenOdd = _ref3.evenOdd,
      evenOdd = _ref3$evenOdd === void 0 ? true : _ref3$evenOdd,
      _ref3$inner = _ref3.inner,
      inner = _ref3$inner === void 0 ? false : _ref3$inner,
      props = _objectWithoutProperties(_ref3, _excluded$I);

  var _useContext = useContext(LayoutContext),
      drawerWidth = _useContext.drawerWidth;

  var sidebarOpen = useSelector$1(function (state) {
    return state.admin.ui.sidebarOpen;
  });
  var classes = useStyles$p({
    sidebarOpen: sidebarOpen,
    drawerWidth: drawerWidth,
    inner: inner
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React__default.createElement(Datagrid$1, _extends({
    classes: evenOdd ? {
      rowEven: classes.rowEven
    } : undefined
  }, props), children));
};

var EmptyMessage = function EmptyMessage(_ref) {
  var classes = _ref.classes,
      emptyText = _ref.emptyText;
  var translate = useTranslate$1();
  return /*#__PURE__*/React__default.isValidElement(emptyText) ? /*#__PURE__*/React__default.cloneElement(emptyText, {
    key: "empty"
  }) : /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.empty,
    key: "empty",
    variant: "body2"
  }, translate(emptyText));
};

/**
 * Custom paginator designed to work with `ReferenceManyField` component.
 * This paginator check whether there are any records in the list and display
 * paginator only if there is data to display.
 *
 * This behavior is necessary to avoid "duplicated" empty messages provided by
 * `ReferenceManyField` and `Pagination` components. Should I create a PR to
 * fix this?
 *
 * @param {Object} props
 *  Receive the same props as `Pagination` component.
 *
 * @returns {JSX.Element}
 */

var Pagination = function Pagination(props) {
  // We have to handle this situation to avoid problems
  // with multiple "empty message strings" provided by react-admin
  // I've to create a PR to the primary project?
  var _useListPaginationCon = useListPaginationContext(props),
      total = _useListPaginationCon.total;

  if (total === 0) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(Pagination$1, props);
};

var _excluded$H = ["linkType", "primaryComponent", "primaryComponentProps", "primarySource", "secondaryComponent", "secondaryComponentProps", "secondarySource", "tertiaryComponent", "tertiaryComponentProps", "tertiarySource", "components"];
/**
 * Define simple list designed to work with `ReferenceManyField` component.
 * This simple list is "componentable" like any other magic crud element.
 * You can construct your simple list by providing many options.
 *
 * @param {Object} props
 * @param {String|Boolean|Function} props.linkType
 *  The type of link to use for the list.
 *  It can be:
 *   - a function referencing record: `(record, id) => link`;
 *   - false to disable links: `false`;
 *   - static string;
 *
 * @param {String} props.primarySource
 *  Name of the primary source to display.
 *  If no component is provided (`primaryComponent`),
 *  the primary source will be displayed as a string.
 *
 * @param {String} props.primaryComponent
 *  Name of the primary component to display.
 *  If specified, the component will receive the primary source as a prop
 *  and will be responsible for rendering the primary source.
 *
 * @param {Object|null} props.primaryComponentProps
 *  Additional props to pass to the primary component.
 *
 * @param {String|null} props.secondarySource
 *  Name of the secondary source to display.
 *  If no component is provided (`secondaryComponent`),
 *  the secondary source will be displayed as a string.
 *
 * @param {String|null} props.secondaryComponent
 *  Name of the secondary component to display.
 *  If specified, the component will receive the secondary source as a prop
 *  and will be responsible for rendering the secondary source.
 *
 * @param {Object|null} props.secondaryComponentProps
 *  Additional props to pass to the secondary component.
 *
 * @param {String|null} props.tertiarySource
 *  Name of the tertiary source to display.
 *  If no component is provided (`tertiaryComponent`),
 *  the tertiary source will be displayed as a string.
 *
 * @param {String|null} props.tertiaryComponent
 *  Name of the tertiary component to display.
 *  If specified, the component will receive the tertiary source as a prop
 *  and will be responsible for rendering the tertiary source.
 *
 * @param {Object|null} props.tertiaryComponentProps
 *  Additional props to pass to the tertiary component.
 *
 * @param {Object} components
 *  A dictionary of components renderable by name.
 *
 * @returns {JSX.Element}
 *
 * @example
 *  // Display list with custom component for the date.
 * 	<SimpleList
 *    linkType={(record, id) => `example/${id}`}
 *    primarySource="name"
 *    secondarySource="created"
 *    secondaryComponent="DateField"
 *    secondaryComponentProps={{ showTime: true }}
 *
 *    components={{
 *      DateField
 *    }}
 *  />
 */

var SimpleList = function SimpleList(_ref) {
  var _ref$linkType = _ref.linkType,
      linkType = _ref$linkType === void 0 ? undefined : _ref$linkType,
      _ref$primaryComponent = _ref.primaryComponent,
      primaryComponent = _ref$primaryComponent === void 0 ? undefined : _ref$primaryComponent,
      _ref$primaryComponent2 = _ref.primaryComponentProps,
      primaryComponentProps = _ref$primaryComponent2 === void 0 ? undefined : _ref$primaryComponent2,
      primarySource = _ref.primarySource,
      secondaryComponent = _ref.secondaryComponent,
      secondaryComponentProps = _ref.secondaryComponentProps,
      secondarySource = _ref.secondarySource,
      tertiaryComponent = _ref.tertiaryComponent,
      tertiaryComponentProps = _ref.tertiaryComponentProps,
      tertiarySource = _ref.tertiarySource,
      components = _ref.components,
      props = _objectWithoutProperties(_ref, _excluded$H);

  if ((props === null || props === void 0 ? void 0 : props.total) <= 0 && props !== null && props !== void 0 && props.empty) {
    return props === null || props === void 0 ? void 0 : props.empty;
  }

  return /*#__PURE__*/React__default.createElement(SimpleList$1, _extends({}, props, {
    primaryText: function primaryText(record) {
      return primaryComponent ? /*#__PURE__*/React__default.createElement(Component, {
        record: record,
        source: primarySource,
        componentProps: primaryComponentProps,
        component: primaryComponent,
        components: components
      }) : get$1(record, primarySource);
    },
    secondaryText: function secondaryText(record) {
      return secondaryComponent ? /*#__PURE__*/React__default.createElement(Component, {
        record: record,
        source: secondarySource,
        component: secondaryComponent,
        componentProps: _objectSpread2(_objectSpread2({}, secondaryComponentProps), {}, {
          addLabel: false
        }),
        components: components
      }) : get$1(record, secondarySource);
    },
    tertiaryText: function tertiaryText(record) {
      return tertiaryComponent ? /*#__PURE__*/React__default.createElement(Component, {
        record: record,
        source: tertiarySource,
        component: tertiaryComponent,
        componentProps: tertiaryComponentProps,
        components: components
      }) : get$1(record, tertiarySource);
    },
    linkType: linkType
  }));
};
var SimpleListProps = SimpleList;
SimpleListProps.propTypes = {
  linkType: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  primarySource: PropTypes.string.isRequired,
  secondarySource: PropTypes.string,
  tertiarySource: PropTypes.string
};

var SorryMessage = function SorryMessage(_ref) {
  var sorryText = _ref.sorryText,
      classes = _ref.classes;
  var translate = useTranslate$1();
  return /*#__PURE__*/React__default.isValidElement(sorryText) ? /*#__PURE__*/React__default.cloneElement(sorryText, {
    key: "sorry"
  }) : /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.sorry,
    key: "sorry",
    variant: "body2"
  }, translate(sorryText));
};

var useStyles$o = makeStyles(function () {
  return {
    root: {}
  };
}, {
  name: "FobReferenceListFieldToolbar"
});
/**
 * Basic toolbar to handle referenced records in to `<ReferenceListField />`.
 * You can customize the toolbar style overriding **FobReferenceListFieldToolbar**
 * styles in your theme.
 *
 * @param {Object} props
 * @param {Object} props.additionalData
 *  Additional data to pass when create button is pressed.
 *  **Additional data is passed to the new record form.**
 *
 * @param {Object} props.createLabel
 *  Label to use for the create button.
 *
 * @param {Object} props.record
 * 	Record for which the list of referenced records is displayed.
 *
 * @param {String} props.reference
 *  Reference column to filter the list of referenced records.
 *  For example if you need to filter blog-post-comments by blog-post,
 *  then you should pass `blog-post-comments`
 *
 * @param {String} props.target
 *  Foreign key column to filter the list of referenced records.
 *  For example, if you need to filter blog-post-comments by blog-post,
 *  then you should pass `blog_post_id` as the target.
 *
 * @returns {JSX.Element}
 */

var Toolbar$1 = function Toolbar(_ref) {
  var additionalData = _ref.additionalData,
      _ref$createLabel = _ref.createLabel,
      createLabel = _ref$createLabel === void 0 ? "ra.action.create" : _ref$createLabel,
      record = _ref.record,
      reference = _ref.reference,
      resource = _ref.resource,
      target = _ref.target;
  var classes = useStyles$o();
  var translate = useTranslate$1();
  return /*#__PURE__*/React__default.createElement(TopToolbar, {
    resource: resource,
    className: classes.root
  }, /*#__PURE__*/React__default.createElement(Button$1, {
    component: Link,
    disableElevation: true,
    variant: "outlined",
    color: "primary",
    to: {
      pathname: "/".concat(reference, "/create"),
      search: stringify({
        source: JSON.stringify(_objectSpread2(_defineProperty({}, target, record === null || record === void 0 ? void 0 : record.id), additionalData))
      })
    }
  }, translate(createLabel)));
};

var ValidationError = function ValidationError(_ref) {
  var classes = _ref.classes,
      submitError = _ref.submitError;
  return submitError && typeof submitError === "string" && /*#__PURE__*/React__default.createElement(FormHelperText, {
    error: true,
    className: classes.error,
    dangerouslySetInnerHTML: {
      __html: submitError
    }
  }) || null;
};

/**
 *
 * @param {Object} props
 * @param {String} props.resource
 *  Parent resource name for which generate back redirect.
 *  For example, if you are handling "blog-post-comments" resource and
 *  you want to redirect to "blog-posts" resource, then you should pass "blog-posts".
 * @param {Object} props.record
 *  Parent record for which generate back redirect.
 *
 * @param {String} props.defaultRedirect
 *  Default redirect to use instead of the generated one.
 *
 * @returns {String}
 *  Returns back redirect that can be used using `useRedirect` hook from `react-admin`.
 *
 */

var useMakeRedirect = function useMakeRedirect(_ref) {
  var resource = _ref.resource,
      record = _ref.record,
      _ref$tab = _ref.tab,
      tab = _ref$tab === void 0 ? 0 : _ref$tab,
      defaultRedirect = _ref.defaultRedirect;
  return useMemo$1(function () {
    return defaultRedirect || tab > 0 ? "/".concat(resource, "/").concat(record === null || record === void 0 ? void 0 : record.id, "/").concat(tab) : "/".concat(resource, "/").concat(record === null || record === void 0 ? void 0 : record.id);
  }, [resource, record, tab, defaultRedirect]);
};

var _excluded$G = ["additionalData", "columns", "components", "create", "createLabel", "empty", "filter", "mobileBreakpoint", "mobileLinkType", "mobilePrimaryComponent", "mobilePrimaryComponentProps", "mobilePrimaryText", "mobileSecondaryComponent", "mobileSecondaryComponentProps", "mobileSecondaryText", "mobileTertiaryComponent", "mobileTertiaryComponentProps", "mobileTertiaryText", "modify", "modifyLabel", "reference", "remove", "removeLabel", "removeRedirect", "sorry", "tab", "target", "foreignKey"];
var useStyles$n = makeStyles(function (theme) {
  return {
    root: {
      // "& .MuiFormLabel-root": {
      //   padding: theme.spacing(1),
      // },
      "& .MuiCardContent-root:first-child": {
        padding: theme.spacing(1),
        paddingTop: 0,
        paddingBottom: 0
      },
      "& .MuiTablePagination-toolbar > .MuiTablePagination-input > div": {
        // Fix alignment of the input with consecutive pagination buttons
        paddingTop: theme.spacing(1)
      }
    },
    toolbar: {},
    sorry: {
      padding: theme.spacing(2),
      paddingTop: 0,
      paddingBottom: 0
    },
    empty: {
      padding: theme.spacing(2),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5)
    },
    error: {
      padding: theme.spacing(1)
    }
  };
}, {
  name: "FobReferenceListField"
});
/**
 * Render list of records related to the current record.
 * Use `ReferenceManyField` inside to retrieve and display data.
 * This component can be customized in many ways, please referer to the
 * current documentation to understand how to use it.
 *
 * @param {Object} props
 * @param {Object|null} props.additionalData
 *  Additional data to pass to referenced record's form when creating a new record.
 * @param {Array|null} props.columns
 *  List of dynamic columns to render inside this component.
 *  This prop is used by the Crud Engine to automatically render dynamic columns.
 *  You should not use this prop directly and specify children instead.
 *
 * @param {Object} props.components
 *  Components to use for rendering the list of referenced records.
 *  This prop is used by the Crud Engine to automatically render dynamic columns.
 *  This prop is used too by SimpleList, in mobile view, to render dynamic columns.
 *
 * @param {Boolean} props.create
 *  Whether to display the create button.
 *
 * @param {String} props.createLabel
 *  Label to use for the create button.
 *
 * @param {String|Function|JSX.Element} props.empty
 *  Message to display when there are no records to display.
 *
 * @param {Object} props.filter
 *  Filter to apply to the list of referenced records.
 *
 * @param {String} props.mobileBreakpoint
 *  Breakpoint at which the list of referenced records is displayed
 *  in a mobile view (SimpleList).
 *
 * @param {String|Boolean|Function} props.linkType
 *  The type of link to use for the list.
 *  It can be:
 *   - a function referencing record: `(record, id) => link`;
 *   - false to disable links: `false`;
 *   - static string;
 *
 * @param {String} props.mobilePrimaryText
 *  Name of the primary source to display.
 *  If no component is provided (`primaryComponent`),
 *  the primary source will be displayed as a string.
 *
 * @param {String} props.mobilePrimaryComponent
 *  Name of the primary component to display.
 *  If specified, the component will receive the primary source as a prop
 *  and will be responsible for rendering the primary source.
 *
 * @param {Object|null} props.mobilePrimaryComponentProps
 *  Additional props to pass to the primary component.
 *
 * @param {String|null} props.mobileSecondaryText
 *  Name of the secondary source to display.
 *  If no component is provided (`secondaryComponent`),
 *  the secondary source will be displayed as a string.
 *
 * @param {String|null} props.mobileSecondaryComponent
 *  Name of the secondary component to display.
 *  If specified, the component will receive the secondary source as a prop
 *  and will be responsible for rendering the secondary source.
 *
 * @param {Object|null} props.mobileSecondaryComponentProps
 *  Additional props to pass to the secondary component.
 *
 * @param {String|null} props.mobileTertiaryText
 *  Name of the tertiary source to display.
 *  If no component is provided (`tertiaryComponent`),
 *  the tertiary source will be displayed as a string.
 *
 * @param {String|null} props.mobileTertiaryComponent
 *  Name of the tertiary component to display.
 *  If specified, the component will receive the tertiary source as a prop
 *  and will be responsible for rendering the tertiary source.
 *
 * @param {Object|null} props.mobileTertiaryComponentProps
 *  Additional props to pass to the tertiary component.
 *
 * @param {Boolean} props.modify
 *  Whether to display the modify button.
 *
 * @param {String} props.modifyLabel
 *  Label to use for the modify button.
 *
 * @param {String} props.reference
 *  Referenced records resource name.
 *
 * @param {Boolean} props.remove
 *  Whether to display the remove button.
 *
 * @param {String} props.removeLabel
 *  Label to use for the remove button.
 *
 * @param {String|null} props.removeRedirect
 *  Default redirect to use after removing a referenced record.
 *  This is a string, if not specified is automatically generated based on
 *  current opened record and specified tab.
 *
 * @param {String|Function|JSX.Element} props.sorry
 *  Message to display when the list of referenced records is inside newly created record.
 *
 * @param {Number} props.tab
 *  Tab index where this field is located.
 *  Tab is used to generate default redirect to use after removing a referenced record.
 *
 * @param {String} props.target
 *  Target column to filter with current record primary key.
 *  Suppose you are retrieving blog-post-comments, your target column should be `blog_post_id`.
 *
 * @param {Object} props.record
 *  Current record (used for many things).
 *
 * @param {String} props.foreignKey
 *  Foreign key to use to filter the list of referenced records.
 *  Default is `id`.
 *  Suppose you are retrieving blog-post-comments, your foreign key should be `id`.
 * @returns {JSX.Element}
 */

var ReferenceListField = function ReferenceListField(_ref) {
  var additionalData = _ref.additionalData,
      _ref$columns = _ref.columns,
      columns = _ref$columns === void 0 ? [] : _ref$columns,
      _ref$components = _ref.components,
      components = _ref$components === void 0 ? {} : _ref$components,
      _ref$create = _ref.create,
      create = _ref$create === void 0 ? true : _ref$create,
      _ref$createLabel = _ref.createLabel,
      createLabel = _ref$createLabel === void 0 ? "ra.action.create" : _ref$createLabel,
      _ref$empty = _ref.empty,
      empty = _ref$empty === void 0 ? "ra.no_results" : _ref$empty,
      filter = _ref.filter,
      mobileBreakpoint = _ref.mobileBreakpoint,
      _ref$mobileLinkType = _ref.mobileLinkType,
      mobileLinkType = _ref$mobileLinkType === void 0 ? false : _ref$mobileLinkType,
      _ref$mobilePrimaryCom = _ref.mobilePrimaryComponent,
      mobilePrimaryComponent = _ref$mobilePrimaryCom === void 0 ? null : _ref$mobilePrimaryCom,
      _ref$mobilePrimaryCom2 = _ref.mobilePrimaryComponentProps,
      mobilePrimaryComponentProps = _ref$mobilePrimaryCom2 === void 0 ? null : _ref$mobilePrimaryCom2,
      _ref$mobilePrimaryTex = _ref.mobilePrimaryText,
      mobilePrimaryText = _ref$mobilePrimaryTex === void 0 ? null : _ref$mobilePrimaryTex,
      _ref$mobileSecondaryC = _ref.mobileSecondaryComponent,
      mobileSecondaryComponent = _ref$mobileSecondaryC === void 0 ? null : _ref$mobileSecondaryC,
      _ref$mobileSecondaryC2 = _ref.mobileSecondaryComponentProps,
      mobileSecondaryComponentProps = _ref$mobileSecondaryC2 === void 0 ? null : _ref$mobileSecondaryC2,
      _ref$mobileSecondaryT = _ref.mobileSecondaryText,
      mobileSecondaryText = _ref$mobileSecondaryT === void 0 ? null : _ref$mobileSecondaryT,
      _ref$mobileTertiaryCo = _ref.mobileTertiaryComponent,
      mobileTertiaryComponent = _ref$mobileTertiaryCo === void 0 ? null : _ref$mobileTertiaryCo,
      _ref$mobileTertiaryCo2 = _ref.mobileTertiaryComponentProps,
      mobileTertiaryComponentProps = _ref$mobileTertiaryCo2 === void 0 ? null : _ref$mobileTertiaryCo2,
      _ref$mobileTertiaryTe = _ref.mobileTertiaryText,
      mobileTertiaryText = _ref$mobileTertiaryTe === void 0 ? null : _ref$mobileTertiaryTe,
      _ref$modify = _ref.modify,
      modify = _ref$modify === void 0 ? true : _ref$modify;
      _ref.modifyLabel;
      var reference = _ref.reference,
      _ref$remove = _ref.remove,
      remove = _ref$remove === void 0 ? true : _ref$remove;
      _ref.removeLabel;
      var removeRedirect = _ref.removeRedirect,
      _ref$sorry = _ref.sorry,
      sorry = _ref$sorry === void 0 ? "ra.reference_list.sorry" : _ref$sorry,
      _ref$tab = _ref.tab,
      tab = _ref$tab === void 0 ? 0 : _ref$tab,
      target = _ref.target,
      _ref$foreignKey = _ref.foreignKey,
      foreignKey = _ref$foreignKey === void 0 ? "id" : _ref$foreignKey,
      props = _objectWithoutProperties(_ref, _excluded$G);

  var classes = useStyles$n();
  var resource = props.resource,
      record = props.record;

  var _useInput = useInput(_objectSpread2({}, props)),
      submitError = _useInput.meta.submitError;

  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down(mobileBreakpoint !== null && mobileBreakpoint !== void 0 ? mobileBreakpoint : "sm");
  });
  var parentRecordExists = useMemo$1(function () {
    return (record === null || record === void 0 ? void 0 : record.id) > 0;
  }, [record === null || record === void 0 ? void 0 : record.id]);
  var removeRedir = useMakeRedirect({
    resource: resource,
    record: record,
    tab: tab,
    defaultRedirect: removeRedirect
  });
  var content = parentRecordExists ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ReferenceManyField, _extends({}, props, {
    empty: /*#__PURE__*/React__default.createElement(EmptyMessage, {
      classes: classes,
      emptyText: empty
    }),
    reference: reference,
    target: target,
    filter: _objectSpread2(_defineProperty({}, target, get$1(record, foreignKey)), filter),
    pagination: /*#__PURE__*/React__default.createElement(Pagination, null)
  }), isMobile && mobileBreakpoint !== false && mobilePrimaryText !== null ? /*#__PURE__*/React__default.createElement(SimpleList, {
    primarySource: mobilePrimaryText,
    primaryComponent: mobilePrimaryComponent,
    primaryComponentProps: mobilePrimaryComponentProps,
    secondarySource: mobileSecondaryText,
    secondaryComponent: mobileSecondaryComponent,
    secondaryComponentProps: mobileSecondaryComponentProps,
    tertiarySource: mobileTertiaryText,
    tertiaryComponent: mobileTertiaryComponent,
    tertiaryComponentProps: mobileTertiaryComponentProps,
    linkType: mobileLinkType,
    components: components
  }) : /*#__PURE__*/React__default.createElement(Datagrid, {
    inner: true
  }, React__default.Children.map(props.children, function (field, index) {
    return /*#__PURE__*/React__default.isValidElement(field) ? /*#__PURE__*/React__default.cloneElement(field, {
      key: index
    }) : null;
  }), Component.mapColumns(columns, components, {
    disabled: props.disabled
  }), !props.disabled && modify && /*#__PURE__*/React__default.createElement(EditButton$1, null), !props.disabled && remove && /*#__PURE__*/React__default.createElement(DeleteWithConfirmButton, {
    redirect: removeRedir
  }))), /*#__PURE__*/React__default.createElement(ValidationError, {
    submitError: submitError,
    classes: classes
  }), !props.disabled && create && parentRecordExists > 0 && /*#__PURE__*/React__default.createElement(Toolbar$1, {
    additionalData: additionalData,
    createLabel: createLabel,
    record: record,
    reference: reference,
    resource: resource,
    target: target
  })) : /*#__PURE__*/React__default.createElement(SorryMessage, {
    sorryText: sorry,
    classes: classes
  });
  return (props === null || props === void 0 ? void 0 : props.addLabel) !== false ? /*#__PURE__*/React__default.createElement(Labeled, _extends({}, props, {
    label: props === null || props === void 0 ? void 0 : props.label,
    className: classes.root,
    fullWidth: props === null || props === void 0 ? void 0 : props.fullWidth
  }), content) : content;
};

ReferenceListField.propTypes = {
  tab: PropTypes.number,
  sorry: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
  mobileBreakpoint: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  mobilePrimaryText: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.string]),
  mobilePrimaryComponent: PropTypes.string,
  mobilePrimaryComponentProps: PropTypes.object,
  mobileSecondaryText: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.string]),
  mobileSecondaryComponent: PropTypes.string,
  mobileSecondaryComponentProps: PropTypes.object,
  mobileTertiaryText: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.string]),
  mobileTertiaryComponent: PropTypes.string,
  mobileTertiaryComponentProps: PropTypes.object,
  mobileLinkType: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  additionalData: PropTypes.object,
  removeRedirect: PropTypes.string,
  filter: PropTypes.object,
  create: PropTypes.bool,
  createLabel: PropTypes.string,
  modify: PropTypes.bool,
  modifyLabel: PropTypes.string,
  remove: PropTypes.bool,
  removeLabel: PropTypes.string,
  source: PropTypes.string,
  reference: PropTypes.string,
  target: PropTypes.string,
  record: PropTypes.object,
  resource: PropTypes.string,
  children: PropTypes.node,
  columns: PropTypes.array
};

var _excluded$F = ["label", "record", "resource"];
var useStyles$m = makeStyles(function (theme) {
  return {
    chip: {
      padding: theme.spacing(1),
      height: "100%"
    }
  };
});

var StateField = function StateField(_ref) {
  _ref.label;
      var record = _ref.record,
      toResolve = _ref.resource;
      _objectWithoutProperties(_ref, _excluded$F);

  var classes = useStyles$m();

  var _useContext = useContext(WorkflowContext),
      getWorkflow = _useContext.getWorkflow;

  var resource = useMemo$1(function () {
    return toResolve.replace("workflow/transactions/", "");
  }, [toResolve]);
  var workflow = useMemo$1(function () {
    return getWorkflow(resource);
  }, [resource, getWorkflow]);
  var state = useMemo$1(function () {
    return workflow && workflow.getState(_objectSpread2(_objectSpread2({}, record), {}, {
      transaction: get$1(record, "transaction", record)
    })) || undefined;
  }, [record, workflow]);
  return /*#__PURE__*/React__default.createElement(Chip, {
    className: classes.chip,
    color: "primary",
    label: /*#__PURE__*/React__default.createElement(LongTextField, {
      variant: "body2",
      maxWidth: 200,
      record: state,
      source: "name"
    })
  });
};

var useStyles$l = makeStyles(function (theme) {
  return {
    root: {
      fontWeight: "bold"
    }
  };
});
/**
 * Allow to display the state of a workflow based on the current record.
 * This field display the 'name' and 'description' of current state inside an alert.
 *
 * You can customize few options, if you want to use just the informations
 * necessary to work with the workflow, you can use the 'WorkflowContext' (inside a form)
 * like in the example shown below.
 *
 * @example
 * import { useWorkflow, WorkflowContext } from "ra-friendsofbabba";
 * const { getWorkflow } = useContext(WorkflowContext);
 * const workflow = useMemo(() => getWorkflow(resource), [resource, getWorkflow] );
 * const state = useMemo(() => (workflow && workflow.getState(record)) || undefined, [record, workflow]);
 *
 * // The state object contains many properties like: name,
 * // label and description that you can use
 * // for your own purpose.
 *
 * @param {Object} props
 * @param {String} props.resource The resource for which load the workflow.
 * @param {String} props.severity Severity of the associated allert.
 * @param {String} props.variant Variant of the associated allert.
 * @param {Number} props.elevation Elevation of the associated allert.
 * @param {Object} props.record The record for which display the state.
 * @returns {React.Component}
 */

var StateInfoField = function StateInfoField(_ref) {
  var resource = _ref.resource,
      _ref$severity = _ref.severity,
      severity = _ref$severity === void 0 ? "info" : _ref$severity,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "standard" : _ref$variant,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 0 : _ref$elevation,
      record = _ref.record;

  var _useContext = useContext(WorkflowContext),
      getWorkflow = _useContext.getWorkflow;

  var classes = useStyles$l();
  var workflow = useMemo$1(function () {
    return getWorkflow(resource);
  }, [resource, getWorkflow]);
  var state = useMemo$1(function () {
    return workflow && workflow.getState(record) || undefined;
  }, [record, workflow]);
  return /*#__PURE__*/React__default.createElement(Alert$1, {
    severity: severity,
    variant: variant,
    elevation: elevation
  }, /*#__PURE__*/React__default.createElement(AlertTitle$1, {
    classes: classes
  }, state === null || state === void 0 ? void 0 : state.name), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2"
  }, state === null || state === void 0 ? void 0 : state.description));
};

var useFieldLabel = function useFieldLabel(_ref) {
  var resource = _ref.resource;
  var t = useTranslate$1();
  return function (field) {
    var translate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var label = "resources.".concat(resource, ".fields.").concat(field);
    return translate ? t(label, {
      _: label
    }) : label;
  };
};

var useStyles$k = makeStyles$1(function (theme) {
  return {
    root: {
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      whiteSpace: "break-spaces"
    },
    link: {
      cursor: "pointer",
      fontWeight: "bold"
    },
    visibility: {
      display: "block",
      clear: "both"
    }
  };
});

var TransactionNotesField = function TransactionNotesField(_ref) {
  var _ref$admin = _ref.admin,
      admin = _ref$admin === void 0 ? false : _ref$admin,
      record = _ref.record,
      source = _ref.source,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 150 : _ref$minWidth,
      _ref$maxRows = _ref.maxRows,
      maxRows = _ref$maxRows === void 0 ? 3 : _ref$maxRows,
      component = _ref.component;
  var classes = useStyles$k();
  var fieldLabel = useFieldLabel({
    resource: "transactions"
  });

  var _useMemo = useMemo$1(function () {
    var isPrivate = get$1(record, "is_private", true);
    var value = isPrivate && !admin ? null : get$1(record, source, "");
    var tooLong = value !== null && value.length > 200;
    return {
      isPrivate: isPrivate,
      value: value,
      tooLong: tooLong
    };
  }, [record, admin, source]),
      isPrivate = _useMemo.isPrivate,
      value = _useMemo.value,
      tooLong = _useMemo.tooLong;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showMore = _useState2[0],
      setShowMore = _useState2[1];

  var handleToggle = function handleToggle() {
    return setShowMore(!showMore);
  };

  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Typography, {
    component: component,
    className: classes.root,
    style: {
      minWidth: minWidth,
      WebkitLineClamp: showMore ? null : maxRows
    },
    variant: "body2",
    color: value === null || value.length === 0 ? "textSecondary" : "textPrimary",
    display: "inline"
  }, tooLong === false ? value !== null && value.length > 0 ? value : fieldLabel("notes.empty") : null, tooLong && (showMore ? value : value.substring(0, 200) + "...")), admin && value !== null && value.length > 0 && /*#__PURE__*/React__default.createElement(Typography, {
    component: component,
    color: isPrivate ? "error" : "textSecondary",
    className: classes.visibility,
    variant: "caption"
  }, fieldLabel("notes.".concat(isPrivate ? "private" : "public"))), tooLong && /*#__PURE__*/React__default.createElement(Link$1, {
    underline: "hover",
    className: classes.link,
    onClick: handleToggle
  }, fieldLabel("notes.".concat(showMore ? "show_less" : "show_more"))));
};

TransactionNotesField.propTypes = {
  minWidth: PropTypes.number,
  maxRows: PropTypes.number
};

var _excluded$E = ["fullWidth", "addLabel"],
    _excluded2$a = ["admin", "label"];

var PaginationWrapper = function PaginationWrapper(_ref) {
  _ref.fullWidth;
      _ref.addLabel;
      var props = _objectWithoutProperties(_ref, _excluded$E);

  return /*#__PURE__*/React__default.createElement(Pagination$1, props);
};

var TransactionLogsField = function TransactionLogsField(_ref2) {
  var _props$record;

  var _ref2$admin = _ref2.admin,
      admin = _ref2$admin === void 0 ? false : _ref2$admin;
      _ref2.label;
      var props = _objectWithoutProperties(_ref2, _excluded2$a);

  var _useContext = useContext(WorkflowContext),
      getWorkflow = _useContext.getWorkflow;

  var mobileBreakpoint = useMemo$1(function () {
    return get$1(props, "mobileBreakpoint", "sm");
  }, [props]);
  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down(mobileBreakpoint !== null && mobileBreakpoint !== void 0 ? mobileBreakpoint : "sm");
  });
  var fieldLabel = useFieldLabel({
    resource: "transactions"
  });
  var workflow = useMemo$1(function () {
    return getWorkflow(props.resource);
  }, [getWorkflow, props.resource]);

  if (!workflow || !props.record || (props === null || props === void 0 ? void 0 : (_props$record = props.record) === null || _props$record === void 0 ? void 0 : _props$record.id) <= 0) {
    return null;
  }

  var content = /*#__PURE__*/React__default.createElement(ReferenceManyField, _extends({
    perPage: 5,
    pagination: /*#__PURE__*/React__default.createElement(PaginationWrapper, null),
    reference: "workflow/transactions/".concat(props.resource),
    sort: {
      field: "Transactions.created",
      order: "desc"
    }
  }, props, {
    source: "id",
    target: "id"
  }), isMobile ? /*#__PURE__*/React__default.createElement(SimpleList$1, {
    primaryText: function primaryText(record) {
      return /*#__PURE__*/React__default.createElement(DateField, {
        label: fieldLabel("created"),
        record: record,
        source: "created",
        showTime: true
      });
    },
    secondaryText: function secondaryText(record) {
      return /*#__PURE__*/React__default.createElement(TransactionNotesField, {
        record: record,
        component: "span",
        label: fieldLabel("notes"),
        source: "notes",
        admin: admin,
        sortable: false,
        maxRows: 6
      });
    },
    linkType: false
  }) : /*#__PURE__*/React__default.createElement(Datagrid$1, null, admin && /*#__PURE__*/React__default.createElement(TextField, {
    label: fieldLabel("id"),
    source: "id"
  }), /*#__PURE__*/React__default.createElement(DateField, {
    label: fieldLabel("created"),
    source: "created",
    showTime: true,
    sortBy: "Transactions.created"
  }), /*#__PURE__*/React__default.createElement(TextField, {
    label: fieldLabel("user"),
    source: "user.name",
    sortBy: "Users.username"
  }), /*#__PURE__*/React__default.createElement(TransactionNotesField, {
    label: fieldLabel("notes"),
    source: "notes",
    admin: admin,
    sortable: false,
    maxRows: 6
  }), /*#__PURE__*/React__default.createElement(StateField, {
    label: fieldLabel("state"),
    sortBy: "Transactions.state"
  })));
  return (props === null || props === void 0 ? void 0 : props.addLabel) !== false ? /*#__PURE__*/React__default.createElement(Labeled, _extends({}, props, {
    label: props === null || props === void 0 ? void 0 : props.label,
    fullWidth: props === null || props === void 0 ? void 0 : props.fullWidth
  }), content) : content;
};

var fields = /*#__PURE__*/Object.freeze({
  __proto__: null,
  BooleanField: BooleanField,
  ChipArrayField: ChipArrayField,
  CoverField: CoverField,
  ChipField: ChipField,
  DateAgoField: DateAgoField,
  DateField: DateField,
  EmailField: EmailField,
  LongTextField: LongTextField,
  MediaField: MediaField,
  NotificationField: NotificationField,
  ProgressField: ProgressField,
  ReferenceListField: ReferenceListField,
  StateField: StateField,
  StateInfoField: StateInfoField,
  TextField: TextField,
  TransactionLogsField: TransactionLogsField,
  TransactionNotesField: TransactionNotesField,
  useFieldLabel: useFieldLabel,
  Pagination: Pagination,
  useMakeRedirect: useMakeRedirect
});

var _excluded$D = ["classes", "label", "value", "icon", "className", "syncWithLocation"];

var FormTabHeader = function FormTabHeader(_ref) {
  var classes = _ref.classes,
      label = _ref.label,
      value = _ref.value,
      icon = _ref.icon,
      className = _ref.className,
      syncWithLocation = _ref.syncWithLocation,
      rest = _objectWithoutProperties(_ref, _excluded$D);

  var translate = useTranslate$2();
  var location = useLocation();

  var _useFormState = useFormState(UseFormStateOptions),
      submitFailed = _useFormState.submitFailed,
      submitErrors = _useFormState.submitErrors;

  var formContext = useFormContext();
  var formGroup = useFormGroup(value.toString());
  var submitError = React.useMemo(function () {
    var fields = formContext.getGroupFields(value.toString());
    var errors = fields.some(function (field) {
      return get$1(submitErrors, field) != null;
    });
    return errors;
  }, [submitErrors, formContext, value]);
  var propsForLink = {
    component: Link,
    to: _objectSpread2(_objectSpread2({}, location), {}, {
      pathname: value
    })
  };
  return /*#__PURE__*/React.createElement(Tab, _extends({
    label: /*#__PURE__*/isValidElement(label) ? label : translate(label, {
      _: label
    }),
    value: value,
    icon: icon,
    className: classnames("form-tab", className, _defineProperty({}, classes.errorTabButton, submitError || formGroup.invalid && (formGroup.touched || submitFailed)))
  }, syncWithLocation ? propsForLink : {}, {
    // to avoid TypeScript screams, see https://github.com/mui-org/material-ui/issues/9106#issuecomment-451270521
    id: "tabheader-".concat(value),
    "aria-controls": "tabpanel-".concat(value)
  }, rest));
};

var UseFormStateOptions = {
  subscription: {
    submitFailed: true,
    submitErrors: true
  }
};

var _excluded$C = ["basePath", "className", "classes", "contentClassName", "children", "hidden", "icon", "intent", "label", "margin", "path", "record", "resource", "variant", "value"];
var hiddenStyle = {
  display: "none"
};

var FormTab = function FormTab(props) {
  var basePath = props.basePath,
      className = props.className,
      classes = props.classes,
      contentClassName = props.contentClassName,
      children = props.children,
      hidden = props.hidden,
      icon = props.icon,
      intent = props.intent,
      label = props.label,
      margin = props.margin;
      props.path;
      var record = props.record,
      resource = props.resource,
      variant = props.variant,
      value = props.value,
      rest = _objectWithoutProperties(props, _excluded$C);

  var renderHeader = function renderHeader() {
    return /*#__PURE__*/React.createElement(FormTabHeader, _extends({
      label: label,
      value: value,
      icon: icon,
      className: className,
      classes: classes
    }, rest));
  };

  var renderContent = function renderContent() {
    return /*#__PURE__*/React.createElement(FormGroupContextProvider, {
      name: value.toString()
    }, /*#__PURE__*/React.createElement("span", {
      style: hidden ? hiddenStyle : null,
      className: contentClassName,
      id: "tabpanel-".concat(value),
      "aria-labelledby": "tabheader-".concat(value) // Set undefined instead of false because WAI-ARIA Authoring Practices 1.1
      // notes that aria-hidden="false" currently behaves inconsistently across browsers.
      ,
      "aria-hidden": hidden || undefined
    }, React.Children.map(children, function (input) {
      return input && /*#__PURE__*/React.createElement(FormInput, {
        basePath: basePath,
        input: input,
        record: record,
        resource: resource,
        variant: input.props.variant || variant,
        margin: input.props.margin || margin
      });
    })));
  };

  return intent === "header" ? renderHeader() : renderContent();
};

var _excluded$B = ["children", "spacing", "wrapper"];
/**
 * Renders a group of fields using MUI grids.
 * You can use cascading groups to create a form layout.
 *
 * @returns {React.Component} A React component
 *
 * @example
 * import { Group, GroupItem } from "ra-friendsofbabba";
 *
 * <Group {...props}>
 *     <GroupItem lg={2} md={2} sm={2} xs={12}>
 *         <TextInput source="name" />
 *     </GroupItem>
 *     <GroupItem lg={2} md={2} sm={2} xs={12}>
 *         <TextInput source="lastName" />
 *     </GroupItem>
 * </Group>
 *
 */

var Group = function Group(_ref) {
  var children = _ref.children,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 2 : _ref$spacing,
      _ref$wrapper = _ref.wrapper,
      wrapper = _ref$wrapper === void 0 ? false : _ref$wrapper,
      props = _objectWithoutProperties(_ref, _excluded$B);

  return !wrapper ? /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: spacing
  }, React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.isValidElement(child) ? /*#__PURE__*/React__default.cloneElement(child, _objectSpread2(_objectSpread2({}, props), child.props)) : child;
  })) : React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.isValidElement(child) ? /*#__PURE__*/React__default.cloneElement(child, _objectSpread2(_objectSpread2({}, props), child.props)) : child;
  });
};

var _excluded$A = ["children", "lg", "md", "sm", "xs", "spacing", "block"];

var GroupItem = function GroupItem(_ref) {
  var children = _ref.children,
      _ref$lg = _ref.lg,
      lg = _ref$lg === void 0 ? 4 : _ref$lg,
      _ref$md = _ref.md,
      md = _ref$md === void 0 ? 6 : _ref$md,
      _ref$sm = _ref.sm,
      sm = _ref$sm === void 0 ? 12 : _ref$sm,
      _ref$xs = _ref.xs,
      xs = _ref$xs === void 0 ? 12 : _ref$xs,
      spacing = _ref.spacing;
      _ref.block;
      var props = _objectWithoutProperties(_ref, _excluded$A);

  return /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    lg: lg,
    md: md,
    sm: sm,
    xs: xs,
    spacing: spacing
  }, React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.isValidElement(child) ? /*#__PURE__*/React__default.cloneElement(child, _objectSpread2(_objectSpread2({}, props), child.props)) : child;
  }));
};

var useStyles$j = makeStyles(function (theme) {
  return {
    title: {
      margin: theme.spacing(1),
      fontWeight: "bold"
    },
    spacer: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    subTitle: {
      margin: theme.spacing(1)
    }
  };
});

var GroupTitle = function GroupTitle(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      _ref$divider = _ref.divider,
      divider = _ref$divider === void 0 ? true : _ref$divider,
      color = _ref.color;
  var classes = useStyles$j();
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Typography, {
    color: color,
    classes: {
      root: classes.title
    },
    variant: "h6",
    gutterBottom: true,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), divider && /*#__PURE__*/React__default.createElement(Divider, {
    classes: {
      root: classes.spacer
    }
  }), subTitle && /*#__PURE__*/React__default.createElement(Typography, {
    color: color,
    classes: {
      root: classes.subTitle
    },
    variant: "body1",
    dangerouslySetInnerHTML: {
      __html: subTitle
    }
  }));
};

/**
 *
 * @param {Object} props
 * @param {String} props.backRedirect The redirect url to go back to
 * @param {String} props.backReferenceTarget The reference target to go back to
 * @param {String} props.backReference The reference to go back to
 * @param {Number} props.backTab The tab to go back to
 * @param {Object} props.record The parent record
 * @returns {String}
 */

var useBackUrl = function useBackUrl(_ref) {
  var backRedirect = _ref.backRedirect,
      backReferenceTarget = _ref.backReferenceTarget,
      backReference = _ref.backReference,
      _ref$backTab = _ref.backTab,
      backTab = _ref$backTab === void 0 ? 1 : _ref$backTab,
      record = _ref.record;
  var referenceId = get$1(record, backReferenceTarget, 0);
  return useMemo$1(function () {
    return referenceId === 0 ? backRedirect : backTab > 0 ? "/".concat(backReference, "/").concat(referenceId, "/").concat(backTab) : "/".concat(backReference, "/").concat(referenceId);
  }, [backRedirect, backReference, referenceId, backTab]);
};

var _excluded$z = ["backRedirect", "backReferenceTarget", "backReference", "backTab", "children", "buttons", "components", "mutationMode", "validating", "useWorkflow", "useCustomButtons", "useBackButton", "useDeleteButton", "maxButtonsToDisplay", "stateFilter"];
var useStyles$i = makeStyles(function (theme) {
  return {
    toolbar: {
      "& .MuiButton-root": {
        marginRight: theme.spacing(1)
      },
      justifyContent: function justifyContent(_ref) {
        var useWorkflow = _ref.useWorkflow;
        return useWorkflow ? "flex-start" : "space-between";
      }
    }
  };
}, {
  name: "FobToolbar"
});
/**
 * @param {Object} props
 */

var Toolbar = function Toolbar(_ref2) {
  var backRedirect = _ref2.backRedirect,
      backReferenceTarget = _ref2.backReferenceTarget,
      backReference = _ref2.backReference,
      _ref2$backTab = _ref2.backTab,
      backTab = _ref2$backTab === void 0 ? 1 : _ref2$backTab,
      children = _ref2.children,
      _ref2$buttons = _ref2.buttons,
      buttons = _ref2$buttons === void 0 ? [] : _ref2$buttons,
      _ref2$components = _ref2.components,
      components = _ref2$components === void 0 ? [] : _ref2$components;
      _ref2.mutationMode;
      _ref2.validating;
      var useWorkflow = _ref2.useWorkflow,
      _ref2$useCustomButton = _ref2.useCustomButtons,
      useCustomButtons = _ref2$useCustomButton === void 0 ? false : _ref2$useCustomButton,
      _ref2$useBackButton = _ref2.useBackButton,
      useBackButton = _ref2$useBackButton === void 0 ? true : _ref2$useBackButton,
      _ref2$useDeleteButton = _ref2.useDeleteButton,
      useDeleteButton = _ref2$useDeleteButton === void 0 ? true : _ref2$useDeleteButton,
      _ref2$maxButtonsToDis = _ref2.maxButtonsToDisplay,
      maxButtonsToDisplay = _ref2$maxButtonsToDis === void 0 ? 1 : _ref2$maxButtonsToDis,
      stateFilter = _ref2.stateFilter,
      props = _objectWithoutProperties(_ref2, _excluded$z);

  var form = useForm();
  var classes = useStyles$i({
    useWorkflow: useWorkflow
  });
  var backUrl = useBackUrl(_objectSpread2({
    backRedirect: backRedirect,
    backReferenceTarget: backReferenceTarget,
    backReference: backReference,
    backTab: backTab
  }, props));
  var handleSubmitWithRedirect = props.handleSubmitWithRedirect,
      record = props.record;

  var _useGetIdentity = useGetIdentity(),
      loading = _useGetIdentity.loading,
      loaded = _useGetIdentity.loaded,
      identity = _useGetIdentity.identity;

  var roles = useMemo$1(function () {
    return !loading && loaded ? identity === null || identity === void 0 ? void 0 : identity.roles : [];
  }, [loading, loaded, identity]);

  var _useContext = useContext(WorkflowContext),
      getWorkflow = _useContext.getWorkflow;

  var workflow = useMemo$1(function () {
    return useWorkflow ? getWorkflow(props.resource) : null;
  }, [getWorkflow, useWorkflow, props.resource]);

  var _useMemo = useMemo$1(function () {
    var save = workflow && workflow.canEdit(roles, record) && get$1(record, "id", 0) > 0;
    var states = workflow && workflow.getNextStates(roles, record) || [];
    return {
      states: states,
      save: save
    };
  }, [workflow, record, roles]),
      states = _useMemo.states,
      save = _useMemo.save;

  var statesToDisplay = useMemo$1(function () {
    return stateFilter ? states.filter(stateFilter) : states;
  }, [states, stateFilter]);
  var handleClick = useCallback(function () {
    form.change("state", get$1(record, "transaction.state", get$1(record, "state")));
    handleSubmitWithRedirect("list");
  }, [form, record, handleSubmitWithRedirect]);

  if (!record) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(Toolbar$3, _extends({}, props, {
    classes: classes
  }), (!useWorkflow && !useCustomButtons || save) && /*#__PURE__*/React__default.createElement(SaveButton, _extends({}, props, {
    color: "primary",
    redirect: backUrl,
    handleSubmitWithRedirect: useWorkflow ? handleClick : handleSubmitWithRedirect,
    disabled: props.saving
  })), statesToDisplay.length > maxButtonsToDisplay && /*#__PURE__*/React__default.createElement(StateButtonMenu, _extends({
    states: statesToDisplay
  }, props, {
    disabled: props.saving
  })), statesToDisplay.length <= maxButtonsToDisplay && statesToDisplay.map(function (state) {
    return /*#__PURE__*/React__default.createElement(StateButton$1, _extends({
      key: get$1(state, "code"),
      state: state
    }, props, {
      disabled: props.saving
    }));
  }), React__default.Children.count(children) > 0 && React__default.Children.map(children, function (child, key) {
    return /*#__PURE__*/React__default.cloneElement(child, _objectSpread2(_objectSpread2({}, props), {}, {
      key: key
    }));
  }), buttons && buttons.map(function (_ref3, index) {
    var component = _ref3.component,
        componentProps = _ref3.componentProps;
    return /*#__PURE__*/React__default.createElement(Component, {
      key: index,
      addLabel: false,
      component: component,
      componentProps: _objectSpread2(_objectSpread2({}, props), componentProps),
      components: components
    });
  }), !useWorkflow && !useCustomButtons && useDeleteButton && (record === null || record === void 0 ? void 0 : record.id) > 0 && /*#__PURE__*/React__default.createElement(DeleteWithConfirmButton, {
    redirect: backUrl
  }), (useWorkflow || !useCustomButtons) && useBackButton && /*#__PURE__*/React__default.createElement(BackButton, {
    to: backUrl
  }));
};

var _excluded$y = ["children"];

var Unprop = function Unprop(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded$y);

  return React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.isValidElement(child) ? /*#__PURE__*/React__default.cloneElement(child, _objectSpread2(_objectSpread2({}, props), child.props)) : child;
  });
};

var parseField = function parseField(field) {
  var match = field.match(/\d+/);
  var number = match ? parseInt(match[0], 10) + 1 : null;
  var name = field.replace(/\d+/, "n");
  return {
    number: number,
    name: name
  };
};

var useStyles$h = makeStyles(function (theme) {
  return {
    subheaderRoot: {
      padding: theme.spacing(1),
      paddingTop: 0,
      paddingBottom: 0
    },
    listItemRoot: {
      marginLeft: theme.spacing(1)
    },
    listRoot: {
      "& .MuiList-root": {
        margin: 0,
        padding: 0,
        paddingLeft: theme.spacing(3),
        "& li:last-child": {
          borderBottom: "1px solid ".concat(theme.palette.divider)
        }
      }
    }
  };
});

var ValidationItem = function ValidationItem(_ref) {
  var resource = _ref.resource,
      field = _ref.field,
      error = _ref.error,
      translate = _ref.translate,
      component = _ref.component;

  var _parseField = parseField(field),
      number = _parseField.number,
      name = _parseField.name;

  var classes = useStyles$h();
  return typeof error === "string" ? /*#__PURE__*/React__default.createElement(ListItem, {
    dense: true,
    disableGutters: true,
    classes: {
      root: classes.listItemRoot
    }
  }, /*#__PURE__*/React__default.isValidElement(component) ? /*#__PURE__*/React__default.cloneElement(component, {
    error: error,
    field: field,
    number: number,
    resource: resource
  }) : /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(ListItemAvatar, null, /*#__PURE__*/React__default.createElement(Avatar, null, /*#__PURE__*/React__default.createElement(Warning, null))), /*#__PURE__*/React__default.createElement(ListItemText, {
    primary: translate("errors.".concat(resource, ".").concat(name), {
      number: number
    }),
    secondary: /*#__PURE__*/React__default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: error
      }
    })
  }))) : /*#__PURE__*/React__default.createElement(List$1, {
    classes: {
      root: classes.listRoot
    }
  }, /*#__PURE__*/React__default.createElement(ListSubheader, {
    disableGutters: true,
    disableSticky: true,
    classes: {
      root: classes.subheaderRoot
    }
  }, translate("errors.".concat(resource, ".subheader.").concat(name), {
    number: number
  })), Object.keys(error).map(function (subField) {
    return /*#__PURE__*/React__default.createElement(ValidationItem, {
      key: subField,
      field: "".concat(field, ".").concat(subField),
      error: error[subField],
      resource: resource,
      translate: translate,
      component: component
    });
  }));
};

var mapFieldErrors = function mapFieldErrors(field, errors) {
  var keys = Object.keys(errors);
  var messages = keys.filter(function (k) {
    return typeof errors[k] === "string";
  });

  if (typeof errors === "string") {
    return _defineProperty({}, field, errors);
  } else if (messages.length > 0 && isNaN(parseInt(field))) {
    return _defineProperty({}, field, messages.map(function (m) {
      return errors[m];
    }).join("\n"));
  } else {
    var out = keys.reduce(function (errorMap, key) {
      return _objectSpread2(_objectSpread2({}, errorMap), mapFieldErrors(key, errors[key]));
    }, {});
    return Object.keys(out).length > 0 ? _defineProperty({}, field, out) : {};
  }
};

var cakephpErrorMapper = function cakephpErrorMapper(errors) {
  var fields = Object.keys(errors);
  var validationErrors = fields.reduce(function (errorsMap, field) {
    return _objectSpread2(_objectSpread2({}, errorsMap), mapFieldErrors(field, errors[field]));
  }, {});
  return validationErrors;
};

var createErrorMapper = function createErrorMapper() {
  return function (error, notify) {
    var errors = get$1(error, "body.data.errors");
    var message = get$1(error, "body.data.message", error === null || error === void 0 ? void 0 : error.message);

    if (message) {
      notify(message, {
        type: "error"
      });
    }

    if (errors) {
      var mappedErrors = cakephpErrorMapper(errors);
      return mappedErrors;
    } else {
      return false;
    }
  };
};

var useValidationSummary = function useValidationSummary() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    groupName: undefined,
    source: "validationErrors"
  },
      groupName = _ref.groupName,
      source = _ref.source;

  var _useFormState = useFormState({
    subscription: {
      submitFailed: true,
      submitErrors: true
    }
  }),
      submitErrors = _useFormState.submitErrors;

  var formContext = useFormContext();
  var defaultGroupName = useFormGroupContext();
  var group = groupName || defaultGroupName;

  var _useFormState2 = useFormState({
    subscription: {
      values: true
    }
  }),
      values = _useFormState2.values;

  return useMemo$1(function () {
    var validationErrors = get$1(values, source);
    var loading = validationErrors === undefined && values.id > 0;
    var mode = values.id > 0 ? "edit" : "create";
    var fields = formContext.getGroupFields(group);
    var errors = fields.filter(function (field) {
      return get$1(submitErrors, field) != null || get$1(validationErrors, field) != null;
    });
    var errorMaps = errors.length > 0 ? errors.reduce(function (acc, field) {
      return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, field, get$1(submitErrors, field) || get$1(validationErrors, field)));
    }, {}) : {};
    var errorMap = cakephpErrorMapper(errorMaps);
    return {
      errorsCount: Object.keys(errorMap).length,
      errorKeys: errors,
      errorMap: errorMap,
      loading: loading,
      mode: mode
    };
  }, [submitErrors, formContext, values, source, group]);
};

var useStyles$g = makeStyles(function (theme) {
  return {
    progress: {
      margin: theme.spacing(1)
    },
    spaced: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2)
    }
  };
});

var detectState = function detectState(_ref) {
  var errorsCount = _ref.errorsCount,
      mode = _ref.mode,
      loading = _ref.loading;
  return mode === "create" ? "explain" : loading ? "loading" : errorsCount > 0 ? "warning" : "success";
};

var ValidationSummary = function ValidationSummary(_ref2) {
  var _ref2$elevation = _ref2.elevation,
      elevation = _ref2$elevation === void 0 ? 1 : _ref2$elevation,
      _ref2$spaced = _ref2.spaced,
      spaced = _ref2$spaced === void 0 ? true : _ref2$spaced,
      _ref2$source = _ref2.source,
      source = _ref2$source === void 0 ? "validationErrors" : _ref2$source,
      _ref2$title = _ref2.title,
      title = _ref2$title === void 0 ? {
    warning: "ra.validation_summary.title.warning",
    success: "ra.validation_summary.title.success",
    loading: "ra.validation_summary.title.loading",
    explain: "ra.validation_summary.title.explain"
  } : _ref2$title,
      _ref2$message = _ref2.message,
      message = _ref2$message === void 0 ? {
    warning: "ra.validation_summary.message.warning",
    success: "ra.validation_summary.message.success",
    loading: "ra.validation_summary.message.loading",
    explain: "ra.validation_summary.message.explain"
  } : _ref2$message,
      _ref2$showWhenNoError = _ref2.showWhenNoErrors,
      showWhenNoErrors = _ref2$showWhenNoError === void 0 ? true : _ref2$showWhenNoError,
      resource = _ref2.resource,
      children = _ref2.children;
  var classes = useStyles$g();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var translate = useTranslate$2();

  var _useValidationSummary = useValidationSummary({
    source: source
  }),
      errorsCount = _useValidationSummary.errorsCount,
      errorKeys = _useValidationSummary.errorKeys,
      errorMap = _useValidationSummary.errorMap,
      loading = _useValidationSummary.loading,
      mode = _useValidationSummary.mode;

  var _useMemo = useMemo$1(function () {
    return {
      groupTitle: title[detectState({
        errorsCount: errorsCount,
        mode: mode,
        loading: loading
      })],
      groupMessage: message[detectState({
        errorsCount: errorsCount,
        mode: mode,
        loading: loading
      })],
      severity: loading || mode === "create" ? "info" : errorsCount > 0 ? "warning" : "success"
    };
  }, [errorsCount, loading, mode, message, title]),
      groupTitle = _useMemo.groupTitle,
      groupMessage = _useMemo.groupMessage,
      severity = _useMemo.severity;

  var toggleExpand = useCallback(function () {
    return setExpanded(function (expanded) {
      return !expanded;
    });
  }, []);

  if (resource == null || errorsCount === 0 && !showWhenNoErrors) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(Alert$1, {
    className: classnames(_defineProperty({}, classes.spaced, spaced)),
    icon: false,
    elevation: elevation,
    severity: severity
  }, /*#__PURE__*/React__default.createElement(Group, {
    wrapper: true
  }, /*#__PURE__*/React__default.createElement(GroupTitle, {
    title: translate(groupTitle, {
      count: errorsCount
    }),
    subTitle: translate(groupMessage, {
      count: errorsCount
    })
  }), loading && /*#__PURE__*/React__default.createElement(Group, null, /*#__PURE__*/React__default.createElement(GroupItem, {
    lg: 12,
    md: 12,
    sm: 12,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(CircularProgress, {
    className: classes.progress
  }))), /*#__PURE__*/React__default.createElement(Collapse, {
    in: expanded
  }, /*#__PURE__*/React__default.createElement(Group, null, /*#__PURE__*/React__default.createElement(GroupItem, {
    lg: 10,
    md: 11,
    sm: 12
  }, /*#__PURE__*/React__default.createElement(List$1, {
    dense: true,
    component: "nav",
    color: "error"
  }, errorKeys.map(function (field) {
    return /*#__PURE__*/React__default.createElement(ValidationItem, {
      key: field,
      field: field,
      error: errorMap[field],
      resource: resource,
      translate: translate,
      component: children
    });
  }))))), !loading && errorKeys.length > 0 && /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: toggleExpand,
    endIcon: expanded ? /*#__PURE__*/React__default.createElement(ExpandLess, null) : /*#__PURE__*/React__default.createElement(ExpandMore, null)
  }, translate("ra.validation_summary.button.".concat(expanded ? "expand_less" : "expand_more")))));
};

// Give up on IE 11 support for this feature

function stripDiacritics(string) {
  return typeof string.normalize !== "undefined" ? string.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : string;
}

function createFilterOptions() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$ignoreAccents = config.ignoreAccents,
      ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents,
      _config$ignoreCase = config.ignoreCase,
      ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase,
      limit = config.limit,
      _config$matchFrom = config.matchFrom,
      matchFrom = _config$matchFrom === void 0 ? "any" : _config$matchFrom,
      stringify = config.stringify,
      _config$trim = config.trim,
      trim = _config$trim === void 0 ? false : _config$trim;
  return function (options, _ref) {
    var inputValue = _ref.inputValue,
        getOptionLabel = _ref.getOptionLabel;
    var input = trim ? inputValue.trim() : inputValue;

    if (ignoreCase) {
      var _input;

      input = (_input = input) === null || _input === void 0 ? void 0 : _input.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
    }

    var filteredOptions = options.filter(function (option) {
      var candidate = (stringify || getOptionLabel)(option);

      if (ignoreCase) {
        var _candidate;

        candidate = (_candidate = candidate) === null || _candidate === void 0 ? void 0 : _candidate.toLowerCase();
      }

      if (ignoreAccents) {
        candidate = stripDiacritics(candidate);
      }

      return matchFrom === "start" ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
    });
    return typeof limit === "number" ? filteredOptions.slice(0, limit) : filteredOptions;
  };
} // To replace with .findIndex() once we stop IE 11 support.

function findIndex(array, comp) {
  for (var i = 0; i < array.length; i += 1) {
    if (comp(array[i])) {
      return i;
    }
  }

  return -1;
}

var defaultFilterOptions = createFilterOptions(); // Number of options to jump in list box when pageup and pagedown keys are used.

var pageSize = 5;
function useAutocomplete(props) {
  var _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
      _props$autoHighlight = props.autoHighlight,
      autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
      _props$autoSelect = props.autoSelect,
      autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
      _props$blurOnSelect = props.blurOnSelect,
      blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect,
      _props$clearOnBlur = props.clearOnBlur,
      clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur,
      _props$clearOnEscape = props.clearOnEscape,
      clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
      _props$componentName = props.componentName,
      componentName = _props$componentName === void 0 ? "useAutocomplete" : _props$componentName,
      _props$debug = props.debug,
      debug = _props$debug === void 0 ? false : _props$debug,
      _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue,
      _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
      _props$disableCloseOn = props.disableCloseOnSelect,
      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
      _props$disabledItemsF = props.disabledItemsFocusable,
      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      _props$filterOptions = props.filterOptions,
      filterOptions = _props$filterOptions === void 0 ? defaultFilterOptions : _props$filterOptions,
      _props$filterSelected = props.filterSelectedOptions,
      filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
      _props$freeSolo = props.freeSolo,
      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
      getOptionDisabled = props.getOptionDisabled,
      _props$getOptionLabel = props.getOptionLabel,
      getOptionLabelProp = _props$getOptionLabel === void 0 ? function (option) {
    return option;
  } : _props$getOptionLabel,
      _props$getOptionSelec = props.getOptionSelected,
      getOptionSelected = _props$getOptionSelec === void 0 ? function (option, value) {
    return option === value;
  } : _props$getOptionSelec,
      groupBy = props.groupBy,
      _props$handleHomeEndK = props.handleHomeEndKeys,
      handleHomeEndKeys = _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK,
      idProp = props.id,
      _props$includeInputIn = props.includeInputInList,
      includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
      inputValueProp = props.inputValue,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      onChange = props.onChange,
      onClose = props.onClose,
      onHighlightChange = props.onHighlightChange,
      onInputChange = props.onInputChange,
      onOpen = props.onOpen,
      openProp = props.open,
      _props$openOnFocus = props.openOnFocus,
      openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus,
      options = props.options,
      _props$selectOnFocus = props.selectOnFocus,
      selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus,
      valueProp = props.value;
  var id = unstable_useId(idProp);
  var getOptionLabel = getOptionLabelProp;

  if (process.env.NODE_ENV !== "production") {
    getOptionLabel = function getOptionLabel(option) {
      var optionLabel = getOptionLabelProp(option);

      if (typeof optionLabel !== "string") {
        var erroneousReturn = optionLabel === undefined ? "undefined" : "".concat(_typeof(optionLabel), " (").concat(optionLabel, ")");
        console.error("Material-UI: The `getOptionLabel` method of ".concat(componentName, " returned ").concat(erroneousReturn, " instead of a string for ").concat(JSON.stringify(option), "."));
      }

      return optionLabel;
    };
  }

  var ignoreFocus = React.useRef(false);
  var firstFocus = React.useRef(true);
  var inputRef = React.useRef(null);
  var listboxRef = React.useRef(null);

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var _React$useState3 = React.useState(-1),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      focusedTag = _React$useState4[0],
      setFocusedTag = _React$useState4[1];

  var defaultHighlighted = autoHighlight ? 0 : -1;
  var highlightedIndexRef = React.useRef(defaultHighlighted);

  var _useControlled = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: componentName
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  var _useControlled3 = useControlled({
    controlled: inputValueProp,
    default: "",
    name: componentName,
    state: "inputValue"
  }),
      _useControlled4 = _slicedToArray(_useControlled3, 2),
      inputValue = _useControlled4[0],
      setInputValue = _useControlled4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      focused = _React$useState6[0],
      setFocused = _React$useState6[1];

  var resetInputValue = useEventCallback(function (event, newValue) {
    var newInputValue;

    if (multiple) {
      newInputValue = "";
    } else if (newValue == null) {
      newInputValue = "";
    } else {
      var optionLabel = getOptionLabel(newValue);
      newInputValue = typeof optionLabel === "string" ? optionLabel : "";
    }

    if (inputValue === newInputValue) {
      return;
    }

    if (!open) {
      setInputValue(newInputValue);
    }

    if (onInputChange) {
      onInputChange(event, newInputValue, "reset");
    }
  });
  React.useEffect(function () {
    resetInputValue(null, value);
  }, [value, resetInputValue]);

  var _useControlled5 = useControlled({
    controlled: openProp,
    default: false,
    name: componentName,
    state: "open"
  }),
      _useControlled6 = _slicedToArray(_useControlled5, 2),
      open = _useControlled6[0],
      setOpenState = _useControlled6[1];

  var inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
  var popupOpen = open;
  var filteredOptions = popupOpen ? filterOptions(options.filter(function (option) {
    if (filterSelectedOptions && (multiple ? value : [value]).some(function (value2) {
      return value2 !== null && getOptionSelected(option, value2);
    })) {
      return false;
    }

    return true;
  }), // we use the empty string to manipulate `filterOptions` to not filter any options
  // i.e. the filter predicate always returns true
  {
    inputValue: inputValueIsSelectedValue ? "" : inputValue,
    getOptionLabel: getOptionLabel
  }) : [];

  if (process.env.NODE_ENV !== "production") {
    if (value !== null && !freeSolo && options.length > 0) {
      var missingValue = (multiple ? value : [value]).filter(function (value2) {
        return !options.some(function (option) {
          return getOptionSelected(option, value2);
        });
      });

      if (missingValue.length > 0) {
        console.warn(["Material-UI: The value provided to ".concat(componentName, " is invalid."), "None of the options match with `".concat(missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0]), "`."), "You can use the `getOptionSelected` prop to customize the equality test."].join("\n"));
      }
    }
  }

  var focusTag = useEventCallback(function (tagToFocus) {
    if (tagToFocus === -1) {
      inputRef.current.focus();
    } else {
      anchorEl.querySelector("[data-tag-index=\"".concat(tagToFocus, "\"]")).focus();
    }
  }); // Ensure the focusedTag is never inconsistent

  React.useEffect(function () {
    if (multiple && focusedTag > value.length - 1) {
      setFocusedTag(-1);
      focusTag(-1);
    }
  }, [value, multiple, focusedTag, focusTag]);

  function validOptionIndex(index, direction) {
    if (!listboxRef.current || index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === "next" && nextFocus === filteredOptions.length || direction === "previous" && nextFocus === -1) {
        return -1;
      }

      var option = listboxRef.current.querySelector("[data-option-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      var nextFocusDisabled = disabledItemsFocusable ? false : option && (option.disabled || option.getAttribute("aria-disabled") === "true");

      if (option && !option.hasAttribute("tabindex") || nextFocusDisabled) {
        // Move to the next element.
        nextFocus += direction === "next" ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var setHighlightedIndex = useEventCallback(function (_ref2) {
    var event = _ref2.event,
        index = _ref2.index,
        _ref2$reason = _ref2.reason,
        reason = _ref2$reason === void 0 ? "auto" : _ref2$reason;
    highlightedIndexRef.current = index; // does the index exist?

    if (index === -1) {
      inputRef.current.removeAttribute("aria-activedescendant");
    } else {
      inputRef.current.setAttribute("aria-activedescendant", "".concat(id, "-option-").concat(index));
    }

    if (onHighlightChange) {
      onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
    }

    if (!listboxRef.current) {
      return;
    }

    var prev = listboxRef.current.querySelector("[data-focus]");

    if (prev) {
      prev.removeAttribute("data-focus");
    }

    var listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"

    if (!listboxNode) {
      return;
    }

    if (index === -1) {
      listboxNode.scrollTop = 0;
      return;
    }

    var option = listboxRef.current.querySelector("[data-option-index=\"".concat(index, "\"]"));

    if (!option) {
      return;
    }

    option.setAttribute("data-focus", "true"); // Scroll active descendant into view.
    // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
    //
    // Consider this API instead once it has a better browser support:
    // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });

    if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== "mouse") {
      var element = option;
      var scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
      var elementBottom = element.offsetTop + element.offsetHeight;

      if (elementBottom > scrollBottom) {
        listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
      } else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) {
        listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
      }
    }
  });
  var changeHighlightedIndex = useEventCallback(function (_ref3) {
    var event = _ref3.event,
        diff = _ref3.diff,
        _ref3$direction = _ref3.direction,
        direction = _ref3$direction === void 0 ? "next" : _ref3$direction,
        _ref3$reason = _ref3.reason,
        reason = _ref3$reason === void 0 ? "auto" : _ref3$reason;

    if (!popupOpen) {
      return;
    }

    var getNextIndex = function getNextIndex() {
      var maxIndex = filteredOptions.length - 1;

      if (diff === "reset") {
        return defaultHighlighted;
      }

      if (diff === "start") {
        return 0;
      }

      if (diff === "end") {
        return maxIndex;
      }

      var newIndex = highlightedIndexRef.current + diff;

      if (newIndex < 0) {
        if (newIndex === -1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) {
          return 0;
        }

        return maxIndex;
      }

      if (newIndex > maxIndex) {
        if (newIndex === maxIndex + 1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap || Math.abs(diff) > 1) {
          return maxIndex;
        }

        return 0;
      }

      return newIndex;
    };

    var nextIndex = validOptionIndex(getNextIndex(), direction);
    setHighlightedIndex({
      index: nextIndex,
      reason: reason,
      event: event
    }); // Sync the content of the input with the highlighted option.

    if (autoComplete && diff !== "reset") {
      if (nextIndex === -1) {
        inputRef.current.value = inputValue;
      } else {
        var option = getOptionLabel(filteredOptions[nextIndex]);
        inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
        // a completion string, appears inline after the input cursor in the textbox.

        var index = option === null || option === void 0 ? void 0 : option.toLowerCase().indexOf(inputValue === null || inputValue === void 0 ? void 0 : inputValue.toLowerCase());

        if (index === 0 && inputValue.length > 0) {
          inputRef.current.setSelectionRange(inputValue.length, option.length);
        }
      }
    }
  });
  var syncHighlightedIndex = React.useCallback(function () {
    if (!popupOpen) {
      return;
    }

    var valueItem = multiple ? value[0] : value; // The popup is empty, reset

    if (filteredOptions.length === 0 || valueItem == null) {
      changeHighlightedIndex({
        diff: "reset"
      });
      return;
    }

    if (!listboxRef.current) {
      return;
    } // Synchronize the value with the highlighted index


    if (!filterSelectedOptions && valueItem != null) {
      var currentOption = filteredOptions[highlightedIndexRef.current]; // Keep the current highlighted index if possible

      if (multiple && currentOption && findIndex(value, function (val) {
        return getOptionSelected(currentOption, val);
      }) !== -1) {
        return;
      }

      var itemIndex = findIndex(filteredOptions, function (optionItem) {
        return getOptionSelected(optionItem, valueItem);
      });

      if (itemIndex === -1) {
        changeHighlightedIndex({
          diff: "reset"
        });
      } else {
        setHighlightedIndex({
          index: itemIndex
        });
      }

      return;
    } // Prevent the highlighted index to leak outside the boundaries.


    if (highlightedIndexRef.current >= filteredOptions.length - 1) {
      setHighlightedIndex({
        index: filteredOptions.length - 1
      });
      return;
    } // Restore the focus to the previous index.


    setHighlightedIndex({
      index: highlightedIndexRef.current
    }); // Ignore filteredOptions (and options, getOptionSelected, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [// Only sync the highlighted index when the option switch between empty and not
  // eslint-disable-next-line react-hooks/exhaustive-deps
  filteredOptions.length === 0, // Don't sync the highlighted index with the value when multiple
  // eslint-disable-next-line react-hooks/exhaustive-deps
  multiple ? false : value, filterSelectedOptions, changeHighlightedIndex, setHighlightedIndex, popupOpen, inputValue, multiple]);
  var handleListboxRef = useEventCallback(function (node) {
    setRef(listboxRef, node);

    if (!node) {
      return;
    }

    syncHighlightedIndex();
  });
  React.useEffect(function () {
    syncHighlightedIndex();
  }, [syncHighlightedIndex]);

  var handleOpen = function handleOpen(event) {
    if (open) {
      return;
    }

    setOpenState(true);

    if (onOpen) {
      onOpen(event);
    }
  };

  var handleClose = function handleClose(event, reason) {
    if (!open) {
      return;
    }

    setOpenState(false);

    if (onClose) {
      onClose(event, reason);
    }
  };

  var handleValue = function handleValue(event, newValue, reason, details) {
    if (value === newValue) {
      return;
    }

    if (onChange) {
      onChange(event, newValue, reason, details);
    }

    setValue(newValue);
  };

  var isTouch = React.useRef(false);

  var selectNewValue = function selectNewValue(event, option) {
    var reasonProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "select-option";
    var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "options";
    var reason = reasonProp;
    var newValue = option;

    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];

      if (process.env.NODE_ENV !== "production") {
        var matches = newValue.filter(function (val) {
          return getOptionSelected(option, val);
        });

        if (matches.length > 1) {
          console.error(["Material-UI: The `getOptionSelected` method of ".concat(componentName, " do not handle the arguments correctly."), "The component expects a single value to match a given option but found ".concat(matches.length, " matches.")].join("\n"));
        }
      }

      var itemIndex = findIndex(newValue, function (valueItem) {
        return getOptionSelected(option, valueItem);
      });

      if (itemIndex === -1) {
        newValue.push(option);
      } else if (origin !== "freeSolo") {
        newValue.splice(itemIndex, 1);
        reason = "remove-option";
      }
    }

    resetInputValue(event, newValue);
    handleValue(event, newValue, reason, {
      option: option
    });

    if (!disableCloseOnSelect) {
      handleClose(event, reason);
    }

    if (blurOnSelect === true || blurOnSelect === "touch" && isTouch.current || blurOnSelect === "mouse" && !isTouch.current) {
      inputRef.current.blur();
    }
  };

  function validTagIndex(index, direction) {
    if (index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === "next" && nextFocus === value.length || direction === "previous" && nextFocus === -1) {
        return -1;
      }

      var option = anchorEl.querySelector("[data-tag-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      if (option && (!option.hasAttribute("tabindex") || option.disabled || option.getAttribute("aria-disabled") === "true")) {
        nextFocus += direction === "next" ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var handleFocusTag = function handleFocusTag(event, direction) {
    if (!multiple) {
      return;
    }

    handleClose(event, "toggleInput");
    var nextTag = focusedTag;

    if (focusedTag === -1) {
      if (inputValue === "" && direction === "previous") {
        nextTag = value.length - 1;
      }
    } else {
      nextTag += direction === "next" ? 1 : -1;

      if (nextTag < 0) {
        nextTag = 0;
      }

      if (nextTag === value.length) {
        nextTag = -1;
      }
    }

    nextTag = validTagIndex(nextTag, direction);
    setFocusedTag(nextTag);
    focusTag(nextTag);
  };

  var handleClear = function handleClear(event) {
    ignoreFocus.current = true;
    console.log("handleClear");
    setInputValue("");

    if (onInputChange) {
      onInputChange(event, "", "clear");
    }

    handleValue(event, multiple ? [] : null, "clear");
  };

  var handleKeyDown = function handleKeyDown(other) {
    return function (event) {
      if (focusedTag !== -1 && ["ArrowLeft", "ArrowRight"].indexOf(event.key) === -1) {
        setFocusedTag(-1);
        focusTag(-1);
      }

      switch (event.key) {
        case "Home":
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: "start",
              direction: "next",
              reason: "keyboard",
              event: event
            });
          }

          break;

        case "End":
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: "end",
              direction: "previous",
              reason: "keyboard",
              event: event
            });
          }

          break;

        case "PageUp":
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: -pageSize,
            direction: "previous",
            reason: "keyboard",
            event: event
          });
          handleOpen(event);
          break;

        case "PageDown":
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: pageSize,
            direction: "next",
            reason: "keyboard",
            event: event
          });
          handleOpen(event);
          break;

        case "ArrowDown":
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: event
          });
          handleOpen(event);
          break;

        case "ArrowUp":
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: event
          });
          handleOpen(event);
          break;

        case "ArrowLeft":
          handleFocusTag(event, "previous");
          break;

        case "ArrowRight":
          handleFocusTag(event, "next");
          break;

        case "Enter":
          // Wait until IME is settled.
          if (event.which === 229) {
            break;
          }

          if (highlightedIndexRef.current !== -1 && popupOpen) {
            var option = filteredOptions[highlightedIndexRef.current];
            var disabled = getOptionDisabled ? getOptionDisabled(option) : false; // We don't want to validate the form.

            event.preventDefault();

            if (disabled) {
              return;
            }

            selectNewValue(event, option, "select-option"); // Move the selection to the end.

            if (autoComplete) {
              inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
            }
          } else if (freeSolo && inputValue !== "" && inputValueIsSelectedValue === false) {
            if (multiple) {
              // Allow people to add new values before they submit the form.
              event.preventDefault();
            }

            selectNewValue(event, inputValue, "create-option", "freeSolo");
          }

          break;

        case "Escape":
          if (popupOpen) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault(); // Avoid the Modal to handle the event.

            event.stopPropagation();
            handleClose(event, "escape");
          } else if (clearOnEscape && (inputValue !== "" || multiple && value.length > 0)) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault(); // Avoid the Modal to handle the event.

            event.stopPropagation();
            handleClear(event);
          }

          break;

        case "Backspace":
          if (multiple && inputValue === "" && value.length > 0) {
            var index = focusedTag === -1 ? value.length - 1 : focusedTag;
            var newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, "remove-option", {
              option: value[index]
            });
          }

          break;
      }

      if (other.onKeyDown) {
        other.onKeyDown(event);
      }
    };
  };

  var handleFocus = function handleFocus(event) {
    setFocused(true);

    if (openOnFocus && !ignoreFocus.current) {
      handleOpen(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    // Ignore the event when using the scrollbar with IE 11
    if (listboxRef.current !== null && document.activeElement === listboxRef.current.parentElement) {
      inputRef.current.focus();
      return;
    }

    setFocused(false);
    firstFocus.current = true;
    ignoreFocus.current = false;

    if (debug && inputValue !== "") {
      return;
    }

    if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) {
      selectNewValue(event, filteredOptions[highlightedIndexRef.current], "blur");
    } else if (autoSelect && freeSolo && inputValue !== "") {
      selectNewValue(event, inputValue, "blur", "freeSolo");
    } else if (clearOnBlur) {
      resetInputValue(event, value);
    }

    handleClose(event, "blur");
  };

  var handleInputChange = function handleInputChange(event) {
    var newValue = event.target.value;

    if (inputValue !== newValue) {
      setInputValue(newValue);

      if (onInputChange) {
        onInputChange(event, newValue, "input");
      }
    }

    if (newValue === "") {
      if (!disableClearable && !multiple) {
        handleValue(event, null, "clear");
      }
    } else {
      handleOpen(event);
    }
  };

  var handleOptionMouseOver = function handleOptionMouseOver(event) {
    setHighlightedIndex({
      event: event,
      index: Number(event.currentTarget.getAttribute("data-option-index")),
      reason: "mouse"
    });
  };

  var handleOptionTouchStart = function handleOptionTouchStart() {
    isTouch.current = true;
  };

  var handleOptionClick = function handleOptionClick(event) {
    var index = Number(event.currentTarget.getAttribute("data-option-index"));
    selectNewValue(event, filteredOptions[index], "select-option");
    isTouch.current = false;
  };

  var handleTagDelete = function handleTagDelete(index) {
    return function (event) {
      var newValue = value.slice();
      newValue.splice(index, 1);
      handleValue(event, newValue, "remove-option", {
        option: value[index]
      });
    };
  };

  var handlePopupIndicator = function handlePopupIndicator(event) {
    if (open) {
      handleClose(event, "toggleInput");
    } else {
      handleOpen(event);
    }
  }; // Prevent input blur when interacting with the combobox


  var handleMouseDown = function handleMouseDown(event) {
    if (event.target.getAttribute("id") !== id) {
      event.preventDefault();
    }
  }; // Focus the input when interacting with the combobox


  var handleClick = function handleClick() {
    inputRef.current.focus();

    if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
      inputRef.current.select();
    }

    firstFocus.current = false;
  };

  var handleInputMouseDown = function handleInputMouseDown(event) {
    if (inputValue === "" || !open) {
      handlePopupIndicator(event);
    }
  };

  var dirty = freeSolo && inputValue.length > 0;
  dirty = dirty || (multiple ? value.length > 0 : value !== null);
  var groupedOptions = filteredOptions;

  if (groupBy) {
    // used to keep track of key and indexes in the result array
    var indexBy = new Map();
    var warn = false;
    groupedOptions = filteredOptions.reduce(function (acc, option, index) {
      var group = groupBy(option);

      if (acc.length > 0 && acc[acc.length - 1].group === group) {
        acc[acc.length - 1].options.push(option);
      } else {
        if (process.env.NODE_ENV !== "production") {
          if (indexBy.get(group) && !warn) {
            console.warn("Material-UI: The options provided combined with the `groupBy` method of ".concat(componentName, " returns duplicated headers."), "You can solve the issue by sorting the options with the output of `groupBy`.");
            warn = true;
          }

          indexBy.set(group, true);
        }

        acc.push({
          key: index,
          index: index,
          group: group,
          options: [option]
        });
      }

      return acc;
    }, []);
  }

  return {
    getRootProps: function getRootProps() {
      var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _objectSpread2(_objectSpread2({
        "aria-owns": popupOpen ? "".concat(id, "-popup") : null,
        role: "combobox",
        "aria-expanded": popupOpen
      }, other), {}, {
        onKeyDown: handleKeyDown(other),
        onMouseDown: handleMouseDown,
        onClick: handleClick
      });
    },
    getInputLabelProps: function getInputLabelProps() {
      return {
        id: "".concat(id, "-label"),
        htmlFor: id
      };
    },
    getInputProps: function getInputProps() {
      return {
        id: id,
        value: inputValue,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onChange: handleInputChange,
        onMouseDown: handleInputMouseDown,
        // if open then this is handled imperativeley so don't let react override
        // only have an opinion about this when closed
        "aria-activedescendant": popupOpen ? "" : null,
        "aria-autocomplete": autoComplete ? "both" : "list",
        "aria-controls": popupOpen ? "".concat(id, "-popup") : null,
        // Disable browser's suggestion that might overlap with the popup.
        // Handle autocomplete but not autofill.
        autoComplete: "off",
        ref: inputRef,
        autoCapitalize: "none",
        spellCheck: "false"
      };
    },
    getClearProps: function getClearProps() {
      return {
        tabIndex: -1,
        onClick: handleClear
      };
    },
    getPopupIndicatorProps: function getPopupIndicatorProps() {
      return {
        tabIndex: -1,
        onClick: handlePopupIndicator
      };
    },
    getTagProps: function getTagProps(_ref4) {
      var index = _ref4.index;
      return {
        key: index,
        "data-tag-index": index,
        tabIndex: -1,
        onDelete: handleTagDelete(index)
      };
    },
    getListboxProps: function getListboxProps() {
      return {
        role: "listbox",
        id: "".concat(id, "-popup"),
        "aria-labelledby": "".concat(id, "-label"),
        ref: handleListboxRef,
        onMouseDown: function onMouseDown(event) {
          // Prevent blur
          event.preventDefault();
        }
      };
    },
    getOptionProps: function getOptionProps(_ref5) {
      var index = _ref5.index,
          option = _ref5.option;
      var selected = (multiple ? value : [value]).some(function (value2) {
        return value2 != null && getOptionSelected(option, value2);
      });
      var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
      return {
        key: index,
        tabIndex: -1,
        role: "option",
        id: "".concat(id, "-option-").concat(index),
        onMouseOver: handleOptionMouseOver,
        onClick: handleOptionClick,
        onTouchStart: handleOptionTouchStart,
        "data-option-index": index,
        "aria-disabled": disabled,
        "aria-selected": selected
      };
    },
    id: id,
    inputValue: inputValue,
    value: value,
    dirty: dirty,
    popupOpen: popupOpen,
    focused: focused || focusedTag !== -1,
    anchorEl: anchorEl,
    setAnchorEl: setAnchorEl,
    focusedTag: focusedTag,
    groupedOptions: groupedOptions
  };
}

var _excluded$x = ["anchorEl", "open"],
    _excluded2$9 = ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "classes", "className", "clearOnBlur", "clearOnEscape", "clearText", "closeIcon", "closeText", "debug", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionLabel", "getOptionSelected", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "value"];
var styles = function styles(theme) {
  var _option;

  return {
    /* Styles applied to the root element. */
    root: {
      "&$focused $clearIndicatorDirty": {
        visibility: "visible"
      },

      /* Avoid double tap issue on iOS */
      "@media (pointer: fine)": {
        "&:hover $clearIndicatorDirty": {
          visibility: "visible"
        }
      }
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: "100%"
    },

    /* Pseudo-class applied to the root element if focused. */
    focused: {},

    /* Styles applied to the tag elements, e.g. the chips. */
    tag: {
      margin: 3,
      maxWidth: "calc(100% - 6px)"
    },

    /* Styles applied to the tag elements, e.g. the chips if `size="small"`. */
    tagSizeSmall: {
      margin: 2,
      maxWidth: "calc(100% - 4px)"
    },

    /* Styles applied when the popup icon is rendered. */
    hasPopupIcon: {},

    /* Styles applied when the clear icon is rendered. */
    hasClearIcon: {},

    /* Styles applied to the Input element. */
    inputRoot: {
      flexWrap: "wrap",
      "$hasPopupIcon &, $hasClearIcon &": {
        paddingRight: 26 + 4
      },
      "$hasPopupIcon$hasClearIcon &": {
        paddingRight: 52 + 4
      },
      "& $input": {
        width: 0,
        minWidth: 30
      },
      '&[class*="MuiInput-root"]': {
        paddingBottom: 1,
        "& $input": {
          padding: 4
        },
        "& $input:first-child": {
          padding: "6px 0"
        }
      },
      '&[class*="MuiInput-root"][class*="MuiInput-marginDense"]': {
        "& $input": {
          padding: "4px 4px 5px"
        },
        "& $input:first-child": {
          padding: "3px 0 6px"
        }
      },
      '&[class*="MuiOutlinedInput-root"]': {
        padding: 9,
        "$hasPopupIcon &, $hasClearIcon &": {
          paddingRight: 26 + 4 + 9
        },
        "$hasPopupIcon$hasClearIcon &": {
          paddingRight: 52 + 4 + 9
        },
        "& $input": {
          padding: "9.5px 4px"
        },
        "& $input:first-child": {
          paddingLeft: 6
        },
        "& $endAdornment": {
          right: 9
        }
      },
      '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
        padding: 6,
        "& $input": {
          padding: "4.5px 4px"
        }
      },
      '&[class*="MuiFilledInput-root"]': {
        paddingTop: 19,
        paddingLeft: 8,
        "$hasPopupIcon &, $hasClearIcon &": {
          paddingRight: 26 + 4 + 9
        },
        "$hasPopupIcon$hasClearIcon &": {
          paddingRight: 52 + 4 + 9
        },
        "& $input": {
          padding: "9px 4px"
        },
        "& $endAdornment": {
          right: 9
        }
      },
      '&[class*="MuiFilledInput-root"][class*="MuiFilledInput-marginDense"]': {
        paddingBottom: 1,
        "& $input": {
          padding: "4.5px 4px"
        }
      }
    },

    /* Styles applied to the input element. */
    input: {
      flexGrow: 1,
      textOverflow: "ellipsis",
      opacity: 0
    },

    /* Styles applied to the input element if tag focused. */
    inputFocused: {
      opacity: 1
    },

    /* Styles applied to the endAdornment element. */
    endAdornment: {
      // We use a position absolute to support wrapping tags.
      position: "absolute",
      right: 0,
      top: "calc(50% - 14px)" // Center vertically

    },

    /* Styles applied to the clear indicator. */
    clearIndicator: {
      marginRight: -2,
      padding: 4,
      visibility: "hidden"
    },

    /* Styles applied to the clear indicator if the input is dirty. */
    clearIndicatorDirty: {},

    /* Styles applied to the popup indicator. */
    popupIndicator: {
      padding: 2,
      marginRight: -2
    },

    /* Styles applied to the popup indicator if the popup is open. */
    popupIndicatorOpen: {
      transform: "rotate(180deg)"
    },

    /* Styles applied to the popper element. */
    popper: {
      zIndex: theme.zIndex.modal
    },

    /* Styles applied to the popper element if `disablePortal={true}`. */
    popperDisablePortal: {
      position: "absolute"
    },

    /* Styles applied to the `Paper` component. */
    paper: _objectSpread2(_objectSpread2({}, theme.typography.body1), {}, {
      overflow: "hidden",
      margin: "4px 0"
    }),

    /* Styles applied to the `listbox` component. */
    listbox: {
      listStyle: "none",
      margin: 0,
      padding: "8px 0",
      maxHeight: "40vh",
      overflow: "auto"
    },

    /* Styles applied to the loading wrapper. */
    loading: {
      color: theme.palette.text.secondary,
      padding: "14px 16px"
    },

    /* Styles applied to the no option wrapper. */
    noOptions: {
      color: theme.palette.text.secondary,
      padding: "14px 16px"
    },

    /* Styles applied to the option elements. */
    option: (_option = {
      minHeight: 48,
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      cursor: "pointer",
      paddingTop: 6,
      boxSizing: "border-box",
      outline: "0",
      WebkitTapHighlightColor: "transparent",
      paddingBottom: 6,
      paddingLeft: 16,
      paddingRight: 16
    }, _defineProperty(_option, theme.breakpoints.up("sm"), {
      minHeight: "auto"
    }), _defineProperty(_option, '&[aria-selected="true"]', {
      backgroundColor: theme.palette.action.selected
    }), _defineProperty(_option, '&[data-focus="true"]', {
      backgroundColor: theme.palette.action.hover
    }), _defineProperty(_option, "&:active", {
      backgroundColor: theme.palette.action.selected
    }), _defineProperty(_option, '&[aria-disabled="true"]', {
      opacity: theme.palette.action.disabledOpacity,
      pointerEvents: "none"
    }), _option),

    /* Styles applied to the group's label elements. */
    groupLabel: {
      backgroundColor: theme.palette.background.paper,
      top: -8
    },

    /* Styles applied to the group's ul elements. */
    groupUl: {
      padding: 0,
      "& $option": {
        paddingLeft: 24
      }
    }
  };
};

function DisablePortal(props) {
  // eslint-disable-next-line react/prop-types
  props.anchorEl;
      props.open;
      var other = _objectWithoutProperties(props, _excluded$x);

  return /*#__PURE__*/React.createElement("div", other);
}

var Autocomplete = /*#__PURE__*/React.forwardRef(function Autocomplete(props, ref) {
  var _clsx2;

  /* eslint-disable no-unused-vars */
  props.autoComplete;
      props.autoHighlight;
      props.autoSelect;
      props.blurOnSelect;
      var ChipProps = props.ChipProps,
      classes = props.classes,
      className = props.className,
      _props$clearOnBlur = props.clearOnBlur;
      _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur;
      props.clearOnEscape;
      var _props$clearText = props.clearText,
      clearText = _props$clearText === void 0 ? "Clear" : _props$clearText,
      _props$closeIcon = props.closeIcon,
      closeIcon = _props$closeIcon === void 0 ? /*#__PURE__*/React.createElement(CloseIcon, {
    fontSize: "small"
  }) : _props$closeIcon,
      _props$closeText = props.closeText,
      closeText = _props$closeText === void 0 ? "Close" : _props$closeText;
      props.debug;
      var _props$defaultValue = props.defaultValue;
      _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue;
      var _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab;
      props.disableCloseOnSelect;
      var _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
      props.disabledItemsFocusable;
      props.disableListWrap;
      var _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal;
      props.filterOptions;
      props.filterSelectedOptions;
      var _props$forcePopupIcon = props.forcePopupIcon,
      forcePopupIcon = _props$forcePopupIcon === void 0 ? "auto" : _props$forcePopupIcon,
      _props$freeSolo = props.freeSolo,
      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$getLimitTagsTe = props.getLimitTagsText,
      getLimitTagsText = _props$getLimitTagsTe === void 0 ? function (more) {
    return "+".concat(more);
  } : _props$getLimitTagsTe;
      props.getOptionDisabled;
      var _props$getOptionLabel = props.getOptionLabel,
      getOptionLabel = _props$getOptionLabel === void 0 ? function (x) {
    return x;
  } : _props$getOptionLabel;
      props.getOptionSelected;
      var groupBy = props.groupBy,
      _props$handleHomeEndK = props.handleHomeEndKeys;
      _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK;
      props.id;
      props.includeInputInList;
      props.inputValue;
      var _props$limitTags = props.limitTags,
      limitTags = _props$limitTags === void 0 ? -1 : _props$limitTags,
      _props$ListboxCompone = props.ListboxComponent,
      ListboxComponent = _props$ListboxCompone === void 0 ? "ul" : _props$ListboxCompone,
      ListboxProps = props.ListboxProps,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$loadingText = props.loadingText,
      loadingText = _props$loadingText === void 0 ? "Loading…" : _props$loadingText,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$noOptionsText = props.noOptionsText,
      noOptionsText = _props$noOptionsText === void 0 ? "No options" : _props$noOptionsText;
      props.onChange;
      props.onClose;
      props.onHighlightChange;
      props.onInputChange;
      props.onOpen;
      props.open;
      props.openOnFocus;
      var _props$openText = props.openText,
      openText = _props$openText === void 0 ? "Open" : _props$openText;
      props.options;
      var _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? Paper$1 : _props$PaperComponent,
      _props$PopperComponen = props.PopperComponent,
      PopperComponentProp = _props$PopperComponen === void 0 ? Popper : _props$PopperComponen,
      _props$popupIcon = props.popupIcon,
      popupIcon = _props$popupIcon === void 0 ? /*#__PURE__*/React.createElement(ArrowDropDownIcon, null) : _props$popupIcon,
      renderGroupProp = props.renderGroup,
      renderInput = props.renderInput,
      renderOptionProp = props.renderOption,
      renderTags = props.renderTags,
      _props$selectOnFocus = props.selectOnFocus;
      _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus;
      var _props$size = props.size,
      size = _props$size === void 0 ? "medium" : _props$size;
      props.value;
      var other = _objectWithoutProperties(props, _excluded2$9);
  /* eslint-enable no-unused-vars */


  var PopperComponent = disablePortal ? DisablePortal : PopperComponentProp;

  var _useAutocomplete = useAutocomplete(_objectSpread2(_objectSpread2({}, props), {}, {
    componentName: "Autocomplete"
  })),
      getRootProps = _useAutocomplete.getRootProps,
      getInputProps = _useAutocomplete.getInputProps,
      getInputLabelProps = _useAutocomplete.getInputLabelProps,
      getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps,
      getClearProps = _useAutocomplete.getClearProps,
      getTagProps = _useAutocomplete.getTagProps,
      getListboxProps = _useAutocomplete.getListboxProps,
      getOptionProps = _useAutocomplete.getOptionProps,
      value = _useAutocomplete.value,
      dirty = _useAutocomplete.dirty,
      id = _useAutocomplete.id,
      popupOpen = _useAutocomplete.popupOpen,
      focused = _useAutocomplete.focused,
      focusedTag = _useAutocomplete.focusedTag,
      anchorEl = _useAutocomplete.anchorEl,
      setAnchorEl = _useAutocomplete.setAnchorEl,
      inputValue = _useAutocomplete.inputValue,
      groupedOptions = _useAutocomplete.groupedOptions;

  var startAdornment;

  if (multiple && value.length > 0) {
    var getCustomizedTagProps = function getCustomizedTagProps(params) {
      return _objectSpread2({
        className: clsx(classes.tag, _defineProperty({}, classes.tagSizeSmall, size === "small")),
        disabled: disabled
      }, getTagProps(params));
    };

    if (renderTags) {
      startAdornment = renderTags(value, getCustomizedTagProps);
    } else {
      startAdornment = value.map(function (option, index) {
        return /*#__PURE__*/React.createElement(Chip$1, _extends({
          label: getOptionLabel(option),
          size: size
        }, getCustomizedTagProps({
          index: index
        }), ChipProps));
      });
    }
  }

  if (limitTags > -1 && Array.isArray(startAdornment)) {
    var more = startAdornment.length - limitTags;

    if (!focused && more > 0) {
      startAdornment = startAdornment.splice(0, limitTags);
      startAdornment.push( /*#__PURE__*/React.createElement("span", {
        className: classes.tag,
        key: startAdornment.length
      }, getLimitTagsText(more)));
    }
  }

  var defaultRenderGroup = function defaultRenderGroup(params) {
    return /*#__PURE__*/React.createElement("li", {
      key: params.key
    }, /*#__PURE__*/React.createElement(ListSubheader$1, {
      className: classes.groupLabel,
      component: "div"
    }, params.group), /*#__PURE__*/React.createElement("ul", {
      className: classes.groupUl
    }, params.children));
  };

  var renderGroup = renderGroupProp || defaultRenderGroup;
  var renderOption = renderOptionProp || getOptionLabel;

  var renderListOption = function renderListOption(option, index) {
    var optionProps = getOptionProps({
      option: option,
      index: index
    });
    return /*#__PURE__*/React.createElement("li", _extends({}, optionProps, {
      className: classes.option
    }), renderOption(option, {
      selected: optionProps["aria-selected"],
      inputValue: inputValue
    }));
  };

  var hasClearIcon = !disableClearable && !disabled;
  var hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: clsx(classes.root, (_clsx2 = {}, _defineProperty(_clsx2, classes.focused, focused), _defineProperty(_clsx2, classes.fullWidth, fullWidth), _defineProperty(_clsx2, classes.hasClearIcon, hasClearIcon), _defineProperty(_clsx2, classes.hasPopupIcon, hasPopupIcon), _clsx2), className)
  }, getRootProps(other)), renderInput({
    id: id,
    disabled: disabled,
    fullWidth: true,
    size: size === "small" ? "small" : undefined,
    InputLabelProps: getInputLabelProps(),
    InputProps: {
      ref: setAnchorEl,
      className: classes.inputRoot,
      startAdornment: startAdornment,
      endAdornment: /*#__PURE__*/React.createElement("div", {
        className: classes.endAdornment
      }, hasClearIcon ? /*#__PURE__*/React.createElement(IconButton$1, _extends({}, getClearProps(), {
        "aria-label": clearText,
        title: clearText,
        className: clsx(classes.clearIndicator, _defineProperty({}, classes.clearIndicatorDirty, dirty))
      }), closeIcon) : null, hasPopupIcon ? /*#__PURE__*/React.createElement(IconButton$1, _extends({}, getPopupIndicatorProps(), {
        disabled: disabled,
        "aria-label": popupOpen ? closeText : openText,
        title: popupOpen ? closeText : openText,
        className: clsx(classes.popupIndicator, _defineProperty({}, classes.popupIndicatorOpen, popupOpen))
      }), popupIcon) : null)
    },
    inputProps: _objectSpread2({
      className: clsx(classes.input, _defineProperty({}, classes.inputFocused, focusedTag === -1)),
      disabled: disabled
    }, getInputProps())
  })), popupOpen && anchorEl ? /*#__PURE__*/React.createElement(PopperComponent, {
    className: clsx(classes.popper, _defineProperty({}, classes.popperDisablePortal, disablePortal)),
    style: {
      width: anchorEl ? anchorEl.clientWidth : null
    },
    role: "presentation",
    anchorEl: anchorEl,
    open: true
  }, /*#__PURE__*/React.createElement(PaperComponent, {
    className: classes.paper
  }, loading && groupedOptions.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: classes.loading
  }, loadingText) : null, groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/React.createElement("div", {
    className: classes.noOptions
  }, noOptionsText) : null, groupedOptions.length > 0 ? /*#__PURE__*/React.createElement(ListboxComponent, _extends({
    className: classes.listbox
  }, getListboxProps(), ListboxProps), groupedOptions.map(function (option, index) {
    if (groupBy) {
      return renderGroup({
        key: option.key,
        group: option.group,
        children: option.options.map(function (option2, index2) {
          return renderListOption(option2, option.index + index2);
        })
      });
    }

    return renderListOption(option, index);
  })) : null)) : null);
});
Autocomplete.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the portion of the selected suggestion that has not been typed by the user,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   */
  autoComplete: PropTypes.bool,

  /**
   * If `true`, the first option is automatically highlighted.
   */
  autoHighlight: PropTypes.bool,

  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   */
  autoSelect: PropTypes.bool,

  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   */
  blurOnSelect: PropTypes.oneOfType([PropTypes.oneOf(["mouse", "touch"]), PropTypes.bool]),

  /**
   * Props applied to the [`Chip`](/api/chip/) element.
   */
  ChipProps: PropTypes.object,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the input's text will be cleared on blur if no value is selected.
   *
   * Set to `true` if you want to help the user enter a new value.
   * Set to `false` if you want to help the user resume his search.
   */
  clearOnBlur: PropTypes.bool,

  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   */
  clearOnEscape: PropTypes.bool,

  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  clearText: PropTypes.string,

  /**
   * The icon to display in place of the default close icon.
   */
  closeIcon: PropTypes.node,

  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  closeText: PropTypes.string,

  /**
   * If `true`, the popup will ignore the blur event if the input is filled.
   * You can inspect the popup markup with your browser tools.
   * Consider this option when you need to customize the component.
   */
  debug: PropTypes.bool,

  /**
   * The default input value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the input can't be cleared.
   */
  disableClearable: PropTypes
  /* @typescript-to-proptypes-ignore */
  .bool,

  /**
   * If `true`, the popup won't close when a value is selected.
   */
  disableCloseOnSelect: PropTypes.bool,

  /**
   * If `true`, the input will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, will allow focus on disabled items.
   */
  disabledItemsFocusable: PropTypes.bool,

  /**
   * If `true`, the list box in the popup will not wrap focus.
   */
  disableListWrap: PropTypes.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * A filter function that determines the options that are eligible.
   *
   * @param {T[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {T[]}
   */
  filterOptions: PropTypes.func,

  /**
   * If `true`, hide the selected options from the list box.
   */
  filterSelectedOptions: PropTypes.bool,

  /**
   * Force the visibility display of the popup icon.
   */
  forcePopupIcon: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.bool]),

  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   */
  freeSolo: PropTypes
  /* @typescript-to-proptypes-ignore */
  .bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   */
  getLimitTagsText: PropTypes.func,

  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {T} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: PropTypes.func,

  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * @param {T} option
   * @returns {string}
   */
  getOptionLabel: PropTypes.func,

  /**
   * Used to determine if an option is selected, considering the current value.
   * Uses strict equality by default.
   *
   * @param {T} option The option to test.
   * @param {T} value The value to test against.
   * @returns {boolean}
   */
  getOptionSelected: PropTypes.func,

  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {T} options The options to group.
   * @returns {string}
   */
  groupBy: PropTypes.func,

  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   */
  handleHomeEndKeys: PropTypes.bool,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,

  /**
   * If `true`, the highlight can move to the input.
   */
  includeInputInList: PropTypes.bool,

  /**
   * The input value.
   */
  inputValue: PropTypes.string,

  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   */
  limitTags: PropTypes.number,

  /**
   * The component used to render the listbox.
   */
  ListboxComponent: PropTypes.elementType,

  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: PropTypes.object,

  /**
   * If `true`, the component is in a loading state.
   */
  loading: PropTypes.bool,

  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  loadingText: PropTypes.node,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes
  /* @typescript-to-proptypes-ignore */
  .bool,

  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  noOptionsText: PropTypes.node,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {T|T[]} value The new value of the component.
   * @param {string} reason One of "create-option", "select-option", "remove-option", "blur" or "clear".
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"select-option"`, `"blur"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the highlight option changes.
   *
   * @param {object} event The event source of the callback.
   * @param {T} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`.
   */
  onHighlightChange: PropTypes.func,

  /**
   * Callback fired when the input value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */
  onInputChange: PropTypes.func,

  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control the popup` open state.
   */
  open: PropTypes.bool,

  /**
   * If `true`, the popup will open on input focus.
   */
  openOnFocus: PropTypes.bool,

  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  openText: PropTypes.string,

  /**
   * Array of options.
   */
  options: PropTypes.array.isRequired,

  /**
   * The component used to render the body of the popup.
   */
  PaperComponent: PropTypes.elementType,

  /**
   * The component used to position the popup.
   */
  PopperComponent: PropTypes.elementType,

  /**
   * The icon to display in place of the default popup icon.
   */
  popupIcon: PropTypes.node,

  /**
   * Render the group.
   *
   * @param {any} option The group to render.
   * @returns {ReactNode}
   */
  renderGroup: PropTypes.func,

  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: PropTypes.func.isRequired,

  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {T} option The option to render.
   * @param {object} state The state of the component.
   * @returns {ReactNode}
   */
  renderOption: PropTypes.func,

  /**
   * Render the selected value.
   *
   * @param {T[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @returns {ReactNode}
   */
  renderTags: PropTypes.func,

  /**
   * If `true`, the input's text will be selected on focus.
   * It helps the user clear the selected value.
   */
  selectOnFocus: PropTypes.bool,

  /**
   * The size of the autocomplete.
   */
  size: PropTypes.oneOf(["medium", "small"]),

  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `getOptionSelected` prop.
   */
  value: PropTypes.any
};
var Autocomplete$1 = withStyles(styles, {
  name: "MuiAutocomplete"
})(Autocomplete);

// record -> input
var createManyFormatter = function createManyFormatter() {
  return function (many) {
    var array = many ? many.map(function (p) {
      return p.id;
    }) : [];
    return array;
  };
};

// input -> record
var createManyParser = function createManyParser() {
  return function (many) {
    var objects = many ? many.map(function (id) {
      return {
        id: id
      };
    }) : [];
    return objects;
  };
};

/**
 * Returns a memoized function that will only call the passed function when it hasn't been called for the wait period
 * @param func The function to be called
 * @param wait Wait period after function hasn't been called for
 * @returns A memoized function that is debounced
 */

var useDebouncedCallback = function useDebouncedCallback(func, wait) {
  // Use a ref to store the timeout between renders
  // and prevent changes to it from causing re-renders
  var timeout = useRef();
  return useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var later = function later() {
      clearTimeout(timeout.current);
      func.apply(void 0, args);
    };

    clearTimeout(timeout.current);
    timeout.current = setTimeout(later, wait);
  }, [func, wait]);
};

var _excluded$w = ["choices", "optionText", "setFilter", "parse", "format", "helperText", "disabled", "variant", "margin"],
    _excluded2$8 = ["name", "onChange"];
var useStyles$f = makeStyles$1(function (theme) {
  return {
    root: {
      "& div>div": {
        marginTop: theme.spacing(0.5),
        marginBottom: theme.spacing(1)
      }
    }
  };
}, {
  name: "FobAutocompleteArrayInput"
});

var AutocompleteArrayInput = function AutocompleteArrayInput(_ref) {
  var choices = _ref.choices,
      _ref$optionText = _ref.optionText,
      optionText = _ref$optionText === void 0 ? "name" : _ref$optionText,
      setFilter = _ref.setFilter;
      _ref.parse;
      var _ref$format = _ref.format,
      format = _ref$format === void 0 ? createManyFormatter() : _ref$format,
      helperText = _ref.helperText,
      disabled = _ref.disabled,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? "dense" : _ref$margin,
      props = _objectWithoutProperties(_ref, _excluded$w);

  var formState = useFormState({
    subscription: {
      values: true
    }
  });
  var classes = useStyles$f();

  var _useInput = useInput(props),
      _useInput$input = _useInput.input;
      _useInput$input.name;
      var onChange = _useInput$input.onChange,
      rest = _objectWithoutProperties(_useInput$input, _excluded2$8),
      _useInput$meta = _useInput.meta,
      touched = _useInput$meta.touched,
      error = _useInput$meta.error,
      submitError = _useInput$meta.submitError,
      submitFailed = _useInput$meta.submitFailed,
      isRequired = _useInput.isRequired;

  var hasError = (error || submitError) && (touched || submitFailed);
  var selectedValues = useMemo$1(function () {
    var ids = format(get$1(formState === null || formState === void 0 ? void 0 : formState.values, props === null || props === void 0 ? void 0 : props.source, []));
    return choices.filter(function (c) {
      return ids.indexOf(c.id) !== -1;
    });
  }, [formState, props, choices]);
  var handleChange = useCallback(function (_, values) {
    var ids = format(values);
    onChange(ids);
  }, []);
  var handleOptionLabel = useCallback(function (option) {
    return typeof optionText === "function" ? optionText(option) : get$1(option, optionText);
  }, [optionText]);
  var handleTextChange = useDebouncedCallback(function (e) {
    return setFilter(e.target.value);
  }, 1000);
  return /*#__PURE__*/React__default.createElement(Autocomplete$1, _extends({}, rest, {
    multiple: true,
    classes: classes,
    options: choices,
    disabled: disabled,
    onChange: handleChange,
    getOptionLabel: handleOptionLabel,
    value: selectedValues,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$1, _extends({
        error: hasError,
        margin: margin,
        variant: variant,
        onChange: handleTextChange,
        helperText: /*#__PURE__*/React__default.createElement(InputHelperText, {
          helperText: helperText,
          touched: touched,
          error: submitError
        }),
        required: isRequired,
        label: /*#__PURE__*/React__default.createElement(FieldTitle, _extends({}, props, {
          label: props === null || props === void 0 ? void 0 : props.label,
          source: props === null || props === void 0 ? void 0 : props.source,
          resource: props === null || props === void 0 ? void 0 : props.resource
        }))
      }, params));
    }
  }));
};

var _excluded$v = ["choices", "optionText", "optionValue", "helperText", "className", "setFilter", "disabled", "variant", "margin"],
    _excluded2$7 = ["name", "onChange"];
var useStyles$e = makeStyles$1(function (theme) {
  return {
    root: {
      marginBottom: theme.spacing(1)
    }
  };
});

var AutocompleteInput = function AutocompleteInput(_ref) {
  var choices = _ref.choices,
      _ref$optionText = _ref.optionText,
      optionText = _ref$optionText === void 0 ? "name" : _ref$optionText,
      _ref$optionValue = _ref.optionValue,
      optionValue = _ref$optionValue === void 0 ? "id" : _ref$optionValue,
      _ref$helperText = _ref.helperText,
      helperText = _ref$helperText === void 0 ? null : _ref$helperText;
      _ref.className;
      var setFilter = _ref.setFilter,
      disabled = _ref.disabled,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? "dense" : _ref$margin,
      props = _objectWithoutProperties(_ref, _excluded$v);

  var formState = useFormState({
    subscription: {
      values: true
    }
  });
  var classes = useStyles$e();

  var _useInput = useInput(props),
      _useInput$input = _useInput.input;
      _useInput$input.name;
      var onChange = _useInput$input.onChange,
      rest = _objectWithoutProperties(_useInput$input, _excluded2$7),
      _useInput$meta = _useInput.meta,
      touched = _useInput$meta.touched,
      error = _useInput$meta.error,
      submitError = _useInput$meta.submitError,
      submitFailed = _useInput$meta.submitFailed,
      isRequired = _useInput.isRequired;

  var hasError = (error || submitError) && (touched || submitFailed);
  var selectedValue = useMemo$1(function () {
    var filteredData = choices === null || choices === void 0 ? void 0 : choices.filter(function (c) {
      return get$1(formState === null || formState === void 0 ? void 0 : formState.values, props === null || props === void 0 ? void 0 : props.source) === get$1(c, optionValue);
    });
    return (filteredData === null || filteredData === void 0 ? void 0 : filteredData.length) > 0 ? filteredData[0] : null;
  }, [formState, props === null || props === void 0 ? void 0 : props.source, choices]);
  var handleChange = useCallback(function (_, values) {
    var id = get$1(values, optionValue);
    onChange(id);
  });
  var handleOptionLabel = useCallback(function (option) {
    return typeof optionText === "function" ? optionText(option) : get$1(option, optionText);
  }, [optionText]);
  var handleTextChange = useDebouncedCallback(function (e) {
    return setFilter(e.target.value);
  }, 1000);
  return /*#__PURE__*/React__default.createElement(Autocomplete$1, _extends({}, rest, {
    classes: classes,
    options: choices,
    onChange: handleChange,
    disabled: disabled,
    getOptionLabel: handleOptionLabel,
    value: selectedValue,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default.createElement(TextField$1, _extends({
        error: hasError,
        margin: margin,
        variant: variant,
        onChange: handleTextChange,
        helperText: /*#__PURE__*/React__default.createElement(InputHelperText, {
          helperText: helperText || "",
          touched: touched,
          error: submitError
        }),
        required: isRequired,
        label: /*#__PURE__*/React__default.createElement(FieldTitle, {
          label: props === null || props === void 0 ? void 0 : props.label,
          source: props === null || props === void 0 ? void 0 : props.source,
          resource: props === null || props === void 0 ? void 0 : props.resource
        })
      }, params));
    }
  }));
};

var _excluded$u = ["displayedFilters", "filterValues", "setFilters"];
var DATE_FORMAT = "YYYY-MM-DD";
var DATE_RANGE_EXPR = {
  all: function all() {
    return {
      start_at: null,
      end_at: null,
      day: null
    };
  },
  today: function today() {
    return {
      start_at: moment().format(DATE_FORMAT),
      end_at: moment().format(DATE_FORMAT),
      day: undefined
    };
  },
  yesterday: function yesterday() {
    return {
      start_at: moment().subtract(1, "days").format(DATE_FORMAT),
      end_at: moment().subtract(1, "days").format(DATE_FORMAT),
      day: undefined
    };
  },
  last_7_days: function last_7_days() {
    return {
      start_at: moment().subtract(7, "days").format(DATE_FORMAT),
      end_at: moment().format(DATE_FORMAT),
      day: undefined
    };
  },
  last_30_days: function last_30_days() {
    return {
      start_at: moment().subtract(30, "days").format(DATE_FORMAT),
      end_at: moment().format(DATE_FORMAT),
      day: undefined
    };
  },
  prev_week: function prev_week() {
    return {
      start_at: moment().subtract(1, "weeks").startOf("isoWeek").format(DATE_FORMAT),
      end_at: moment().subtract(1, "weeks").endOf("isoWeek").format(DATE_FORMAT),
      day: undefined
    };
  },
  this_month: function this_month() {
    return {
      name: function name(props, translate) {
        return translate("app.date_range.this_month", {
          month: moment().format("MMMM")
        });
      },
      start_at: moment().startOf("month").format(DATE_FORMAT),
      end_at: moment().endOf("month").format(DATE_FORMAT),
      day: undefined
    };
  },
  last_month: function last_month() {
    return {
      name: function name(props, translate) {
        return translate("app.date_range.last_month", {
          month: moment().subtract(1, "months").format("MMMM")
        });
      },
      start_at: moment().subtract(1, "months").startOf("month").format(DATE_FORMAT),
      end_at: moment().subtract(1, "months").endOf("month").format(DATE_FORMAT),
      day: undefined
    };
  },
  last_two_months: function last_two_months() {
    return {
      name: function name(props, translate) {
        return translate("app.date_range.last_two_months", {
          from: moment().subtract(1, "months").format("MMMM"),
          to: moment().format("MMMM")
        });
      },
      start_at: moment().subtract(1, "months").startOf("month").format(DATE_FORMAT),
      end_at: moment().endOf("month").format(DATE_FORMAT),
      day: undefined
    };
  },
  range: function range() {
    return {
      start_at: moment().startOf("month").format(DATE_FORMAT),
      end_at: moment().endOf("month").format(DATE_FORMAT),
      day: undefined
    };
  },
  day: function day() {
    return {
      start_at: null,
      end_at: null,
      day: moment().format(DATE_FORMAT)
    };
  }
};

var getRanges = function getRanges(props, translate) {
  return Object.keys(DATE_RANGE_EXPR).map(function (id) {
    var nameResolver = function nameResolver(props, translate) {
      return translate("app.date_range.".concat(id));
    };

    var expr = get$1(DATE_RANGE_EXPR, "".concat(id), function () {
      return {
        name: nameResolver
      };
    })();
    var name = get$1(expr, "name", nameResolver)(props, translate);
    return {
      id: id,
      name: name
    };
  });
};

var DateRangeSelectInput = function DateRangeSelectInput(_ref) {
  var displayedFilters = _ref.displayedFilters,
      filterValues = _ref.filterValues,
      setFilters = _ref.setFilters,
      props = _objectWithoutProperties(_ref, _excluded$u);

  var translate = useTranslate$1();

  var handleChange = function handleChange(evt) {
    var value = evt.target.value;
    var range = get$1(DATE_RANGE_EXPR, value, get$1(DATE_RANGE_EXPR, "today"))();

    var newFilters = _objectSpread2(_objectSpread2({}, filterValues), {}, _defineProperty({}, props.source, value), range);

    setFilters(newFilters, displayedFilters);
  };

  return /*#__PURE__*/React__default.createElement(SelectInput, _extends({}, props, {
    label: props.label || "app.date_range.label",
    choices: getRanges(props, translate),
    onChange: handleChange
  }));
};

var _excluded$t = ["startAtSource", "endAtSource", "daySource"];
var useStyles$d = makeStyles(function (theme) {
  return {
    input: {
      marginRight: theme.spacing(1)
    }
  };
});

var DateRangeInput = function DateRangeInput(_ref) {
  var _ref$startAtSource = _ref.startAtSource,
      startAtSource = _ref$startAtSource === void 0 ? "start_at" : _ref$startAtSource,
      _ref$endAtSource = _ref.endAtSource,
      endAtSource = _ref$endAtSource === void 0 ? "end_at" : _ref$endAtSource,
      _ref$daySource = _ref.daySource,
      daySource = _ref$daySource === void 0 ? "day" : _ref$daySource,
      props = _objectWithoutProperties(_ref, _excluded$t);

  var classes = useStyles$d();

  var _useListContext = useListContext(props),
      displayedFilters = _useListContext.displayedFilters,
      filterValues = _useListContext.filterValues,
      setFilters = _useListContext.setFilters;

  var viewMode = useMemo$1(function () {
    return get$1(filterValues, props.source);
  }, [filterValues, props.source]);
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(DateRangeSelectInput, _extends({}, props, {
    label: props.label || "app.date_range.label",
    displayedFilters: displayedFilters,
    filterValues: filterValues,
    setFilters: setFilters,
    className: classnames(["range", "day"].indexOf(viewMode) > -1 && classes.input)
  })), viewMode === "range" && /*#__PURE__*/React__default.createElement(DateInput, _extends({}, props, {
    className: classes.input,
    label: "app.label.start_at",
    source: startAtSource,
    alwaysOn: true,
    fullWidth: true
  })), viewMode === "range" && /*#__PURE__*/React__default.createElement(DateInput, _extends({}, props, {
    className: classes.input,
    label: "app.label.end_at",
    source: endAtSource,
    fullWidth: true
  })), viewMode === "day" && /*#__PURE__*/React__default.createElement(DateInput, _extends({}, props, {
    className: classes.input,
    label: "app.label.day",
    source: daySource,
    alwaysOn: true
  })));
};

var _excluded$s = ["variant", "margin"],
    _excluded2$6 = ["name", "onChange", "value"];
var useStyles$c = makeStyles$1(function (theme) {
  return {
    leftInput_filled: {
      "& .MuiInputBase-root": {
        borderTopRightRadius: 0
      },
      "& label": {
        overflow: "visible",
        minWidth: 250,
        transform: "translate(12px, 10px) scale(0.75)"
      },
      marginBottom: theme.spacing(1)
    },
    leftInput_outlined: {
      "& label": {
        width: "90%",
        overflow: "visible",
        transform: "translate(12px, 10px) scale(0.75)"
      },
      marginBottom: theme.spacing(1)
    },
    rightInput_filled: {
      "& .MuiInputBase-root": {
        borderTopLeftRadius: 0
      },
      marginBottom: theme.spacing(1)
    },
    rightInput_outlined: {
      marginLeft: theme.spacing(1)
    }
  };
});

var getDateAndTime = function getDateAndTime(value) {
  var dateAndTime = value.indexOf("T") !== -1 ? value.split("T") : value.split(" ");
  var date = get$1(dateAndTime, "[0]", "");
  var time = get$1(dateAndTime, "[1]", "").substr(0, 5);
  return {
    date: date,
    time: time
  };
};

var DateTimeInput = function DateTimeInput(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? "dense" : _ref$margin,
      props = _objectWithoutProperties(_ref, _excluded$s);

  var classes = useStyles$c();

  var _useInput = useInput(props),
      _useInput$input = _useInput.input;
      _useInput$input.name;
      var onChange = _useInput$input.onChange,
      value = _useInput$input.value,
      rest = _objectWithoutProperties(_useInput$input, _excluded2$6),
      _useInput$meta = _useInput.meta,
      touched = _useInput$meta.touched,
      error = _useInput$meta.error,
      submitError = _useInput$meta.submitError,
      isRequired = _useInput.isRequired;

  var _useMemo = useMemo$1(function () {
    return getDateAndTime(value);
  }, [value]),
      date = _useMemo.date,
      time = _useMemo.time;

  var stopTimeChange = !value || value === null;
  var handleChange = useCallback(function (part) {
    return function (e) {
      var _getDateAndTime = getDateAndTime(value),
          date = _getDateAndTime.date,
          time = _getDateAndTime.time;

      switch (part) {
        case "date":
          date = e.target.value;
          break;

        case "time":
          time = e.target.value;
          break;
      }

      var dateAndTime = [date, time].join(" ");
      onChange(dateAndTime);
    };
  }, [value, onChange]);
  var translate = useTranslate$1();
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TextField$1, _extends({}, rest, {
    label: /*#__PURE__*/React__default.createElement(FieldTitle, {
      label: props === null || props === void 0 ? void 0 : props.label,
      source: props === null || props === void 0 ? void 0 : props.source,
      resource: props === null || props === void 0 ? void 0 : props.resource
    }),
    variant: variant,
    margin: margin,
    type: "date",
    error: !!(touched && (error || submitError)),
    helperText: touched && (error && translate(error) || submitError && translate(submitError)),
    required: isRequired,
    classes: {
      root: classes["leftInput_".concat(variant)]
    },
    value: date,
    onChange: handleChange("date"),
    InputLabelProps: {
      shrink: true
    }
  })), /*#__PURE__*/React__default.createElement(TextField$1, _extends({
    variant: variant,
    margin: margin,
    type: "time",
    error: !!(touched && (error || submitError)),
    required: isRequired,
    classes: {
      root: classes["rightInput_".concat(variant)]
    },
    value: time,
    onChange: stopTimeChange ? null : handleChange("time")
  }, rest)));
};

function useDebounce(value, delay) {
  // State and setters for debounced value
  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      debouncedValue = _useState2[0],
      setDebouncedValue = _useState2[1];

  useEffect(function () {
    // Update debounced value after delay
    var handler = setTimeout(function () {
      setDebouncedValue(value);
    }, delay); // Cancel the timeout if value changes (also on delay change or unmount)
    // This is how we prevent debounced value from updating if value is changed ...
    // .. within the delay period. Timeout gets cleared and restarted.

    return function () {
      clearTimeout(handler);
    };
  }, [value, delay] // Only re-call effect if value or delay changes
  );
  return debouncedValue;
}

var _excluded$r = ["margin", "variant", "fullWidth", "maxLength", "multiline", "format", "rows", "disabled", "delay", "InputProps", "InputLabelProps"],
    _excluded2$5 = ["name", "onChange"];

var DebouncedTextInput = function DebouncedTextInput(_ref) {
  var _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? "dense" : _ref$margin,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      fullWidth = _ref.fullWidth,
      maxLength$1 = _ref.maxLength,
      multiline = _ref.multiline,
      format = _ref.format,
      rows = _ref.rows,
      disabled = _ref.disabled,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 500 : _ref$delay,
      InputProps = _ref.InputProps,
      InputLabelProps = _ref.InputLabelProps,
      props = _objectWithoutProperties(_ref, _excluded$r);

  var className = props.className,
      source = props.source,
      resource = props.resource,
      label = props.label;
  var validationFn = maxLength(maxLength$1);
  var helperText = props.helperText;
  var validate = props.validate;

  if (!validate) {
    validate = [validationFn];
  } else if (Array.isArray(validate)) {
    if (validate.indexOf(validationFn) === -1) {
      validate.push(validationFn);
    }
  }

  var _useInput = useInput(_objectSpread2({
    validate: validate
  }, props)),
      _useInput$input = _useInput.input,
      name = _useInput$input.name,
      onChange = _useInput$input.onChange,
      rest = _objectWithoutProperties(_useInput$input, _excluded2$5),
      _useInput$meta = _useInput.meta,
      touched = _useInput$meta.touched,
      error = _useInput$meta.error,
      submitError = _useInput$meta.submitError,
      isRequired = _useInput.isRequired;

  var translate = useTranslate$2();
  var defaultValue = props.type === "number" ? 0 : "";

  var _React$useState = React__default.useState(rest.value !== undefined ? rest.value : defaultValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _useFormState = useFormState({
    subscription: {
      values: true
    }
  }),
      values = _useFormState.values;

  var formValue = get$1(values, source, defaultValue);
  var didMountEffect = useRef(false);
  var didUpdateValue = useRef(false);
  useEffect(function () {
    if (didMountEffect.current === false) {
      didMountEffect.current = true;
      return;
    }

    if (formValue && formValue !== null) {
      // didUpdateValue.current = true;
      setValue(formValue);
    }
  }, [formValue]);
  var handleChange = useCallback(function (evt) {
    return setValue(evt.target.value);
  }, []);
  var debouncedValue = useDebounce(value, delay);
  var didMountChange = useRef(false);
  useEffect(function () {
    if (didMountChange.current === false) {
      didMountChange.current = true;
      return;
    }

    if (didUpdateValue.current === true) {
      didUpdateValue.current = false;
      return;
    }

    var compareToValue = formValue !== null ? formValue : defaultValue;

    if (debouncedValue !== compareToValue) {
      onChange(debouncedValue);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [debouncedValue, onChange]);
  var usedCharsInfo = translate("app.input.max_length_info", {
    count: get$1(value, "length", 0),
    max: maxLength$1
  });

  if (maxLength$1) {
    helperText = helperText && helperText.length > 0 ? "".concat(usedCharsInfo, " - ").concat(translate(helperText)) : usedCharsInfo;
  }

  return /*#__PURE__*/React__default.createElement(TextField$1, _extends({}, rest, {
    disabled: disabled,
    name: name,
    className: className,
    fullWidth: fullWidth,
    multiline: multiline,
    rows: rows,
    variant: variant,
    margin: margin,
    value: format ? format(value) : value,
    label: label !== "" && label !== false && /*#__PURE__*/React__default.createElement(FieldTitle$1, {
      label: label,
      source: source,
      resource: resource
    }),
    onChange: handleChange,
    error: !!(touched && (error || submitError)),
    helperText: /*#__PURE__*/React__default.createElement(InputHelperText$1, {
      touched: touched,
      error: error || submitError,
      helperText: helperText
    }),
    InputLabelProps: InputLabelProps,
    InputProps: InputProps,
    inputProps: {
      maxLength: maxLength$1
    },
    required: isRequired
  }));
};

/**
 * Convert Date object to String
 *
 * @param {Date} value value to convert
 * @returns {String} A standardized date (yyyy-MM-dd), to be passed to an <input type="date" />
 */

var convertDateToString = function convertDateToString(value) {
  if (!(value instanceof Date) || isNaN(value.getDate())) return "";
  var pad = "00";
  var yyyy = value.getFullYear().toString();
  var MM = (value.getMonth() + 1).toString();
  var dd = value.getDate().toString();
  return "".concat(yyyy, "-").concat((pad + MM).slice(-2), "-").concat((pad + dd).slice(-2));
};

var dateRegex = /^\d{4}-\d{2}-\d{2}$/;
var defaultInputLabelProps = {
  shrink: true
};

var getStringFromDate = function getStringFromDate(value) {
  // null, undefined and empty string values should not go through dateFormatter
  // otherwise, it returns undefined and will make the input an uncontrolled one.
  if (value == null || value === "") {
    return "";
  }

  if (value instanceof Date) {
    return convertDateToString(value);
  } // valid dates should not be converted


  if (dateRegex.test(value)) {
    return value;
  }

  return convertDateToString(new Date(value));
};

var DebouncedDateInput = function DebouncedDateInput(props) {
  return /*#__PURE__*/React__default.createElement(DebouncedTextInput, _extends({}, props, {
    type: "date",
    format: getStringFromDate,
    InputLabelProps: defaultInputLabelProps
  }));
};

var convertStringToNumber = function convertStringToNumber(value) {
  var float = parseFloat(value);
  return isNaN(float) ? null : float;
};

var DebouncedNumberInput = function DebouncedNumberInput(props) {
  return /*#__PURE__*/React__default.createElement(DebouncedTextInput, _extends({}, props, {
    type: "number",
    parse: convertStringToNumber
  }));
};

var ImageInput = function ImageInput(props) {
  return /*#__PURE__*/React__default.createElement(ImageInput$1, props, /*#__PURE__*/React__default.createElement(CoverField, {
    source: "file.path",
    title: "file.name"
  }));
};

var useWorkflowInput = function useWorkflowInput(_ref) {
  var resource = _ref.resource,
      source = _ref.source,
      record = _ref.record;

  var _useGetIdentity = useGetIdentity$1(),
      loaded = _useGetIdentity.loaded,
      loading = _useGetIdentity.loading,
      identity = _useGetIdentity.identity;

  var roles = useMemo$1(function () {
    return !loading && loaded ? identity === null || identity === void 0 ? void 0 : identity.roles : [];
  }, [identity, loading, loaded]);

  var _useContext = useContext(WorkflowContext),
      getWorkflow = _useContext.getWorkflow;

  var workflow = useMemo$1(function () {
    return getWorkflow(resource);
  }, [resource, getWorkflow]);

  var _useMemo = useMemo$1(function () {
    var visible = workflow && workflow.canReadField(source, roles, record);
    var disabled = workflow && !workflow.canEditField(source, roles, record);
    return {
      visible: visible,
      disabled: disabled
    };
  }, [workflow, source, record, roles]),
      visible = _useMemo.visible,
      disabled = _useMemo.disabled;

  return {
    visible: visible,
    disabled: disabled
  };
};

var _excluded$q = ["component", "disabled"];

var Input$1 = function Input(_ref) {
  var component = _ref.component;
      _ref.disabled;
      var props = _objectWithoutProperties(_ref, _excluded$q);

  var _useMemo = useMemo$1(function () {
    var resource = get$1(props, "resource", component.props.resource);
    var source = get$1(props, "source", component.props.source);
    var record = get$1(props, "record", component.props.record);
    return {
      resource: resource,
      source: source,
      record: record
    };
  }, [props, component]),
      resource = _useMemo.resource,
      source = _useMemo.source,
      record = _useMemo.record;

  var _useWorkflowInput = useWorkflowInput(_objectSpread2(_objectSpread2({}, props), {}, {
    resource: resource,
    source: source,
    record: record
  })),
      visible = _useWorkflowInput.visible,
      disable = _useWorkflowInput.disabled;

  if (!visible) {
    return null;
  }

  return /*#__PURE__*/React__default.cloneElement(component, _objectSpread2(_objectSpread2(_objectSpread2({}, component.props), props), {}, {
    disabled: disable,
    resource: resource,
    source: source,
    record: record
  }));
};

var RecordInput = function RecordInput(_ref) {
  var source = _ref.source,
      record = _ref.record,
      resource = _ref.resource,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 300 : _ref$minWidth;

  var _useState = useState(get$1(record, source, "")),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      updating = _useState4[0],
      setUpdating = _useState4[1];

  var handleChange = useCallback(function (evt) {
    return setValue(evt.target.value);
  }, []);
  var dataProvider = useDataProvider$1();
  var handleKeyPress = useCallback(function (evt) {
    var _objectSpread2$1;

    if (evt.key !== "Enter") {
      return;
    }

    setUpdating(true);
    dataProvider.update(resource, {
      id: record.id,
      data: _objectSpread2(_objectSpread2({}, record), {}, (_objectSpread2$1 = {}, _defineProperty(_objectSpread2$1, source, value), _defineProperty(_objectSpread2$1, "_changed", source), _objectSpread2$1))
    }).then(function () {
      return setUpdating(false);
    });
  }, [value, dataProvider, resource, record, source]);
  var handleBlur = useCallback(function () {
    var _objectSpread3;

    if (get$1(record, source) === value) {
      return;
    }

    setUpdating(true);
    dataProvider.update(resource, {
      id: record.id,
      data: _objectSpread2(_objectSpread2({}, record), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, source, value), _defineProperty(_objectSpread3, "_changed", source), _objectSpread3))
    }).then(function () {
      return setUpdating(false);
    });
  }, [value, dataProvider, resource, source, record]);
  useEffect(function () {
    return setValue(get$1(record, source));
  }, [record, source]);
  return /*#__PURE__*/React__default.createElement(TextField$1, {
    value: value,
    disabled: updating,
    onChange: handleChange,
    onKeyPress: handleKeyPress,
    onBlur: handleBlur,
    style: {
      minWidth: minWidth,
      width: "100%"
    },
    multiline: true,
    InputProps: {
      "arial-label": "naked"
    }
  });
};

var LanguageMessageInput = function LanguageMessageInput(props) {
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TextField, _extends({}, props, {
    source: "code",
    variant: "caption",
    fullWidth: true
  })), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement(RecordInput, _extends({}, props, {
    fullWidth: true
  })));
};

var _excluded$p = ["title", "disabled", "empty", "FieldComponent"];
var useStyles$b = makeStyles(function (theme) {
  return {
    root: {
      padding: theme.spacing(2),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5)
    }
  };
});

var MediaInput = function MediaInput(_ref) {
  var title = _ref.title,
      disabled = _ref.disabled,
      _ref$empty = _ref.empty,
      empty = _ref$empty === void 0 ? "Empty" : _ref$empty,
      _ref$FieldComponent = _ref.FieldComponent,
      FieldComponent = _ref$FieldComponent === void 0 ? MediaField : _ref$FieldComponent,
      props = _objectWithoutProperties(_ref, _excluded$p);

  var classes = useStyles$b();
  var notify = useNotify$1();
  var handleRejection = useCallback(function () {
    return props !== null && props !== void 0 && props.multiple ? notify("ra.message.files_rejected", {
      type: "error"
    }) : notify("ra.message.file_rejected", {
      type: "error"
    });
  }, [props === null || props === void 0 ? void 0 : props.multiple, notify]);

  if (disabled) {
    var value = get$1(props.record, props.source);
    var files = value ? Array.isArray(value) ? value : [value] : [];
    return /*#__PURE__*/React__default.createElement(Labeled, props, /*#__PURE__*/React__default.createElement(Fragment, null, files.map(function (file, index) {
      return /*#__PURE__*/React__default.createElement(FieldComponent, {
        key: index,
        record: file,
        source: "filepath",
        title: title
      });
    }), files.length === 0 && disabled && empty && /*#__PURE__*/React__default.createElement(Typography$1, {
      key: "empty",
      variant: "body2",
      classes: classes,
      dangerouslySetInnerHTML: {
        __html: empty
      }
    }), /*#__PURE__*/React__default.createElement(FormHelperText, null, /*#__PURE__*/React__default.createElement(InputHelperText, {
      touched: false,
      error: false,
      helperText: props.helperText
    }))));
  }

  return /*#__PURE__*/React__default.createElement(FileInput, _extends({}, props, {
    options: _objectSpread2({
      onDropRejected: handleRejection
    }, props === null || props === void 0 ? void 0 : props.options)
  }), /*#__PURE__*/React__default.createElement(FieldComponent, {
    source: "filepath",
    title: title
  }));
};

var _excluded$o = ["optionText", "helperText"];

var ReferenceAutocompleteInput$1 = function ReferenceAutocompleteInput(_ref) {
  var optionText = _ref.optionText,
      helperText = _ref.helperText,
      props = _objectWithoutProperties(_ref, _excluded$o);

  return /*#__PURE__*/React__default.createElement(ReferenceInput, props, /*#__PURE__*/React__default.createElement(AutocompleteInput, {
    optionText: optionText,
    helperText: helperText
  }));
};

var useManyFormatter = function useManyFormatter() {
  var memoizedFn = useMemo$1(function () {
    return createManyFormatter();
  }, []);
  return memoizedFn;
};

var useManyParser = function useManyParser() {
  var memoizedFn = useMemo$1(function () {
    return createManyParser();
  }, []);
  return memoizedFn;
};

var _excluded$n = ["optionText"];
var useStyles$a = makeStyles(function (theme) {
  return {
    root: {
      "& legend": {
        marginBottom: theme.spacing(1)
      }
    }
  };
});

var ReferenceCheckboxGroupInput = function ReferenceCheckboxGroupInput(_ref) {
  var optionText = _ref.optionText,
      props = _objectWithoutProperties(_ref, _excluded$n);

  var parse = useManyParser();
  var format = useManyFormatter();
  var classes = useStyles$a();
  return /*#__PURE__*/React__default.createElement(ReferenceArrayInput, _extends({}, props, {
    parse: parse,
    format: format
  }), /*#__PURE__*/React__default.createElement(CheckboxGroupInput, {
    classes: classes,
    optionText: optionText
  }));
};

var _excluded$m = ["optionText", "helperText"];

var ReferenceAutocompleteInput = function ReferenceAutocompleteInput(_ref) {
  var optionText = _ref.optionText,
      helperText = _ref.helperText,
      props = _objectWithoutProperties(_ref, _excluded$m);

  return /*#__PURE__*/React__default.createElement(ReferenceInput, props, /*#__PURE__*/React__default.createElement(SelectInput, {
    optionText: optionText,
    helperText: helperText
  }));
};

var _excluded$l = ["dependency"];

var slugify = function slugify(str) {
  return str === null || str === void 0 ? void 0 : str.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
};

var validate = function validate(value) {
  if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value)) {
    return "ra.validation.slug";
  }

  return undefined;
};

var SlugInput = function SlugInput(_ref) {
  var dependency = _ref.dependency,
      props = _objectWithoutProperties(_ref, _excluded$l);

  var form = useForm();

  var _useFormState = useFormState({
    subscription: {
      values: true,
      touched: true
    }
  }),
      values = _useFormState.values,
      touched = _useFormState.touched;

  useEffect(function () {
    if (dependency && values[dependency] && !touched[props.source]) {
      form.change(props.source, slugify(values[dependency]));
    }
  }, [dependency, form, props.source, values[dependency], touched]);
  var handleSlugify = useCallback(function () {
    if (values[dependency]) {
      form.change(props.source, slugify(values[dependency]));
    }
  }, [dependency, form, props.source, values[dependency], touched]);
  return /*#__PURE__*/React__default.createElement(DebouncedTextInput, _extends({}, props, {
    validate: validate,
    InputProps: {
      endAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton, {
        "aria-label": "generate slug from ".concat(dependency),
        onClick: handleSlugify,
        onMouseDown: handleSlugify
      }, /*#__PURE__*/React__default.createElement(RefreshIcon, null)))
    }
  }));
};

var _excluded$k = ["filter"];
var useStyles$9 = makeStyles(function () {
  return {
    root: {
      minWidth: 200
    }
  };
});

var StateArrayInput = function StateArrayInput(_ref) {
  var _ref$filter = _ref.filter,
      filter = _ref$filter === void 0 ? undefined : _ref$filter,
      props = _objectWithoutProperties(_ref, _excluded$k);

  var classes = useStyles$9();

  var _useContext = useContext(WorkflowContext),
      getWorkflow = _useContext.getWorkflow;

  var workflow = useMemo$1(function () {
    return getWorkflow(props.resource);
  }, [props.resource, getWorkflow]);
  var states = useMemo$1(function () {
    return workflow ? workflow.states.filter(function (s) {
      return !s.isLoop && (filter === undefined || filter(s));
    }) : [];
  }, [workflow, filter]);
  return /*#__PURE__*/React__default.createElement(SelectArrayInput, _extends({}, props, {
    className: classes.root,
    choices: states,
    optionText: "name",
    optionValue: "code",
    allowEmpty: true,
    emptyText: "ra.action.all"
  }));
};

var stopPropagation = function stopPropagation(e) {
  return e.stopPropagation();
};

var useStyles$8 = makeStyles$1(function (theme) {
  return {
    required: {}
  };
});

var ConfirmMove = function ConfirmMove(_ref) {
  var _ref$admin = _ref.admin,
      admin = _ref$admin === void 0 ? false : _ref$admin,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? false : _ref$open,
      resource = _ref.resource,
      record = _ref.record,
      state = _ref.state,
      onCancel = _ref.onCancel;
  var classes = useStyles$8();
  var refresh = useRefresh();
  var notify = useNotify$1();

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      notes = _useState2[0],
      setNotes = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isPrivate = _useState4[0],
      setPrivate = _useState4[1];

  var _useContext = useContext(WorkflowContext),
      getWorkflow = _useContext.getWorkflow;

  var workflow = useMemo$1(function () {
    return getWorkflow(resource);
  }, [getWorkflow, resource]);
  var translate = useTranslate$1();
  var handleChange = useCallback(function (e) {
    return setNotes(e.target.value);
  }, [setNotes]);
  var handlePrivate = useCallback(function (e) {
    return setPrivate(e.target.checked);
  }, [setPrivate]);
  var needsNotes = useMemo$1(function () {
    return workflow && workflow.needsNotes(record, state);
  }, [workflow, record, state]);

  var _useUpdate = useUpdate(resource, record.id, _objectSpread2(_objectSpread2({}, record), {}, {
    state: get$1(state, "code"),
    notes: notes,
    is_private: isPrivate
  }), record, {
    onSuccess: function onSuccess() {
      notify("resources.workflow.move.success");
      refresh();
    },
    onFailure: function onFailure(_ref2) {
      var message = _ref2.message,
          body = _ref2.body,
          status = _ref2.status;
      onCancel();
      notify("resources.workflow.move.error", "error", {
        reason: message,
        message: message,
        body: body,
        status: status
      });
    }
  }),
      _useUpdate2 = _slicedToArray(_useUpdate, 2),
      handleUpdate = _useUpdate2[0],
      loading = _useUpdate2[1].loading;

  return /*#__PURE__*/React__default.createElement(Dialog, {
    open: open,
    onClick: stopPropagation
  }, /*#__PURE__*/React__default.createElement(DialogTitle, null, translate("resources.workflow.move.title"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption",
    display: "block"
  }, state === null || state === void 0 ? void 0 : state.label)), /*#__PURE__*/React__default.createElement(DialogContent, null, /*#__PURE__*/React__default.createElement(DialogContentText, {
    className: classnames(needsNotes && classes.required)
  }, translate("resources.workflow.move.message" + (needsNotes ? ".required" : ""))), /*#__PURE__*/React__default.createElement(TextField$1, {
    autoFocus: true,
    onChange: handleChange,
    margin: "dense",
    id: "notes",
    label: translate("resources.workflow.fields.notes"),
    type: "text",
    multiline: true,
    fullWidth: true
  }), admin && /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(FormControlLabel, {
    control: /*#__PURE__*/React__default.createElement(Switch, {
      checked: isPrivate,
      onChange: handlePrivate,
      name: "is_private",
      color: "primary"
    }),
    label: translate("resources.workflow.fields.is_private")
  }), /*#__PURE__*/React__default.createElement(FormHelperText, null, translate("resources.workflow.fields.is_private.help")))), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: onCancel
  }, translate("ra.action.cancel")), /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: handleUpdate,
    color: "primary",
    disabled: needsNotes && notes.length === 0 || loading
  }, translate("ra.action.confirm"))));
};

ConfirmMove.propTypes = {
  state: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string
  }),
  resource: PropTypes.string.isRequired,
  record: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired
};

var StateCollectionInput = function StateCollectionInput(_ref) {
  var _ref$readonly = _ref.readonly,
      readonly = _ref$readonly === void 0 ? false : _ref$readonly,
      _ref$admin = _ref.admin,
      admin = _ref$admin === void 0 ? false : _ref$admin,
      record = _ref.record,
      toResolve = _ref.resource;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var _useGetIdentity = useGetIdentity$1(),
      loading = _useGetIdentity.loading,
      loaded = _useGetIdentity.loaded,
      identity = _useGetIdentity.identity;

  var roles = useMemo$1(function () {
    return !loading && loaded ? identity === null || identity === void 0 ? void 0 : identity.roles : [];
  }, [loading, loaded, identity]);
  var resource = useMemo$1(function () {
    return toResolve.replace("workflow/transactions/", "");
  }, [toResolve]);

  var _useContext = useContext(WorkflowContext),
      getWorkflow = _useContext.getWorkflow;

  var workflow = useMemo$1(function () {
    return getWorkflow(resource);
  }, [getWorkflow, resource]);

  var _useMemo = useMemo$1(function () {
    var currentState = workflow && workflow.getState(_objectSpread2(_objectSpread2({}, record), {}, {
      // If component is used inside TransactionLogsField the transaction is referencing
      // current record. I have to get it to make workflow work.
      transaction: get$1(record, "transaction", record)
    })) || undefined;
    var nextStates = workflow.getNextStates(roles, record);
    return {
      currentState: currentState,
      nextStates: nextStates
    };
  }, [roles, record, workflow]),
      currentState = _useMemo.currentState,
      nextStates = _useMemo.nextStates;

  var _React$useState = React__default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handleClick = function handleClick(e) {
    e.stopPropagation();
    e.preventDefault();
    setAnchorEl(e.currentTarget);
  };

  var handleClose = function handleClose(e) {
    e.stopPropagation();
    e.preventDefault();
    setAnchorEl(null);
    setState(null);
  };

  var handleChange = useCallback(function (state) {
    return function (e) {
      e.stopPropagation();
      e.preventDefault();
      setAnchorEl(null);
      setState(state);
    };
  }, []);

  if (readonly || nextStates.length === 0) {
    // If user is not admin and there are no next states, show current state
    return /*#__PURE__*/React__default.createElement(StateField, {
      record: record,
      resource: toResolve
    });
  }

  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Button$1, {
    disableElevation: true,
    endIcon: /*#__PURE__*/React__default.createElement(ArrowDropDown, null),
    color: "primary",
    variant: "contained",
    "aria-controls": "simple-menu",
    "aria-haspopup": "true",
    style: {
      textAlign: "left"
    },
    size: "small",
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement(LongTextField, {
    record: currentState,
    source: "name",
    variant: "body2"
  })), /*#__PURE__*/React__default.createElement(Menu$2, {
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: handleClose
  }, nextStates.map(function (state) {
    return /*#__PURE__*/React__default.createElement(MenuItem$1, {
      key: get$1(state, "code"),
      onClick: handleChange(state)
    }, get$1(state, "label"));
  })), /*#__PURE__*/React__default.createElement(ConfirmMove, {
    admin: admin,
    open: state !== null,
    resource: resource,
    record: record,
    state: state,
    onCancel: handleClose
  }));
};

var _excluded$j = ["filter"];

var StateInput = function StateInput(_ref) {
  var _ref$filter = _ref.filter,
      filter = _ref$filter === void 0 ? undefined : _ref$filter,
      props = _objectWithoutProperties(_ref, _excluded$j);

  var _useContext = useContext(WorkflowContext),
      getWorkflow = _useContext.getWorkflow;

  var workflow = useMemo$1(function () {
    return getWorkflow(props.resource);
  }, [props.resource, getWorkflow]);
  var states = useMemo$1(function () {
    return workflow ? workflow.states.filter(function (s) {
      return !s.isLoop && (filter === undefined || filter(s));
    }) : [];
  }, [workflow, filter]);
  return /*#__PURE__*/React__default.createElement(SelectInput, _extends({}, props, {
    choices: states,
    optionText: "name",
    optionValue: "code",
    allowEmpty: true,
    emptyText: "ra.action.all"
  }));
};

var _excluded$i = ["variant", "margin", "size"],
    _excluded2$4 = ["name"];
var useStyles$7 = makeStyles(function (theme) {
  return {
    root: {
      "& .MuiInputBase-root": {
        borderTopRightRadius: 0
      },
      "& label": {
        width: "90%",
        overflow: "visible",
        transform: "translate(12px, 10px) scale(0.75)"
      },
      marginBottom: theme.spacing(1)
    }
  };
});

var TimeInput = function TimeInput(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$margin = _ref.margin,
      margin = _ref$margin === void 0 ? "dense" : _ref$margin,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "small" : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded$i);

  var classes = useStyles$7();

  var _useInput = useInput(_objectSpread2({}, props)),
      _useInput$input = _useInput.input;
      _useInput$input.name;
      var rest = _objectWithoutProperties(_useInput$input, _excluded2$4),
      _useInput$meta = _useInput.meta,
      touched = _useInput$meta.touched,
      error = _useInput$meta.error,
      submitError = _useInput$meta.submitError,
      isRequired = _useInput.isRequired;

  return /*#__PURE__*/React__default.createElement(TextField$1, _extends({
    label: /*#__PURE__*/React__default.createElement(FieldTitle, {
      label: props === null || props === void 0 ? void 0 : props.label,
      source: props === null || props === void 0 ? void 0 : props.source,
      resource: props === null || props === void 0 ? void 0 : props.resource
    }),
    variant: variant,
    margin: margin,
    size: size,
    type: "time",
    error: !!(touched && (error || submitError)),
    required: isRequired,
    className: props === null || props === void 0 ? void 0 : props.className,
    classes: classes,
    InputLabelProps: {
      shrink: true
    }
  }, rest));
};

var TransactionNotesInput = function TransactionNotesInput(props) {
  var translate = useTranslate$1();
  var fieldLabel = useFieldLabel({
    resource: "transactions"
  });
  var label = useMemo$1(function () {
    return props.label || fieldLabel("notes");
  }, [props.label, fieldLabel]);
  var helperText = useMemo$1(function () {
    return translate(props.helperText);
  }, [props.helperText, translate]);
  return /*#__PURE__*/React__default.createElement(DebouncedTextInput, _extends({}, props, {
    label: label,
    helperText: helperText,
    maxLength: 1500,
    multiline: true
  }));
};

var _excluded$h = ["label", "helperText", "admin"];

var TransactionNotesIsPrivateInput = function TransactionNotesIsPrivateInput(_ref) {
  var label = _ref.label,
      helperText = _ref.helperText,
      _ref$admin = _ref.admin,
      admin = _ref$admin === void 0 ? false : _ref$admin,
      props = _objectWithoutProperties(_ref, _excluded$h);

  var fieldLabel = useFieldLabel({
    resource: "transactions"
  });

  if (!admin) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(BooleanInput, _extends({
    label: label || fieldLabel("is_private", false),
    helperText: helperText || fieldLabel("is_private.helper_text"),
    source: "is_private"
  }, props));
};

var inputs = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Autocomplete: Autocomplete$1,
  AutocompleteArrayInput: AutocompleteArrayInput,
  AutocompleteInput: AutocompleteInput,
  BooleanInput: BooleanInput,
  DateInput: DateInput,
  DateRangeInput: DateRangeInput,
  DateTimeInput: DateTimeInput,
  DebouncedDateInput: DebouncedDateInput,
  DebouncedNumberInput: DebouncedNumberInput,
  DebouncedTextInput: DebouncedTextInput,
  ImageInput: ImageInput,
  Input: Input$1,
  LanguageMessageInput: LanguageMessageInput,
  MediaInput: MediaInput,
  NullableBooleanInput: NullableBooleanInput,
  NumberInput: NumberInput,
  RecordInput: RecordInput,
  ReferenceAutocompleteInput: ReferenceAutocompleteInput$1,
  ReferenceCheckboxGroupInput: ReferenceCheckboxGroupInput,
  ReferenceSelectInput: ReferenceAutocompleteInput,
  SearchInput: SearchInput,
  SelectInput: SelectInput,
  SlugInput: SlugInput,
  StateArrayInput: StateArrayInput,
  StateCollectionInput: StateCollectionInput,
  StateInput: StateInput,
  TextInput: TextInput,
  TimeInput: TimeInput,
  TransactionNotesInput: TransactionNotesInput,
  TransactionNotesIsPrivateInput: TransactionNotesIsPrivateInput
});

var NotificationList = function NotificationList(_ref) {
  var props = _extends({}, _ref);

  var theme = useTheme();

  var _useMemo = useMemo$1(function () {
    return {
      type: theme.palette.type,
      colorize: theme.palette.type === "dark" ? darken : lighten,
      density: theme.palette.type === "dark" ? 0.5 : 0.9
    };
  }, [theme.palette.type]),
      type = _useMemo.type,
      colorize = _useMemo.colorize,
      density = _useMemo.density;

  var handleRowStyle = useCallback(function (record) {
    return {
      marginLeft: -2,
      borderLeftWidth: 2,
      borderLeftStyle: "solid",
      borderLeftColor: record !== null && record !== void 0 && record.readed ? colorize(theme.palette.primary[type], density) : theme.palette.secondary[type],
      backgroundColor: record !== null && record !== void 0 && record.readed ? colorize(theme.palette.primary[type], density) : colorize(theme.palette.secondary[type], density)
    };
  }, [theme, type, colorize, density]);
  var dataProvider = useDataProvider$1();
  var handleRowClick = useCallback(function (id, basePath, record) {
    dataProvider.update("notifications", {
      id: record.id,
      data: _objectSpread2(_objectSpread2({}, record), {}, {
        readed: moment().format()
      })
    });
    return record === null || record === void 0 ? void 0 : record.resource;
  }, [dataProvider]);
  return /*#__PURE__*/React__default.createElement(Datagrid, _extends({}, props, {
    evenOdd: false,
    rowClick: handleRowClick,
    rowStyle: handleRowStyle
  }), /*#__PURE__*/React__default.createElement(NotificationField, {
    source: "notification",
    sortable: false
  }), /*#__PURE__*/React__default.createElement(DateAgoField, {
    source: "created"
  }));
};

var lists = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Datagrid: Datagrid,
  NotificationList: NotificationList
});

var _require = require("ra-core"),
    getResources = _require.getResources;

var _require2 = require("react-redux"),
    shallowEqual = _require2.shallowEqual,
    useSelector = _require2.useSelector;

var _require3 = require("lodash"),
    get = _require3.get;

var useCustomComponents = function useCustomComponents(resource) {
  var _useContext = useContext(CrudContext),
      components = _useContext.components;

  var resources = useSelector(getResources, shallowEqual);
  return useMemo$1(function () {
    var r = resources.find(function (r) {
      return r.name === resource;
    });
    return _objectSpread2(_objectSpread2({}, get(r, "options.components")), components);
  }, [components, resources, resource]);
};

var _excluded$g = ["tabs"],
    _excluded2$3 = ["componentProps"],
    _excluded3$1 = ["fullWidth"];

var TabbedForm = function TabbedForm(_ref) {
  var tabs = _ref.tabs,
      props = _objectWithoutProperties(_ref, _excluded$g);

  var _useContext = useContext(CrudContext),
      getForm = _useContext.getForm;

  var _useContext2 = useContext(WorkflowContext),
      getWorkflow = _useContext2.getWorkflow;

  var form = useMemo$1(function () {
    return getForm(props.resource);
  }, [props.resource, getForm]);
  var workflow = useMemo$1(function () {
    return form !== null && form !== void 0 && form.useWorkflow ? getWorkflow(props.resource) : null;
  }, [props.resource, getWorkflow, form]);
  var customComponents = useCustomComponents(props.resource);
  return /*#__PURE__*/React__default.createElement(TabbedForm$1, props, tabs.map(function (_ref2, index) {
    var _tab$inputs;

    var label = _ref2.componentProps.label,
        tab = _objectWithoutProperties(_ref2, _excluded2$3);

    return /*#__PURE__*/React__default.createElement(FormTab$1, {
      key: index,
      label: label
    }, tab === null || tab === void 0 ? void 0 : (_tab$inputs = tab.inputs) === null || _tab$inputs === void 0 ? void 0 : _tab$inputs.map(function (_ref3) {
      var source = _ref3.source,
          label = _ref3.label,
          component = _ref3.component,
          useWorkflow = _ref3.useWorkflow,
          _ref3$componentProps = _ref3.componentProps,
          fullWidth = _ref3$componentProps.fullWidth,
          restComponentProps = _objectWithoutProperties(_ref3$componentProps, _excluded3$1);

      return form !== null && form !== void 0 && form.useWorkflow && workflow !== null && useWorkflow === true ? /*#__PURE__*/React__default.createElement(Input$1, {
        key: source,
        source: source,
        fullWidth: true,
        component: /*#__PURE__*/React__default.createElement(Component, {
          key: source,
          source: source,
          label: label,
          fullWidth: fullWidth,
          component: component,
          componentProps: _objectSpread2({
            fullWidth: fullWidth
          }, restComponentProps),
          components: _objectSpread2(_objectSpread2(_objectSpread2({}, fields), inputs), customComponents)
        })
      }) : /*#__PURE__*/React__default.createElement(Component, {
        key: source,
        source: source,
        label: label,
        fullWidth: fullWidth,
        component: component,
        componentProps: _objectSpread2({
          fullWidth: fullWidth
        }, restComponentProps),
        components: _objectSpread2(_objectSpread2(_objectSpread2({}, fields), inputs), customComponents)
      });
    }));
  }));
};

/**
 *
 * @param {Object} props
 * @param {Function} props.onSuccess
 * @param {Function} props.onFailure
 * @param {Function} props.errorMapper
 * @param {Function} props.transform
 * @param {String} props.type - mutation type
 * @returns
 */

var useSaveMutation = function useSaveMutation(_ref) {
  var basePath = _ref.basePath,
      _ref$errorMapper = _ref.errorMapper,
      errorMapper = _ref$errorMapper === void 0 ? createErrorMapper() : _ref$errorMapper,
      _ref$onSuccess = _ref.onSuccess,
      onSuccess = _ref$onSuccess === void 0 ? undefined : _ref$onSuccess,
      _ref$redir = _ref.redir,
      redir = _ref$redir === void 0 ? null : _ref$redir,
      redirect = _ref.redirect,
      _ref$refresh = _ref.refresh,
      refresh = _ref$refresh === void 0 ? true : _ref$refresh,
      resource = _ref.resource,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? undefined : _ref$transform,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? null : _ref$type;

  var _useMutation = useMutation$1(),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      mutate = _useMutation2[0];

  var doRedirect = useRedirect();
  var doRefresh = useRefresh$1();
  var notify = useNotify();
  var save = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
      var response, errors;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return mutate({
                type: type === null ? values.id && values.id > 0 ? "update" : "create" : type,
                resource: resource,
                payload: {
                  id: values.id,
                  data: transform ? transform(values) : values
                }
              }, {
                returnPromise: true
              });

            case 3:
              response = _context.sent;
              _context.next = 10;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              errors = errorMapper(_context.t0, notify);
              return _context.abrupt("return", errors);

            case 10:
              if (!onSuccess) {
                if (redir) {
                  redirect(redir);
                } else if (refresh === true) {
                  if (values.id > 0) {
                    doRefresh();
                  } else {
                    doRedirect("edit", basePath, response.data.id);
                  }
                } else {
                  doRedirect(redirect, basePath, response.data.id);
                }

                notify("ra.notification." + (values.id > 0 ? "updated" : "created"), {
                  type: "info",
                  messageArgs: {
                    smart_count: 1
                  }
                });
              } else onSuccess(response, values);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 6]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [basePath, doRedirect, doRefresh, errorMapper, mutate, notify, onSuccess, redir, redirect, refresh, resource, transform, type]);
  return save;
};

var _excluded$f = ["fullWidth"];

var Form = function Form(_ref) {
  var _form$toolbar, _form$toolbar2, _form$toolbar3, _form$inputs;

  var props = _extends({}, _ref);

  var _useContext = useContext(CrudContext),
      getForm = _useContext.getForm,
      loading = _useContext.loading,
      components = _useContext.components;

  var _useContext2 = useContext(WorkflowContext),
      getWorkflow = _useContext2.getWorkflow;

  var form = useMemo$1(function () {
    return getForm(props.resource);
  }, [props.resource, getForm]);
  var workflow = useMemo$1(function () {
    return form !== null && form !== void 0 && form.useWorkflow ? getWorkflow(props.resource) : null;
  }, [props.resource, getWorkflow, form]);
  var customComponents = useCustomComponents(props.resource);
  var backUrl = useBackUrl(_objectSpread2(_objectSpread2({}, props), form === null || form === void 0 ? void 0 : (_form$toolbar = form.toolbar) === null || _form$toolbar === void 0 ? void 0 : _form$toolbar.componentProps));
  var save = useSaveMutation(_objectSpread2(_objectSpread2({}, props), {}, {
    refresh: form === null || form === void 0 ? void 0 : form.refresh,
    redirect: (form === null || form === void 0 ? void 0 : form.redirect) !== null ? form === null || form === void 0 ? void 0 : form.redirect : backUrl
  }));

  if (loading) {
    return /*#__PURE__*/React__default.createElement(Loading, null);
  }

  if (form === false || form === null) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(Component, _extends({}, props, {
    save: save,
    toolbar: /*#__PURE__*/React__default.createElement(Component, {
      component: form === null || form === void 0 ? void 0 : (_form$toolbar2 = form.toolbar) === null || _form$toolbar2 === void 0 ? void 0 : _form$toolbar2.component,
      componentProps: _objectSpread2({
        useWorkflow: form === null || form === void 0 ? void 0 : form.useWorkflow,
        useCustomButtons: form === null || form === void 0 ? void 0 : form.useCustomButtons,
        buttons: form === null || form === void 0 ? void 0 : form.buttons,
        components: _objectSpread2(_objectSpread2({}, buttons), customComponents)
      }, form === null || form === void 0 ? void 0 : (_form$toolbar3 = form.toolbar) === null || _form$toolbar3 === void 0 ? void 0 : _form$toolbar3.componentProps),
      components: _objectSpread2(_objectSpread2({
        Toolbar: Toolbar
      }, buttons), customComponents)
    }),
    initialValues: form === null || form === void 0 ? void 0 : form.initialValues,
    sanitizeEmptyValues: form === null || form === void 0 ? void 0 : form.sanitizeEmptyValues,
    warnWhenUnsavedChanges: form === null || form === void 0 ? void 0 : form.warnWhenUnsavedChanges,
    redirect: (form === null || form === void 0 ? void 0 : form.redirect) !== null ? form === null || form === void 0 ? void 0 : form.redirect : backUrl,
    component: form === null || form === void 0 ? void 0 : form.component,
    componentProps: form === null || form === void 0 ? void 0 : form.componentProps,
    components: _objectSpread2(_objectSpread2({
      SimpleForm: SimpleForm,
      TabbedForm: TabbedForm
    }, components), customComponents)
  }), form === null || form === void 0 ? void 0 : (_form$inputs = form.inputs) === null || _form$inputs === void 0 ? void 0 : _form$inputs.map(function (_ref2) {
    var source = _ref2.source,
        label = _ref2.label,
        component = _ref2.component,
        useWorkflow = _ref2.useWorkflow,
        _ref2$componentProps = _ref2.componentProps,
        fullWidth = _ref2$componentProps.fullWidth,
        restComponentProps = _objectWithoutProperties(_ref2$componentProps, _excluded$f);

    return form !== null && form !== void 0 && form.useWorkflow && workflow !== null && useWorkflow === true ? /*#__PURE__*/React__default.createElement(Input$1, {
      key: source,
      source: source,
      fullWidth: true,
      component: /*#__PURE__*/React__default.createElement(Component, {
        key: source,
        source: source,
        label: label,
        fullWidth: fullWidth,
        component: component,
        componentProps: _objectSpread2({
          fullWidth: fullWidth,
          components: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, fields), inputs), components), customComponents)
        }, restComponentProps),
        components: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, fields), inputs), components), customComponents)
      })
    }) : /*#__PURE__*/React__default.createElement(Component, {
      key: source,
      source: source,
      label: label,
      fullWidth: fullWidth,
      component: component,
      componentProps: _objectSpread2({
        fullWidth: fullWidth,
        components: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, fields), inputs), components), customComponents)
      }, restComponentProps),
      components: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, fields), inputs), components), customComponents)
    });
  }));
};

var Create$1 = function Create(props) {
  return /*#__PURE__*/React__default.createElement(Create$3, props, /*#__PURE__*/React__default.createElement(Form, null));
};

/**
 * Provide access to top right actions for create/edit form.
 *
 * @param {Object} props
 * @param {Array} props.buttons List of buttons to display.
 * @param {Object} props.components Map of button components.
 * @returns {JSX.Element}
 */

var FormActions = function FormActions(_ref) {
  var basePath = _ref.basePath,
      data = _ref.data,
      resource = _ref.resource,
      buttons = _ref.buttons,
      components = _ref.components;
  return /*#__PURE__*/React__default.createElement(TopToolbar, null, buttons.map(function (_ref2, index) {
    var component = _ref2.component,
        componentProps = _ref2.componentProps;
    return /*#__PURE__*/React__default.createElement(Component, {
      key: index,
      component: component,
      componentProps: _objectSpread2({
        basePath: basePath,
        record: data,
        data: data,
        resource: resource
      }, componentProps),
      components: components
    });
  }));
};

var Create = function Create(props) {
  var _form$actions;

  var _useContext = useContext(CrudContext),
      getForm = _useContext.getForm,
      components = _useContext.components;

  var customComponents = useCustomComponents(props.resource);
  var form = useMemo$1(function () {
    return getForm(props.resource);
  }, [props.resource, getForm]);
  return /*#__PURE__*/React__default.createElement(Edit, _extends({}, props, {
    actions: (form === null || form === void 0 ? void 0 : (_form$actions = form.actions) === null || _form$actions === void 0 ? void 0 : _form$actions.length) > 0 ? /*#__PURE__*/React__default.createElement(FormActions, {
      resource: props.resource,
      buttons: form === null || form === void 0 ? void 0 : form.actions,
      components: _objectSpread2(_objectSpread2(_objectSpread2({}, buttons), components), customComponents)
    }) : false
  }), /*#__PURE__*/React__default.createElement(Form, null));
};

var _excluded$e = ["grid", "customComponents"],
    _excluded2$2 = ["className", "exporter", "filters"],
    _excluded3 = ["label", "component", "componentProps"];

var ListActions = function ListActions(_ref) {
  var grid = _ref.grid,
      customComponents = _ref.customComponents,
      props = _objectWithoutProperties(_ref, _excluded$e);

  var className = props.className,
      exporter = props.exporter,
      filtersProp = props.filters,
      rest = _objectWithoutProperties(props, _excluded2$2);

  var _useListContext = useListContext$1(props),
      currentSort = _useListContext.currentSort,
      displayedFilters = _useListContext.displayedFilters,
      filterValues = _useListContext.filterValues,
      basePath = _useListContext.basePath,
      showFilter = _useListContext.showFilter,
      total = _useListContext.total;

  var resource = useResourceContext(rest);

  var _useResourceDefinitio = useResourceDefinition(rest),
      hasCreate = _useResourceDefinitio.hasCreate;

  var filters = useContext(FilterContext) || filtersProp;
  return useMemo$1(function () {
    var _grid$exportTo, _grid$actions;

    return /*#__PURE__*/React.createElement(TopToolbar, _extends({
      className: className
    }, sanitizeListRestProps(rest)), filtersProp ? /*#__PURE__*/cloneElement(filtersProp, {
      resource: resource,
      showFilter: showFilter,
      displayedFilters: displayedFilters,
      filterValues: filterValues,
      context: "button"
    }) : filters && /*#__PURE__*/React.createElement(FilterButton, null), (grid === null || grid === void 0 ? void 0 : grid.canCreate) !== false && hasCreate && /*#__PURE__*/React.createElement(CreateButton, {
      basePath: basePath
    }), (grid === null || grid === void 0 ? void 0 : (_grid$exportTo = grid.exportTo) === null || _grid$exportTo === void 0 ? void 0 : _grid$exportTo.length) > 0 ? /*#__PURE__*/React.createElement(ExportToButton, {
      exportTo: grid === null || grid === void 0 ? void 0 : grid.exportTo,
      disabled: total === 0,
      resource: resource,
      sort: currentSort,
      filterValues: filterValues
    }) : exporter !== false && /*#__PURE__*/React.createElement(ExportButton$1, {
      disabled: total === 0,
      resource: resource,
      sort: currentSort,
      filterValues: filterValues
    }), grid === null || grid === void 0 ? void 0 : (_grid$actions = grid.actions) === null || _grid$actions === void 0 ? void 0 : _grid$actions.map(function (_ref2, index) {
      var label = _ref2.label,
          component = _ref2.component,
          componentProps = _ref2.componentProps,
          props = _objectWithoutProperties(_ref2, _excluded3);

      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        key: index,
        label: label,
        component: component,
        componentProps: componentProps,
        components: _objectSpread2(_objectSpread2({}, buttons), customComponents)
      }));
    }));
  },
  /* eslint-disable react-hooks/exhaustive-deps */
  [resource, displayedFilters, filterValues, showFilter, filters, total, basePath, className, currentSort, exporter, hasCreate]);
};

ListActions.propTypes = {
  basePath: PropTypes.string,
  className: PropTypes.string,
  currentSort: PropTypes.any,
  displayedFilters: PropTypes.object,
  exporter: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  filters: PropTypes.element,
  filterValues: PropTypes.object,
  hasCreate: PropTypes.bool,
  resource: PropTypes.string,
  onUnselectItems: PropTypes.func.isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.any),
  showFilter: PropTypes.func,
  total: PropTypes.number
};
ListActions.defaultProps = {
  selectedIds: [],
  onUnselectItems: function onUnselectItems() {
    return null;
  }
};

var _excluded$d = ["grid", "customComponents"];

var ListBulkActionButtons = function ListBulkActionButtons(_ref) {
  var _grid$bulkActionButto;

  var grid = _ref.grid,
      customComponents = _ref.customComponents,
      props = _objectWithoutProperties(_ref, _excluded$d);

  return /*#__PURE__*/React__default.createElement(Fragment, null, grid === null || grid === void 0 ? void 0 : (_grid$bulkActionButto = grid.bulkActionButtons) === null || _grid$bulkActionButto === void 0 ? void 0 : _grid$bulkActionButto.map(function (_ref2, index) {
    var component = _ref2.component,
        componentProps = _ref2.componentProps;
    return /*#__PURE__*/React__default.createElement(Component, _extends({}, props, {
      key: index,
      component: component,
      componentProps: componentProps,
      components: _objectSpread2(_objectSpread2({}, buttons), customComponents)
    }));
  }), (grid === null || grid === void 0 ? void 0 : grid.canDelete) !== false && /*#__PURE__*/React__default.createElement(BulkDeleteButton, props));
};

var _excluded$c = ["grid", "create"];
/**
 * Empty component for the List view when there is no data to display.
 *
 * @param {Object} props
 * @param {Object} props.grid
 *  Grid configuration used to render the Empty.
 *  Generally this prop is passed by Crud when rendering lists using backend
 *  descriptors and is not necessary when using it as your own component.
 * @param {Boolean} props.create
 *  Set to false to disable the creation button.
 *  This param is useful to force CreateButton to be disabled.
 *
 * @returns {React.Component}
 */

var ListEmpty = function ListEmpty(_ref) {
  var grid = _ref.grid,
      _ref$create = _ref.create,
      create = _ref$create === void 0 ? true : _ref$create,
      props = _objectWithoutProperties(_ref, _excluded$c);

  var _useListContext = useListContext$1(props),
      basePath = _useListContext.basePath,
      hasCreate = _useListContext.hasCreate;

  var resource = useResourceContext(props);
  var classes = useStyles$6(props);
  var translate = useTranslate$2();
  var getResourceLabel = useGetResourceLabel();
  var resourceName = translate("resources.".concat(resource, ".forcedCaseName"), {
    smart_count: 0,
    _: getResourceLabel(resource, 0)
  });
  var emptyMessage = translate("ra.page.empty", {
    name: resourceName
  });
  var inviteMessage = translate("ra.page.invite");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.message
  }, /*#__PURE__*/React.createElement(Inbox, {
    className: classes.icon
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    paragraph: true
  }, translate("resources.".concat(resource, ".empty"), {
    _: emptyMessage
  })), create && hasCreate && (grid === null || grid === void 0 ? void 0 : grid.canCreate) !== false && /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, translate("resources.".concat(resource, ".invite"), {
    _: inviteMessage
  }))), create && hasCreate && (grid === null || grid === void 0 ? void 0 : grid.canCreate) !== false && /*#__PURE__*/React.createElement("div", {
    className: classes.toolbar
  }, /*#__PURE__*/React.createElement(CreateButton, {
    variant: "contained",
    basePath: basePath,
    label: translate("resources.".concat(resource, ".create"), {
      _: "ra.action.create"
    })
  })));
};

var useStyles$6 = makeStyles(function (theme) {
  return {
    message: {
      textAlign: "center",
      opacity: theme.palette.type === "light" ? 0.5 : 0.8,
      margin: "0 1em",
      color: theme.palette.type === "light" ? "inherit" : theme.palette.text.primary
    },
    icon: {
      width: "9em",
      height: "9em"
    },
    toolbar: {
      textAlign: "center",
      marginTop: "2em"
    }
  };
}, {
  name: "FobListEmpty"
});

var exporter = function exporter(grid, data, translate) {
  var columns = ((grid === null || grid === void 0 ? void 0 : grid.columns) || []).filter(function (c) {
    return c.exportable === true;
  });
  var headers = columns.map(function (c) {
    return get$1(c, "label", c.source);
  });
  var csvData = data.map(function (record) {
    var row = {};
    columns.forEach(function (column) {
      var value = get$1(record, column.source);
      row[column.label] = value;
    });
    return row;
  });
  jsonExport(csvData, {
    rowDelimiter: ";",
    headers: headers
  }, function (err, csv) {
    return downloadCSV("\uFEFF" + csv, translate(grid === null || grid === void 0 ? void 0 : grid.title));
  });
};

var List = function List(props) {
  var _grid$mobilePrimaryCo, _grid$mobilePrimaryCo2, _grid$mobileSecondary, _grid$mobileSecondary2, _grid$mobileTertiaryC, _grid$mobileTertiaryC2;

  var translate = useTranslate$1();

  var _React$useContext = React.useContext(CrudContext),
      getGrid = _React$useContext.getGrid,
      loading = _React$useContext.loading;

  var grid = getGrid(props.resource);
  var customComponents = useCustomComponents(props.resource);
  var isMobile = useMediaQuery(function (theme) {
    var _grid$mobileBreakpoin;

    return theme.breakpoints.down((_grid$mobileBreakpoin = grid === null || grid === void 0 ? void 0 : grid.mobileBreakpoint) !== null && _grid$mobileBreakpoin !== void 0 ? _grid$mobileBreakpoin : "sm");
  }) && grid.mobilePrimaryText != null;
  var hasBulkActionButtons = React.useMemo(function () {
    var _grid$bulkActionButto;

    return (grid === null || grid === void 0 ? void 0 : (_grid$bulkActionButto = grid.bulkActionButtons) === null || _grid$bulkActionButto === void 0 ? void 0 : _grid$bulkActionButto.length) > 0 || (grid === null || grid === void 0 ? void 0 : grid.canDelete) !== false;
  }, [grid === null || grid === void 0 ? void 0 : grid.bulkActionButtons, grid === null || grid === void 0 ? void 0 : grid.canDelete]);

  if (loading) {
    return /*#__PURE__*/React.createElement(Loading, null);
  }

  if (grid === false || grid === null) {
    return null;
  }

  return /*#__PURE__*/React.createElement(List$2, _extends({}, props, {
    title: grid.title,
    filter: grid.filter || {},
    actions: /*#__PURE__*/React.createElement(ListActions, {
      grid: grid,
      customComponents: customComponents
    }),
    pagination: grid === null || grid === void 0 ? void 0 : grid.pagination,
    exporter: (grid === null || grid === void 0 ? void 0 : grid.exporter) !== false ? function (data) {
      return exporter(grid, data, translate);
    } : false,
    filterDefaultValues: grid.filterDefaultValues || {},
    sort: grid === null || grid === void 0 ? void 0 : grid.sort,
    empty: /*#__PURE__*/React.createElement(ListEmpty, {
      grid: grid
    }),
    perPage: grid === null || grid === void 0 ? void 0 : grid.perPage,
    bulkActionButtons: hasBulkActionButtons ? /*#__PURE__*/React.createElement(ListBulkActionButtons, {
      grid: grid,
      customComponents: customComponents
    }) : false,
    filters: grid !== null && grid !== void 0 && grid.filters ? /*#__PURE__*/React.createElement(Filter, {
      variant: grid === null || grid === void 0 ? void 0 : grid.filterVariant,
      margin: grid === null || grid === void 0 ? void 0 : grid.filterMargin
    }, Component.mapFilters(grid.filters, _objectSpread2(_objectSpread2({}, inputs), customComponents))) : null
  }), grid !== null && grid !== void 0 && grid.component && (grid === null || grid === void 0 ? void 0 : grid.component) !== "Datagrid" ? /*#__PURE__*/React.createElement(Component, {
    component: grid.component,
    componentProps: grid.componentProps,
    components: _objectSpread2(_objectSpread2({
      Datagrid: Datagrid,
      SimpleList: SimpleList
    }, lists), customComponents)
  }) : isMobile ? /*#__PURE__*/React.createElement(SimpleList, {
    linkType: grid === null || grid === void 0 ? void 0 : grid.mobileLinkType,
    primarySource: grid === null || grid === void 0 ? void 0 : grid.mobilePrimaryText,
    primaryComponent: grid === null || grid === void 0 ? void 0 : (_grid$mobilePrimaryCo = grid.mobilePrimaryComponent) === null || _grid$mobilePrimaryCo === void 0 ? void 0 : _grid$mobilePrimaryCo.component,
    primaryComponentProps: grid === null || grid === void 0 ? void 0 : (_grid$mobilePrimaryCo2 = grid.mobilePrimaryComponent) === null || _grid$mobilePrimaryCo2 === void 0 ? void 0 : _grid$mobilePrimaryCo2.componentProps,
    secondarySource: grid === null || grid === void 0 ? void 0 : grid.mobileSecondaryText,
    secondaryComponent: grid === null || grid === void 0 ? void 0 : (_grid$mobileSecondary = grid.mobileSecondaryComponent) === null || _grid$mobileSecondary === void 0 ? void 0 : _grid$mobileSecondary.component,
    secondaryComponentProps: grid === null || grid === void 0 ? void 0 : (_grid$mobileSecondary2 = grid.mobileSecondaryComponent) === null || _grid$mobileSecondary2 === void 0 ? void 0 : _grid$mobileSecondary2.componentProps,
    tertiarySource: grid === null || grid === void 0 ? void 0 : grid.mobileTertiaryText,
    tertiaryComponent: grid === null || grid === void 0 ? void 0 : (_grid$mobileTertiaryC = grid.mobileTertiaryComponent) === null || _grid$mobileTertiaryC === void 0 ? void 0 : _grid$mobileTertiaryC.component,
    tertiaryComponentProps: grid === null || grid === void 0 ? void 0 : (_grid$mobileTertiaryC2 = grid.mobileTertiaryComponent) === null || _grid$mobileTertiaryC2 === void 0 ? void 0 : _grid$mobileTertiaryC2.componentProps,
    components: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, fields), inputs), buttons), customComponents)
  }) : /*#__PURE__*/React.createElement(Datagrid, grid === null || grid === void 0 ? void 0 : grid.componentProps, Component.mapColumns(grid === null || grid === void 0 ? void 0 : grid.columns, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, fields), inputs), buttons), customComponents))));
};

var createCrud = function createCrud(_ref) {
  var _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? null : _ref$icon,
      _ref$list = _ref.list,
      list = _ref$list === void 0 ? List : _ref$list,
      _ref$create = _ref.create,
      create = _ref$create === void 0 ? Create$1 : _ref$create,
      _ref$edit = _ref.edit,
      edit = _ref$edit === void 0 ? Create : _ref$edit,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {
    group: "admin",
    roles: ["admin"]
  } : _ref$options,
      _ref$components = _ref.components,
      components = _ref$components === void 0 ? {} : _ref$components;
  return {
    icon: icon,
    options: _objectSpread2(_objectSpread2({}, options), {}, {
      components: components
    }),
    list: list,
    edit: edit,
    create: create
  };
};

var _excluded$b = ["icon", "roles", "group", "options", "workflow", "components"];
var defaultIcon = TableChart;
var defaultGroup = "dashboard";
/**
 * Create a CRUD resource ready to be used in a react-admin.
 *
 * @param {Object} props
 *
 * @param {JSX.Element} props.icon
 *  The icon to use for the resource.
 *  Icon is displayed in the sidebar.
 *
 * @param {String} props.roles
 *  The roles that can access the resource.
 *  If not defined, the resource is accessible to all roles.
 *
 * @param {String} props.group
 *  The group to display the resource in the sidebar.
 *  If not defined, the resource is displayed in the "dashboard" group.
 *
 * @param {String} props.name
 *  The name of the resource.
 *
 * @param {Object} props.components
 *  List of custom components usable in the resource.
 *
 * @param {Boolean|null} props.workflow
 *  If true, the resource will be handled by the workflow.
 */

var CrudResource = function CrudResource(_ref) {
  var icon = _ref.icon,
      roles = _ref.roles,
      group = _ref.group,
      options = _ref.options;
      _ref.workflow;
      var components = _ref.components,
      props = _objectWithoutProperties(_ref, _excluded$b);

  var crudProps = useMemo$1(function () {
    return createCrud({
      icon: icon,
      options: _objectSpread2(_objectSpread2({}, options), {}, {
        roles: roles,
        group: group
      }),
      components: components
    });
  }, [icon, roles, group, options, components]);
  return /*#__PURE__*/React__default.createElement(Resource, _extends({}, crudProps, props));
};

CrudResource.propTypes = {
  name: PropTypes.string.isRequired,
  roles: PropTypes.arrayOf(PropTypes.string),
  group: PropTypes.string.isRequired,
  icon: PropTypes.elementType.isRequired,
  list: PropTypes.elementType,
  edit: PropTypes.elementType,
  create: PropTypes.elementType,
  options: PropTypes.object,
  components: PropTypes.object
};
CrudResource.defaultProps = {
  icon: defaultIcon,
  group: defaultGroup,
  components: {},
  workflow: true
};

var _excluded$a = ["saving", "save", "mutationMode"],
    _excluded2$1 = ["children"];

var sanitizeInputProps = function sanitizeInputProps(props) {
  props.saving;
      props.save;
      props.mutationMode;
      var inputProps = _objectWithoutProperties(props, _excluded$a);

  return inputProps;
};

var BaseProfileForm = function BaseProfileForm(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded2$1);

  var notify = useNotify$1();
  var save = useSaveMutation(_objectSpread2(_objectSpread2({}, props), {}, {
    resource: "users/profile",
    redirect: "/",
    onSuccess: function onSuccess(_ref2) {
      var _ref2$data = _ref2.data,
          email = _ref2$data.email,
          profile = _ref2$data.profile;
      localStorage.setItem("profile", JSON.stringify(_objectSpread2({
        email: email
      }, profile)));
      notify("ra.message.profile_updated");
    }
  }));
  return /*#__PURE__*/React__default.createElement(SimpleForm, _extends({}, props, {
    toolbar: /*#__PURE__*/React__default.createElement(Toolbar$3, null, /*#__PURE__*/React__default.createElement(SaveButton, null)),
    save: save
  }), React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.isValidElement(child) ? /*#__PURE__*/React__default.cloneElement(child, _objectSpread2({}, sanitizeInputProps(props))) : child;
  }));
};

var LocalLoginForm = function LocalLoginForm(props) {
  return /*#__PURE__*/React__default.createElement(LoginForm, props);
};

var _excluded$9 = ["logo", "children", "themeOverride"];
var useStyles$5 = makeStyles(function (theme) {
  return {
    main: {
      overflow: "hidden",
      minHeight: "98vh",
      backgroundImage: "none",
      backgroundColor: theme.palette.background.default,
      "& [class*=MuiAvatar-root]": {
        display: "none",
        visibility: "hidden"
      }
    }
  };
});

var LoginPage = function LoginPage(_ref) {
  var logo = _ref.logo,
      children = _ref.children,
      themeOverride = _ref.themeOverride,
      props = _objectWithoutProperties(_ref, _excluded$9);

  var themeProp = useRef(themeOverride);

  var _useState = useState(function () {
    return createTheme(themeOverride);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      theme = _useState2[0],
      setTheme = _useState2[1];

  useEffect(function () {
    if (themeProp.current !== themeOverride) {
      themeProp.current = themeOverride;
      setTheme(createTheme(themeOverride));
    }
  }, [themeOverride, themeProp, theme, setTheme]);
  var location = props.location;
  var search = location.search;
  var classes = useStyles$5();
  var action = useMemo$1(function () {
    if (search) {
      var params = new URLSearchParams(search);
      return params.get("action");
    }

    return null;
  }, [search]);
  return /*#__PURE__*/React__default.createElement(ThemeProvider$1, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(Login, {
    backgroundImage: "",
    theme: theme,
    classes: classes
  }, logo, React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.isValidElement(child) ? /*#__PURE__*/React__default.cloneElement(child, _objectSpread2({
      action: action,
      themeOverride: theme
    }, props)) : child;
  })));
};

LoginPage.propTypes = {
  action: PropTypes.string,
  logo: PropTypes.element
};

var _excluded$8 = ["formData"];

var ProfileForm = function ProfileForm(props) {
  return /*#__PURE__*/React__default.createElement(BaseProfileForm, props, /*#__PURE__*/React__default.createElement(DebouncedTextInput, {
    source: "email",
    validate: [required(), email()]
  }), /*#__PURE__*/React__default.createElement(DebouncedTextInput, {
    source: "profile.name",
    validate: required(),
    maxLength: 50
  }), /*#__PURE__*/React__default.createElement(DebouncedTextInput, {
    source: "profile.surname",
    validate: required(),
    maxLength: 50
  }), /*#__PURE__*/React__default.createElement(FormDataConsumer, null, function (_ref) {
    var formData = _ref.formData,
        props = _objectWithoutProperties(_ref, _excluded$8);

    return formData.auth === "local" && /*#__PURE__*/React__default.createElement(DebouncedTextInput, _extends({}, props, {
      type: "password",
      source: "password"
    }));
  }));
};

var _excluded$7 = ["children", "staticContext", "title"];

var ProfilePage = function ProfilePage(_ref) {
  var children = _ref.children;
      _ref.staticContext;
      var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "ra.page.profile.title" : _ref$title,
      props = _objectWithoutProperties(_ref, _excluded$7);

  return /*#__PURE__*/React__default.createElement(Edit, _extends({}, props, {
    id: "profile",
    title: title,
    resource: "users",
    basePath: "users"
  }), /*#__PURE__*/React__default.isValidElement(children) ? /*#__PURE__*/React__default.cloneElement(children, _objectSpread2({}, props)) : children);
};

ProfilePage.propTypes = {
  children: PropTypes.element,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
}; // ProfilePage.defaultProps = {

var useStyles$4 = makeStyles(function (theme) {
  return {
    button: {
      margin: theme.spacing(1),
      width: "calc(100% - ".concat(theme.spacing(2), "px)")
    }
  };
});

var ResetPasswordLinkButton = function ResetPasswordLinkButton(_ref) {
  var _ref$href = _ref.href,
      href = _ref$href === void 0 ? "/#/reset-password" : _ref$href,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "outlined" : _ref$variant,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "ra.auth.reset_password" : _ref$label;
  var classes = useStyles$4();
  var translate = useTranslate$2();
  return /*#__PURE__*/React__default.createElement(Button$1, {
    className: classes.button,
    href: href,
    color: color,
    type: "button",
    variant: variant
  }, translate(label));
};

var _excluded$6 = ["siteKey", "reset"];

var addScript = function addScript(_ref) {
  var src = _ref.src,
      id = _ref.id,
      onLoad = _ref.onLoad;
  var existing = document.getElementById(id);

  if (existing) {
    return existing;
  } else {
    var script = document.createElement("script");
    script.src = src;
    script.id = id;
    script.async = true;

    script.onload = function () {
      if (onLoad) {
        onLoad();
      }
    };

    document.body.appendChild(script);
    return script;
  }
};

var removeScript = function removeScript(_ref2) {
  var id = _ref2.id;
  var script = document.getElementById(id);

  if (script) {
    document.body.removeChild(script);
  }
};

var RecaptchaInput = function RecaptchaInput(_ref3) {
  var siteKey = _ref3.siteKey;
      _ref3.reset;
      var props = _objectWithoutProperties(_ref3, _excluded$6);

  var _useInput = useInput$1(_objectSpread2({}, props)),
      onChange = _useInput.input.onChange;

  useEffect(function () {
    addScript({
      src: "https://www.google.com/recaptcha/api.js?render=".concat(siteKey),
      id: "recaptcha-api",
      onLoad: function onLoad() {
        // eslint-disable-next-line no-undef
        grecaptcha.ready(function () {
          // eslint-disable-next-line no-undef
          grecaptcha.execute(siteKey, {
            action: "submit"
          }).then(onChange);
        });
      }
    });
    return function () {
      return removeScript({
        id: "recaptcha-api"
      });
    };
  }, [siteKey, onChange]);
  return null;
};

var useResetPassword = function useResetPassword() {
  var dataProvider = useDataProvider$2();
  var handler = useCallback(function (_ref) {
    var account = _ref.account,
        token = _ref.token;
    return dataProvider.post("users/reset-password", {
      account: account,
      token: token
    });
  }, [dataProvider]);
  return handler;
};

var _excluded$5 = ["meta", "input"];
var useStyles$3 = makeStyles(function (theme) {
  return {
    form: {
      padding: "0 1em 1em 1em"
    },
    input: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    button: {
      width: "100%",
      display: "block",
      clear: "both",
      marginTop: theme.spacing(1)
    },
    icon: {
      marginRight: theme.spacing(1)
    }
  };
}, {
  name: "RaResetPasswordForm"
});

var Input = function Input(_ref) {
  var _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      inputProps = _ref.input,
      props = _objectWithoutProperties(_ref, _excluded$5);

  return /*#__PURE__*/React.createElement(TextField$1, _extends({
    error: !!(touched && error),
    helperText: touched && error
  }, inputProps, props, {
    fullWidth: true
  }));
};

var ResetPasswordForm = function ResetPasswordForm(_ref2) {
  var recaptchaSiteApiKey = _ref2.recaptchaSiteApiKey,
      theme = _ref2.theme,
      _ref2$redirectTo = _ref2.redirectTo,
      redirectTo = _ref2$redirectTo === void 0 ? "/login" : _ref2$redirectTo;

  var _useSafeSetState = useSafeSetState(false),
      _useSafeSetState2 = _slicedToArray(_useSafeSetState, 2),
      loading = _useSafeSetState2[0],
      setLoading = _useSafeSetState2[1];

  var resetPassword = useResetPassword();
  var translate = useTranslate$2();
  var redirect = useRedirect();
  var notify = useNotify();
  var classes = useStyles$3();

  var validate = function validate(values) {
    var errors = {
      account: undefined
    };

    if (!values.account) {
      errors.account = translate("ra.validation.required");
    }

    return errors;
  };

  var _React$useState = React.useState(Date.now()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      timestamp = _React$useState2[0],
      setTimestamp = _React$useState2[1];

  var submit = function submit(values) {
    setLoading(true);
    resetPassword(values).then(function (_ref3) {
      var data = _ref3.data;
      setLoading(false);
      setTimestamp(Date.now());
      notify(data === null || data === void 0 ? void 0 : data.message, {
        variant: "info"
      });
      redirect(redirectTo);
    }).catch(function (error) {
      setLoading(false);
      setTimestamp(Date.now());
      notify(error === null || error === void 0 ? void 0 : error.message, {
        type: "warning"
      });
    });
  };

  console.info("theme:", theme);
  return /*#__PURE__*/React.createElement(Form$1, {
    onSubmit: submit,
    validate: validate,
    render: function render(_ref4) {
      var handleSubmit = _ref4.handleSubmit;
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit,
        noValidate: true
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.form
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.input
      }, /*#__PURE__*/React.createElement(Field, {
        autoFocus: true,
        id: "account",
        name: "account",
        component: Input,
        label: translate("ra.auth.account"),
        disabled: loading,
        theme: theme
      }), /*#__PURE__*/React.createElement(Field, {
        id: "token",
        key: timestamp,
        name: "token",
        source: "token",
        component: RecaptchaInput,
        siteKey: recaptchaSiteApiKey
      })), /*#__PURE__*/React.createElement(Button$1, {
        variant: "contained",
        type: "submit",
        color: "primary",
        disabled: loading,
        className: classes.button,
        theme: theme
      }, loading && /*#__PURE__*/React.createElement(CircularProgress, {
        theme: theme,
        className: classes.icon,
        size: 18,
        thickness: 2
      }), translate("ra.auth.password_reset.button")), /*#__PURE__*/React.createElement(Button$1, {
        className: classes.button,
        href: "/#/login",
        color: "primary",
        type: "button",
        disabled: loading,
        theme: theme
      }, "\u2190", translate("ra.auth.back_to_login"))));
    }
  });
};

ResetPasswordForm.propTypes = {
  redirectTo: PropTypes.string
};

var _excluded$4 = ["logo", "themeOverride", "children"];
var useStyles$2 = makeStyles(function (theme) {
  return {
    main: {
      overflow: "hidden",
      minHeight: "98vh",
      backgroundImage: "none",
      backgroundColor: theme.palette.background.default,
      "& [class*=MuiAvatar-root]": {
        display: "none",
        visibility: "hidden"
      }
    }
  };
});

var ResetPasswordPage = function ResetPasswordPage(_ref) {
  var logo = _ref.logo,
      themeOverride = _ref.themeOverride,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? /*#__PURE__*/React__default.createElement(ResetPasswordForm, null) : _ref$children,
      props = _objectWithoutProperties(_ref, _excluded$4);

  var themeProp = useRef(themeOverride);

  var _useState = useState(function () {
    return createTheme(themeOverride);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      theme = _useState2[0],
      setTheme = _useState2[1];

  useEffect(function () {
    if (themeProp.current !== themeOverride) {
      themeProp.current = themeOverride;
      setTheme(createTheme(themeOverride));
    }
  }, [themeOverride, themeProp, theme, setTheme]);
  var location = props.location;
  var search = location.search;
  var classes = useStyles$2();
  var action = useMemo$1(function () {
    if (search) {
      var params = new URLSearchParams(search);
      return params.get("action");
    }

    return null;
  }, [search]);
  return /*#__PURE__*/React__default.createElement(ThemeProvider$1, {
    theme: theme
  }, /*#__PURE__*/React__default.createElement(Login, {
    backgroundImage: "",
    theme: theme,
    classes: classes
  }, logo, React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.isValidElement(child) ? /*#__PURE__*/React__default.cloneElement(child, _objectSpread2({
      action: action,
      theme: theme
    }, props)) : child;
  })));
};

ResetPasswordPage.propTypes = {
  action: PropTypes.string,
  logo: PropTypes.element,
  recaptchaSiteApiKey: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

var _excluded$3 = ["staticContext", "children", "themeOverride"];

var SignupPage = function SignupPage(_ref) {
  _ref.staticContext;
      var children = _ref.children,
      themeOverride = _ref.themeOverride,
      props = _objectWithoutProperties(_ref, _excluded$3);

  var themeProp = useRef(themeOverride);

  var _useState = useState(function () {
    return createTheme(themeOverride);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      theme = _useState2[0],
      setTheme = _useState2[1];

  useEffect(function () {
    if (themeProp.current !== themeOverride) {
      themeProp.current = themeOverride;
      setTheme(createTheme(themeOverride));
    }
  }, [themeOverride, themeProp, theme, setTheme]);
  return /*#__PURE__*/React__default.createElement(ThemeProvider$1, {
    theme: theme
  }, React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.isValidElement(child) ? /*#__PURE__*/React__default.cloneElement(child, _objectSpread2({
      theme: theme
    }, props)) : child;
  }), /*#__PURE__*/React__default.createElement(Notification$1, null));
};

var _excluded$2 = ["children"];
var SignupStepperContext = /*#__PURE__*/React__default.createContext({
  activeStep: 0,
  isLastStep: false
});
var SignupStepperProvider = function SignupStepperProvider(_ref) {
  var children = _ref.children;

  var _React$useState = React__default.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeStep = _React$useState2[0],
      setActiveStep = _React$useState2[1];

  var _React$useState3 = React__default.useState(React__default.Children.toArray(children).length === 1),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isLastStep = _React$useState4[0],
      setIsLastStep = _React$useState4[1];

  return /*#__PURE__*/React__default.createElement(SignupStepperContext.Provider, {
    value: {
      activeStep: activeStep,
      isLastStep: isLastStep,
      setActiveStep: setActiveStep,
      setIsLastStep: setIsLastStep
    }
  }, children);
};

var SignupStepper = function SignupStepper(_ref2) {
  var children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded$2);

  var form = useForm();

  var _React$useContext = React__default.useContext(SignupStepperContext),
      activeStep = _React$useContext.activeStep,
      setActiveStep = _React$useContext.setActiveStep,
      setIsLastStep = _React$useContext.setIsLastStep;

  var handleNext = useCallback(function () {
    form.batch(function () {
      var formState = form.getState();
      var fields = Object.keys(formState.visited);
      fields.forEach(function (field) {
        return form.blur(field);
      });
      var stepErrors = fields.map(function (field) {
        return get$1(formState.errors, field, undefined);
      }).filter(function (fieldError) {
        return fieldError !== undefined;
      });

      if (stepErrors.length === 0) {
        setActiveStep(function (prevActiveStep) {
          return prevActiveStep + 1;
        });
        setIsLastStep(activeStep + 1 === children.length - 1);
      }
    });
  }, [form, activeStep, children.length, setActiveStep, setIsLastStep]);
  var handleBack = useCallback(function () {
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep - 1;
    });
    setIsLastStep(false);
  }, [setActiveStep, setIsLastStep]);
  var translate = useTranslate$2();
  var childrenCount = useMemo$1(function () {
    return children.filter(function (c) {
      return c !== undefined;
    });
  }, [children]);
  return /*#__PURE__*/React__default.createElement(Stepper, {
    activeStep: activeStep,
    orientation: "vertical"
  }, React__default.Children.map(children, function (field, index) {
    return /*#__PURE__*/React__default.isValidElement(field) ? /*#__PURE__*/React__default.createElement(Step, {
      key: index
    }, /*#__PURE__*/React__default.createElement(StepLabel, null, field.props.title || field.props.source), /*#__PURE__*/React__default.createElement(StepContent, {
      TransitionProps: {
        unmountOnExit: true
      }
    }, /*#__PURE__*/React__default.cloneElement(field, _objectSpread2({}, props)), childrenCount > 1 && activeStep > 0 && /*#__PURE__*/React__default.createElement(Button$1, {
      disabled: activeStep === 0,
      onClick: handleBack
    }, "\u2190 ", translate("ra.action.back")), childrenCount > 1 && activeStep < children.length - 1 && /*#__PURE__*/React__default.createElement(Button$1, {
      onClick: handleNext
    }, translate("ra.action.next"), " \u2192"))) : undefined;
  }));
};

var useStyles$1 = makeStyles(function (theme) {
  return {
    root: {
      margin: theme.spacing(1),
      textAlign: "center"
    }
  };
});
var setLoggedIn = function setLoggedIn(_ref) {
  var data = _ref.data;
  localStorage.setItem("email", data.email);
  localStorage.setItem("token", data.token);
  localStorage.setItem("roles", JSON.stringify(data.roles));
  localStorage.setItem("username", data.username);
  localStorage.setItem("profile", JSON.stringify(data.profile));
};
var setSignResponse = function setSignResponse(r) {
  return localStorage.setItem("r", r);
};
var getSignResponse = function getSignResponse() {
  return localStorage.getItem("r");
};
var clearSignResponse = function clearSignResponse() {
  return localStorage.removeItem("r");
};

var doAuthentication = function doAuthentication(_ref2) {
  var authenticationUrl = _ref2.authenticationUrl,
      search = _ref2.search;
  return fetch("".concat(authenticationUrl).concat(search), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  }).then(function (response) {
    return response.json();
  }).catch(function (error) {
    return error;
  });
};

var SpidLoginForm = function SpidLoginForm(_ref3) {
  var apiUrl = _ref3.apiUrl,
      search = _ref3.location.search,
      loginUrl = _ref3.loginUrl,
      authenticationUrl = _ref3.authenticationUrl,
      redirectUrl = _ref3.redirectUrl,
      signup = _ref3.signup,
      action = _ref3.action;
  var notify = useNotify$1();
  var classes = useStyles$1();
  var redirect = useRedirect$1();
  var translate = useTranslate$1();

  var _useMemo = useMemo$1(function () {
    return {
      login: loginUrl || "".concat(apiUrl, "/spid/auth?b=client"),
      authenticate: authenticationUrl || "".concat(apiUrl, "/spid/authenticate")
    };
  }, [apiUrl, loginUrl, authenticationUrl]),
      login = _useMemo.login,
      authenticate = _useMemo.authenticate;

  useEffect(function () {
    if (action !== "callback") {
      return;
    }

    var doAuth = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$doAuthenticati, success, data;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return doAuthentication({
                  authenticationUrl: authenticate,
                  search: search
                });

              case 2:
                _yield$doAuthenticati = _context.sent;
                success = _yield$doAuthenticati.success;
                data = _yield$doAuthenticati.data;

                if (!success) {
                  if (signup !== false) {
                    setSignResponse(search);
                    document.location = signup;
                  } else {
                    notify((data === null || data === void 0 ? void 0 : data.message) || "error.login.failed", "error");
                    document.location = "#/login";
                  }
                } else {
                  clearSignResponse();
                  setLoggedIn({
                    data: data
                  });
                  redirect(typeof redirectUrl === "function" ? redirectUrl(data) : redirectUrl);
                  notifyToken(data.token);
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function doAuth() {
        return _ref4.apply(this, arguments);
      };
    }();

    doAuth();
  }, [action, redirectUrl, search, signup, authenticate, redirect, notify]);

  var stopPropagation = function stopPropagation(e) {
    return e.stopPropagation();
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.root
  }, action === "callback" ? /*#__PURE__*/React__default.createElement(CircularProgress, null) : /*#__PURE__*/React__default.createElement(Button$1, {
    onClick: stopPropagation,
    component: "a",
    color: "primary",
    type: "button",
    variant: "contained",
    href: login,
    fullWidth: true
  }, translate("ra.auth.login.spid")));
};

SpidLoginForm.propTypes = {
  apiUrl: PropTypes.string,
  location: PropTypes.object,
  loginUrl: PropTypes.string,
  authenticationUrl: PropTypes.string,
  redirectUrl: PropTypes.string,
  signup: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  action: PropTypes.string
};
SpidLoginForm.defaultProps = {
  signup: false,
  redirectUrl: "/"
};

var _excluded$1 = ["record", "initialValues"];

var SpidSignupAccountStep = function SpidSignupAccountStep(_ref) {
  _ref.record;
      var initialValues = _ref.initialValues,
      props = _objectWithoutProperties(_ref, _excluded$1);

  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TextInput$1, _extends({}, props, {
    source: "profile.name",
    validate: required(),
    fullWidth: true,
    maxLength: 50,
    disabled: get$1(initialValues, "profile.name") !== null
  })), /*#__PURE__*/React__default.createElement(TextInput$1, _extends({}, props, {
    source: "profile.surname",
    validate: required(),
    fullWidth: true,
    maxLength: 50,
    disabled: get$1(initialValues, "profile.surname") !== null
  })), /*#__PURE__*/React__default.createElement(TextInput$1, _extends({}, props, {
    source: "profile.fiscal_code",
    validate: required(),
    fullWidth: true,
    maxLength: 16,
    disabled: true
  })), /*#__PURE__*/React__default.createElement(TextInput$1, _extends({}, props, {
    source: "email",
    maxLength: 255,
    validate: [required(), email()],
    fullWidth: true
  })), /*#__PURE__*/React__default.createElement(DebouncedTextInput, _extends({}, props, {
    source: "profile.birth_place",
    validate: required(),
    fullWidth: true,
    maxLength: 50
  })), /*#__PURE__*/React__default.createElement(DateInput$1, _extends({}, props, {
    source: "profile.birth_date",
    validate: required(),
    disabled: true,
    fullWidth: true
  })), /*#__PURE__*/React__default.createElement(TextInput$1, _extends({}, props, {
    source: "profile.phone",
    maxLength: 30
  })));
};

var _excluded = ["basePath"],
    _excluded2 = ["apiUrl", "loadUrl", "staticContext", "children", "logo", "title", "subTitle", "resource", "recaptchaSiteApiKey"];

var getProfile = function getProfile(_ref) {
  var loadUrl = _ref.loadUrl,
      search = _ref.search;
  return fetch("".concat(loadUrl).concat(search), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  }).then(function (response) {
    return response.json();
  }).catch(function (error) {
    return error;
  });
};

var useStyles = makeStyles(function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.background.default,
      height: "98vh",
      "& .create-page > div": {
        minWidth: "auto",
        maxWidth: "auto"
      }
    }
  };
});

var SignupToolbar = function SignupToolbar(_ref2) {
  _ref2.basePath;
      var props = _objectWithoutProperties(_ref2, _excluded);

  var _useContext = useContext(SignupStepperContext),
      isLastStep = _useContext.isLastStep;

  return /*#__PURE__*/React__default.createElement(Toolbar$3, props, /*#__PURE__*/React__default.createElement(SaveButton, {
    label: "ra.auth.signup",
    disabled: !isLastStep
  }));
};

var SpidSignupForm = function SpidSignupForm(_ref3) {
  var apiUrl = _ref3.apiUrl,
      loadUrl = _ref3.loadUrl;
      _ref3.staticContext;
      var children = _ref3.children,
      logo = _ref3.logo,
      title = _ref3.title,
      subTitle = _ref3.subTitle,
      resource = _ref3.resource,
      recaptchaSiteApiKey = _ref3.recaptchaSiteApiKey,
      props = _objectWithoutProperties(_ref3, _excluded2);

  var _useState = useState(Date.now()),
      _useState2 = _slicedToArray(_useState, 2),
      timestamp = _useState2[0],
      setTimestamp = _useState2[1];

  var classes = useStyles();

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      initialValues = _useState4[0],
      setInitialValues = _useState4[1];

  var redirect = useRedirect$1();
  var search = getSignResponse();
  var translate = useTranslate$1();
  var save = useSaveMutation({
    resource: resource,
    onSuccess: function onSuccess() {
      setTimeout(function () {
        document.location.href = "#/login".concat(search);
        document.location.reload();
      }, 100);
    },
    onError: function onError() {
      setTimestamp(Date.now());
    }
  });

  var _useMemo = useMemo$1(function () {
    return {
      load: loadUrl || "".concat(apiUrl, "/spid/load")
    };
  }, [apiUrl, loadUrl]),
      load = _useMemo.load;

  useEffect(function () {
    var doLoad = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$getProfile, success, data;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!search) {
                  redirect("/login");
                }

                _context.next = 3;
                return getProfile({
                  loadUrl: load,
                  search: search
                });

              case 3:
                _yield$getProfile = _context.sent;
                success = _yield$getProfile.success;
                data = _yield$getProfile.data;

                if (success) {
                  setInitialValues(data);
                } else {
                  redirect("/login");
                  clearSignResponse();
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function doLoad() {
        return _ref4.apply(this, arguments);
      };
    }();

    doLoad();
  }, [search, load, redirect]);
  return /*#__PURE__*/React__default.createElement(SignupStepperProvider, null, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    justifyContent: "center",
    className: classes.root
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    lg: 6,
    md: 6,
    sm: 8,
    xs: 12
  }, logo, /*#__PURE__*/React__default.isValidElement(title) ? title : /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h3",
    gutterBottom: true,
    display: "block",
    color: "textPrimary"
  }, title), subTitle, initialValues == null && /*#__PURE__*/React__default.createElement(CircularProgress, null), initialValues != null && /*#__PURE__*/React__default.createElement(Create$3, _extends({
    basePath: resource,
    resource: resource
  }, props), /*#__PURE__*/React__default.createElement(SimpleForm, {
    save: save,
    initialValues: initialValues,
    toolbar: /*#__PURE__*/React__default.createElement(SignupToolbar, null)
  }, /*#__PURE__*/React__default.createElement(SignupStepper, {
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(SpidSignupAccountStep, {
    title: translate("resources.spid.steps.general"),
    fullWidth: true
  }), React__default.Children.map(children, function (child) {
    return /*#__PURE__*/React__default.isValidElement(child) ? /*#__PURE__*/React__default.cloneElement(child, _objectSpread2({}, props)) : child;
  })), /*#__PURE__*/React__default.createElement(RecaptchaInput, {
    key: timestamp,
    source: "token",
    siteKey: recaptchaSiteApiKey
  }))))));
};

SpidSignupForm.propTypes = {
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  subTitle: PropTypes.element,
  logo: PropTypes.element,
  apiUrl: PropTypes.string,
  loadUrl: PropTypes.string,
  recaptchaSiteApiKey: PropTypes.string.isRequired,
  staticContext: PropTypes.object,
  children: PropTypes.node
};
SpidSignupForm.defaultProps = {
  resource: "spid"
};

var createI18nProvider = function createI18nProvider(_ref) {
  var _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? "en" : _ref$locale,
      languages = _ref.languages;
  return polyglotI18nProvider(function () {
    if (process.env.NODE_ENV !== "production") {
      localStorage.setItem("locale", locale);
    }

    moment.locale(locale);
    return get$1(languages, locale, {});
  }, resolveBrowserLocale());
};

var queued = [];

var putMessage = function putMessage(apiUrl, locale, message) {
  return message != null && message !== "undefined" && message.indexOf("[") === -1 && message.indexOf("]") === -1 && queued.indexOf("".concat(locale, "-").concat(message)) === -1 && queued.push("".concat(locale, "-").concat(message)) && fetch("".concat(apiUrl, "/languages/put-message"), {
    method: "PUT",
    headers: new Headers({
      Accept: "application/json",
      "Content-Type": "application/json"
    }),
    body: JSON.stringify({
      code: locale,
      message: {
        code: message,
        text: message
      }
    })
  });
};

var useI18nCatcher = function useI18nCatcher(_ref) {
  var apiUrl = _ref.apiUrl,
      loading = _ref.loading;
  var locale = useLocale$1();
  React.useMemo(function () {
    if (process.env.NODE_ENV === "production") {
      return;
    }

    if (loading) {
      return;
    }

    var consoleError = console.error;

    console.error = function (message) {
      if (typeof message === "string" && message.indexOf("Missing translation for key: ") >= 0) {
        message = message.replace("Warning: Missing translation for key: ", "");
        message = message.split('"').join("").trim();

        if (message === null || message.indexOf(" ") !== -1 || message.indexOf(".") === -1) {
          return;
        }

        var lc = localStorage.getItem("locale") || locale;
        putMessage(apiUrl, lc, message);
        return;
      }

      consoleError.apply(console, arguments);
    };
  }, [apiUrl, locale, loading]);
  return true;
};

var useI18nLanguages = function useI18nLanguages(_ref) {
  var apiUrl = _ref.apiUrl;

  var _useState = useState({
    loading: true,
    languages: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  useEffect(function () {
    var headers = new Headers();
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
    fetch("".concat(apiUrl, "/languages/load"), {
      headers: headers
    }).then(function (response) {
      return response.json();
    }).then(function (_ref2) {
      var data = _ref2.data;
      return setData({
        loading: false,
        data: data
      });
    });
  }, [apiUrl]);
  return data;
};

var useI18nProvider = function useI18nProvider(_ref) {
  var apiUrl = _ref.apiUrl,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? "en" : _ref$locale,
      _ref$languages = _ref.languages,
      languages = _ref$languages === void 0 ? {} : _ref$languages;
  var memoizedFn = useMemo$1(function () {
    return createI18nProvider({
      apiUrl: apiUrl,
      locale: locale,
      languages: languages
    });
  }, [apiUrl, locale, languages]);
  return memoizedFn;
};

var convertFileToBase64 = function convertFileToBase64(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file.rawFile);

    reader.onload = function () {
      return resolve(reader.result);
    };

    reader.onerror = reject;
  });
};

var convertFile = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", file.rawFile ? convertFileToBase64(file).then(function (convertedFile) {
              return {
                data: convertedFile,
                name: file.rawFile.name,
                size: file.rawFile.size,
                type: file.rawFile.type
              };
            }) : Promise.resolve(file));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function convertFile(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Iterate inside every prop of data and check if contains a property
 * with one of the names of the fileFields, if the property is an array
 * the engine iterate inside the array recurisively and search for files
 * matching the fileFields.
 *
 * @param {Array} data
 * @param {Array<String>} fileFields
 * @returns
 */

var parseFiles = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data, fileFields) {
    var i, field, value, files, file;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            i = 0;

          case 1:
            if (!(i < fileFields.length)) {
              _context.next = 19;
              break;
            }

            field = fileFields[i];
            value = get$1(data, field);

            if (!(value && Array.isArray(value))) {
              _context.next = 11;
              break;
            }

            _context.next = 7;
            return Promise.all(value.map(function (file) {
              return convertFile(file);
            }));

          case 7:
            files = _context.sent;
            data = set(data, field, files);
            _context.next = 16;
            break;

          case 11:
            if (!value) {
              _context.next = 16;
              break;
            }

            _context.next = 14;
            return convertFile(value);

          case 14:
            file = _context.sent;
            data = set(data, field, file);

          case 16:
            i++;
            _context.next = 1;
            break;

          case 19:
            return _context.abrupt("return", Promise.resolve(data));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function parseFiles(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var parse = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data, fileFields) {
    var prop, isProbableFile;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(_typeof(data) === "object" && data !== null)) {
              _context2.next = 29;
              break;
            }

            _context2.t0 = _regeneratorRuntime().keys(data);

          case 2:
            if ((_context2.t1 = _context2.t0()).done) {
              _context2.next = 29;
              break;
            }

            prop = _context2.t1.value;

            if (!data.hasOwnProperty(prop)) {
              _context2.next = 24;
              break;
            }

            isProbableFile = fileFields.indexOf(prop) !== -1;

            if (!isProbableFile) {
              _context2.next = 12;
              break;
            }

            _context2.next = 9;
            return parseFiles(data, [prop]);

          case 9:
            data = _context2.sent;
            _context2.next = 22;
            break;

          case 12:
            if (!Array.isArray(data[prop])) {
              _context2.next = 18;
              break;
            }

            _context2.next = 15;
            return Promise.all(data[prop].map(function (item) {
              return parse(item, fileFields);
            }));

          case 15:
            data[prop] = _context2.sent;
            _context2.next = 22;
            break;

          case 18:
            if (!(_typeof(data[prop]) === "object")) {
              _context2.next = 22;
              break;
            }

            _context2.next = 21;
            return parse(data[prop], fileFields);

          case 21:
            data[prop] = _context2.sent;

          case 22:
            _context2.next = 27;
            break;

          case 24:
            _context2.next = 26;
            return parse(data[prop], fileFields);

          case 26:
            data[prop] = _context2.sent;

          case 27:
            _context2.next = 2;
            break;

          case 29:
            return _context2.abrupt("return", Promise.resolve(data));

          case 30:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function parse(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Return function that will be used, before every POST/PATCH/PUT request,
 * to check if the data contains files and if so, parse them.
 *
 * This function can parse trees of data, so it can be used to parse files.
 *
 * @param {Object} data
 *  Data to parse
 * @param {Array} fileFields
 *  Array of strings with the names of the fields that contain files.
 *
 * @returns {Promise<Object>}
 *  Return input data with files parsed.
 */


var createFilesParser = function createFilesParser() {
  return parse;
};

// Remove unwanted _joinData props from JSON object before submission to the rest service.
var createDataFormatter = function createDataFormatter(data) {
  return Object.keys(data).reduce(function (r, key) {
    return _objectSpread2(_objectSpread2({}, r), {}, _defineProperty({}, key, Array.isArray(data[key]) ? data[key].map(function (item) {
      if (item._joinData === null) {
        return {
          id: item.id
        };
      }

      return item;
    }) : data[key]));
  }, {});
};

var fetchJson = function fetchJson(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return fetch(url, _objectSpread2({}, options)).then(function (response) {
    return response.text().then(function (text) {
      return {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        body: text
      };
    });
  }).then(function (_ref) {
    var status = _ref.status,
        statusText = _ref.statusText,
        headers = _ref.headers,
        body = _ref.body;
    var json;

    try {
      json = JSON.parse(body);
    } catch (e) {// not json, no big deal
    }

    if (status < 200 || status >= 300) {
      var _json, _json$data, _json2, _json2$data;

      return Promise.reject(new HttpError(((_json = json) === null || _json === void 0 ? void 0 : (_json$data = _json.data) === null || _json$data === void 0 ? void 0 : _json$data.message) || statusText, ((_json2 = json) === null || _json2 === void 0 ? void 0 : (_json2$data = _json2.data) === null || _json2$data === void 0 ? void 0 : _json2$data.code) || status, json));
    }

    return Promise.resolve({
      status: status,
      headers: headers,
      body: body,
      json: json
    });
  });
};

var createDataProvider = function createDataProvider(_ref) {
  var apiUrl = _ref.apiUrl,
      _ref$fileFields = _ref.fileFields,
      fileFields = _ref$fileFields === void 0 ? [] : _ref$fileFields,
      _ref$filesParser = _ref.filesParser,
      filesParser = _ref$filesParser === void 0 ? createFilesParser() : _ref$filesParser,
      _ref$prepareData = _ref.prepareData,
      prepareData = _ref$prepareData === void 0 ? function (data) {
    return createDataFormatter(data);
  } : _ref$prepareData;
  return {
    getInfo: function getInfo(resource, params) {
      var url = "".concat(apiUrl, "/").concat(resource, "/info?").concat(stringify(params));
      var options = {
        headers: getHeaders()
      };
      return fetchJson(url, options).then(function (_ref2) {
        var json = _ref2.json;
        return {
          data: json.data
        };
      });
    },
    getBadges: function getBadges() {
      var url = "".concat(apiUrl, "/stats/badges");
      var options = {
        headers: getHeaders()
      };
      return fetchJson(url, options).then(function (_ref3) {
        var json = _ref3.json;
        return {
          data: json
        };
      });
    },
    getList: function getList(resource, params) {
      var _params$pagination = params.pagination,
          page = _params$pagination.page,
          perPage = _params$pagination.perPage;
      var _params$sort = params.sort,
          field = _params$sort.field,
          order = _params$sort.order;
      var filter = Object.keys(params.filter || {}).reduce(function (f, filterName) {
        return _objectSpread2(_objectSpread2({}, f), {}, _defineProperty({}, filterName, params.filter[filterName] instanceof Array ? params.filter[filterName].join(",") : params.filter[filterName]));
      }, {});

      var query = _objectSpread2({
        sort: field,
        direction: order,
        page: page,
        limit: perPage
      }, filter);

      var url = "".concat(apiUrl, "/").concat(resource, "?").concat(stringify(query));
      var options = {
        headers: getHeaders()
      };
      return fetchJson(url, options).then(function (_ref4) {
        var json = _ref4.json;
        return {
          data: json.data,
          total: parseInt(json.pagination.count, 10)
        };
      });
    },
    getOne: function getOne(resource, params) {
      var url = "".concat(apiUrl, "/").concat(resource) + (params.id ? "/".concat(params.id) : "");
      var options = {
        headers: getHeaders()
      };
      return fetchJson(url, options).then(function (_ref5) {
        var json = _ref5.json;
        return {
          data: json.data
        };
      });
    },
    getMany: function getMany(resource, params) {
      var query = {
        ids: params.ids.map(function (id) {
          return id.id ? id.id : id;
        }).join(",")
      };
      var url = "".concat(apiUrl, "/").concat(resource, "?").concat(stringify(query));
      var options = {
        headers: getHeaders()
      };
      return fetchJson(url, options).then(function (_ref6) {
        var json = _ref6.json;
        return {
          data: json.data,
          total: parseInt(json.pagination.count, 10)
        };
      });
    },
    getManyReference: function getManyReference(resource, params) {
      var _params$pagination2 = params.pagination,
          page = _params$pagination2.page,
          perPage = _params$pagination2.perPage;
      var _params$sort2 = params.sort,
          field = _params$sort2.field,
          order = _params$sort2.order;
      var filter = Object.keys(params.filter || {}).reduce(function (f, filterName) {
        return _objectSpread2(_objectSpread2({}, f), {}, _defineProperty({}, filterName, params.filter[filterName] instanceof Array ? params.filter[filterName].join(",") : params.filter[filterName]));
      }, {});

      var query = _objectSpread2(_defineProperty({
        sort: field,
        direction: order,
        page: page,
        limit: perPage
      }, params.target, params.id), filter);

      var url = "".concat(apiUrl, "/").concat(resource, "?").concat(stringify(query));
      var options = {
        headers: getHeaders()
      };
      return fetchJson(url, options).then(function (_ref7) {
        var json = _ref7.json;
        return {
          data: json.data,
          total: parseInt(json.pagination.count, 10)
        };
      });
    },
    create: function create(resource, params) {
      return filesParser(params.data, fileFields).then(function (data) {
        var url = "".concat(apiUrl, "/").concat(resource);
        var options = {
          method: "POST",
          body: JSON.stringify(prepareData(data, resource, params)),
          headers: getHeaders()
        };
        return fetchJson(url, options).then(function (_ref8) {
          var json = _ref8.json;
          return {
            data: _objectSpread2(_objectSpread2({}, json.data || params.data), {}, {
              id: json.data.id
            })
          };
        });
      });
    },
    update: function update(resource, params) {
      return filesParser(params.data, fileFields).then(function (data) {
        var id = data && data.pk ? data.pk : params.id;
        var url = "".concat(apiUrl, "/").concat(resource) + (id ? "/".concat(id) : "");
        var options = {
          method: "PUT",
          body: JSON.stringify(prepareData(data)),
          headers: getHeaders()
        };
        return fetchJson(url, options).then(function (_ref9) {
          var json = _ref9.json;
          return {
            data: _objectSpread2({
              id: data.pk
            }, json.data)
          };
        });
      });
    },
    updateMany: function updateMany(resource, params) {
      return Promise.all(params.ids.map(function (id) {
        return fetchJson("".concat(apiUrl, "/").concat(resource, "/").concat(id), {
          method: "PUT",
          body: JSON.stringify(params.data),
          headers: getHeaders()
        });
      })).then(function (responses) {
        return {
          data: responses.map(function (response) {
            return response.json;
          })
        };
      });
    },
    delete: function _delete(resource, params) {
      var url = "".concat(apiUrl, "/").concat(resource, "/").concat(params.id);
      var options = {
        method: "DELETE",
        headers: getHeaders()
      };
      return fetchJson(url, options).then(function (_ref10) {
        var json = _ref10.json;
        return {
          data: json
        };
      });
    },
    deleteMany: function deleteMany(resource, params) {
      return Promise.all(params.ids.map(function (id) {
        return fetch("".concat(apiUrl, "/").concat(resource, "/").concat(id), {
          method: "DELETE",
          headers: getHeaders()
        }).then(function (response) {
          return response.json();
        });
      })).then(function (responses) {
        var errors = responses.filter(function (r) {
          return r.data && r.data.code && (r.data.code === 409 || r.data.code === 403);
        });

        if (errors.length > 0) {
          return Promise.reject(errors.map(function (e) {
            return e.data.message;
          }).join("\n"));
        }

        return {
          data: responses.map(function (_ref11) {
            var json = _ref11.json;
            return {
              data: json
            };
          })
        };
      });
    },
    post: function post(resource, params) {
      var url = "".concat(apiUrl, "/").concat(resource);
      var options = {
        body: JSON.stringify(params),
        method: "POST",
        headers: getHeaders()
      };
      return fetchJson(url, options).then(function (_ref12) {
        var json = _ref12.json;
        return {
          data: json
        };
      });
    },
    get: function get(resource, params) {
      var queryString = stringify(params);
      var url = "".concat(apiUrl, "/").concat(resource, "?").concat(queryString);
      var options = {
        method: "GET",
        headers: getHeaders()
      };
      return fetchJson(url, options).then(function (_ref13) {
        var json = _ref13.json;
        return {
          data: json
        };
      });
    },
    getTransactions: function getTransactions(resource, params) {
      var url = "".concat(apiUrl, "/workflow/transactions/").concat(resource, "/").concat(params.id);
      return fetchJson(url, {
        headers: getHeaders()
      }).then(function (_ref14) {
        var json = _ref14.json;
        return {
          data: json.data
        };
      });
    }
  };
};

var useAuthProvider = function useAuthProvider(_ref) {
  var apiUrl = _ref.apiUrl;
  var memoizedFn = useMemo$1(function () {
    return createAuthProvider({
      apiUrl: apiUrl
    });
  }, [apiUrl]);
  return memoizedFn;
};

/**
 * Create and return a data provider.
 *
 * @param {Object} props
 * @param {String} props.apiUrl
 * @param {Array} props.fileFields
 * @param {Function} props.filesParser Function that parse files inside data.
 * @returns
 */

var useDataProvider = function useDataProvider(_ref) {
  var apiUrl = _ref.apiUrl,
      fileFields = _ref.fileFields,
      _ref$filesParser = _ref.filesParser,
      filesParser = _ref$filesParser === void 0 ? createFilesParser() : _ref$filesParser;
  var memoizedFn = useMemo$1(function () {
    return createDataProvider({
      apiUrl: apiUrl,
      fileFields: fileFields,
      filesParser: filesParser
    });
  }, [apiUrl, fileFields, filesParser]);
  return memoizedFn;
};

var useDataFormatter = function useDataFormatter() {
  var memoizedFn = useMemo$1(function () {
    return createDataFormatter();
  }, []);
  return memoizedFn;
};

function beep() {
  var snd = new Audio("data:audio/wav;base64,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");
  snd.play();
}

var useTabVisibiliy = function useTabVisibiliy(tab) {
  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  useEffect(function () {
    var args = pathname.split("/");

    if (tab === 0 && args.length === 3 || args.length === 4 && pathname.endsWith("/".concat(tab))) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [pathname, tab]);
  return visible;
};

export { Alert$1 as Alert, AlertTitle$1 as AlertTitle, AppBar, Autocomplete$1 as Autocomplete, AutocompleteArrayInput, AutocompleteInput, BackButton, Badge, BaseProfileForm, Brand, ChipArrayField, Component, CoverField, CrudContext, CrudProvider, CrudResource, Datagrid, DateAgoField, DateRangeInput, DateTimeInput, DebouncedDateInput, DebouncedNumberInput, DebouncedTextInput, DeleteWithConfirmButton, EditButton, ExportButton, ExportToButton, FormTab, Group, GroupItem, GroupTitle, ImageInput, ImpersonateUserButton, Input$1 as Input, LanguageMessageInput, Layout, ListEmpty, LocalLoginForm, LoginPage, LongTextField, MarkAsReadedButton, MarkAsUnreadedButton, MediaField, MediaInput, Menu$1 as Menu, MenuGroup, MenuItem, NotificationField, NotificationList, Pagination, ProfileForm, ProfilePage, ProgressField, RecordInput, ReferenceAutocompleteInput$1 as ReferenceAutocompleteInput, ReferenceCheckboxGroupInput, ReferenceListField, ReferenceAutocompleteInput as ReferenceSelectInput, ResetPasswordButton, ResetPasswordLinkButton, ResetPasswordPage, Sidebar, SignupPage, SignupStepper, SlugInput, SpidLoginForm, SpidSignupForm, StateArrayInput, StateButton$1 as StateButton, StateButtonMenu, StateCollectionInput, StateField, StateInfoField, StateInput, TimeInput, Toolbar, TransactionLogsField, TransactionNotesField, TransactionNotesInput, TransactionNotesIsPrivateInput, Unprop, UserMenu, UserMenuItem, ValidationItem, ValidationSummary, WorkflowContext, WorkflowProvider, beep, convertFile, createAuthProvider, createDataFormatter, createDataProvider, createErrorMapper, createFilesParser, createI18nProvider, createManyFormatter, createManyParser, getHeaders, getToken, useAuthProvider, useBackUrl, useCrud, useDataFormatter, useDataProvider, useDebounce, useFieldLabel, useI18nCatcher, useI18nLanguages, useI18nProvider, useMakeRedirect, useManyFormatter, useManyParser, useRoles, useSaveMutation, useTabVisibiliy as useTabVisibility, useToken, useWorkflow, useWorkflowInput };
